import Filter from "../../../helpers/Filter";

const getFormats = () => {
    const settings = Filter.getSettingByKey('currencyFormat');
    const decimalPlace = settings['decimalPlace'] || 2;
    const decimalSeparator = settings['decimalSeparator'] || ".";
    const thousandSeparator = settings['thousandSeparator'] || ",";

    return {
        decimalPlaces: decimalPlace,
        name: "",
        thousandsSeparator: thousandSeparator,
        decimalSeparator: decimalSeparator
    }
}

const configs = {
    receipt_bills: [
        {
            "name": "Default",
            "configuation": {
                "slice": {
                    "reportFilters": [
                        {
                            "uniqueName": "FilterType",
                            "filter": {
                                "members": [
                                    "filtertype.[individual bill summary]"
                                ]
                            },
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Controller Name"
                        },
                        {
                            "uniqueName": "Status",
                            "filter": {
                                "members": [
                                    "status.[paid]"
                                ]
                            }
                        }
                    ],
                    "rows": [
                        {
                            "uniqueName": "Order No",
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Date Time",
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Paid Type",
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Note",
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax1", "Tax 1 (%)", true),
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2 (%)", true),
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Discount(%)",
                            "sort": "unsorted"
                        }
                    ],
                    "columns": [
                        {
                            "uniqueName": "Sale Type",
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "[Measures]"
                        }
                    ],
                    "measures": [
                        {
                            "uniqueName": "Sales",
                            "aggregation": "sum",
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("netTaxBeforeDiscount", "Net Tax Before Discount", false),
                            "aggregation": "sum",
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Discount",
                            "aggregation": "sum",
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Net Sales",
                            "aggregation": "sum",
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("taxBeforeDiscount", "Tax Before Discount", false),
                            "aggregation": "sum",
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax1", "Tax 1", false),
                            "aggregation": "sum",
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2", false),
                            "aggregation": "sum",
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Gross",
                            "aggregation": "sum",
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Over Pay(+)",
                            "aggregation": "sum",
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Short Pay(-)",
                            "aggregation": "sum",
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Received",
                            "formula": "sum(\"Received\")",
                            "caption": "Received",
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Controller ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Controller Name",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Sale Type",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Date Time",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Order No",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Status",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Table",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Pax",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Total Dish(es)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Cancel Dish(es)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Waiter",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Cashier",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Agent",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Paid On",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("taxBeforeDiscount", "Tax Before Discount", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Paid Type",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Discount(%)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Sub Total",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax1", "Tax 1 (%)", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2 (%)", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Received-v1",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Note-v1",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Note",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Split No.",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "FilterType",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Gross (Exclude  Tax)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Received-v1 (Exclude  Tax)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Received (Exclude  Tax)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Table/Bill",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Short Pay(-) -v1",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Over Pay(+) -v1",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Day of Week",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Date(Days)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Date(Month)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Date(Year)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Date(Week)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Hour of Day",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Block of 30 minutes",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Date(MM D, YYYY)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Start Time",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "End Time",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Report No.",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Meal Time",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Quarter",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Cash",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Pineapple",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        }
                    ],
                },
                "options": {
                    "grid": {
                        "type": "classic"
                    },
                    "viewType": "grid"
                },
                "formats": [
                    {
                        "name": "-10ir2s6itv0ega"
                    },
                    getFormats(),
                ]
            }
        },
        {
            "name": "Net Sales",
            "configuation": {
                "slice": {
                    "reportFilters": [
                        {
                            "uniqueName": "FilterType",
                            "filter": {
                                "members": [
                                    "filtertype.[individual bill summary]"
                                ]
                            },
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Controller Name"
                        },
                        {
                            "uniqueName": "Status",
                            "filter": {
                                "members": [
                                    "status.[paid]"
                                ]
                            },
                            "sort": "unsorted"
                        }
                    ],
                    "rows": [
                        {
                            "uniqueName": "Date(Week)",
                            "sort": "unsorted"
                        }
                    ],
                    "columns": [
                        {
                            "uniqueName": "Sale Type",
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "[Measures]"
                        }
                    ],
                    "measures": [
                        {
                            "uniqueName": "Net Sales",
                            "aggregation": "sum",
                            "format": "-awt37oklqxh8v"
                        },
                        {
                            "uniqueName": "Pax",
                            "formula": "sum(\"Pax\")",
                            "caption": "Pax",
                            "grandTotalCaption": "Sum of Pax",
                            "format": "-awt37oklqxh8v"
                        },
                        {
                            "uniqueName": "Avg Net Sales / Pax",
                            "formula": "if(sum(\"Net Sales\")>0,sum(\"Net Sales\") / sum(\"Pax\"),0)",
                            "caption": "Avg Net Sales / Pax",
                            "format": "-awt37oklqxh8v"
                        },
                        {
                            "uniqueName": "Bill ",
                            "formula": "Count(\"Order No\")",
                            "caption": "Bill ",
                            "format": "-awt37oklqxh8v"
                        },
                        {
                            "uniqueName": "Avg Net Sales / Bill - 2",
                            "formula": "if(sum(\"Net Sales\")>0,sum(\"Net Sales\") / Count(\"Order No\"),0)",
                            "caption": "Avg Net Sales / Bill",
                            "format": "-awt37oklqxh8v"
                        },
                        {
                            "uniqueName": "Controller ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-awt37oklqxh8v",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Controller Name",
                            "aggregation": "count",
                            "active": false,
                            "format": "-awt37oklqxh8v",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Sale Type",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-awt37oklqxh8v"
                        },
                        {
                            "uniqueName": "Date Time",
                            "aggregation": "count",
                            "active": false,
                            "format": "-awt37oklqxh8v",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Order No",
                            "aggregation": "count",
                            "active": false,
                            "format": "-awt37oklqxh8v"
                        },
                        {
                            "uniqueName": "Status",
                            "aggregation": "count",
                            "active": false,
                            "format": "-awt37oklqxh8v",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Table",
                            "aggregation": "count",
                            "active": false,
                            "format": "-awt37oklqxh8v",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Total Dish(es)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-awt37oklqxh8v"
                        },
                        {
                            "uniqueName": "Cancel Dish(es)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-awt37oklqxh8v"
                        },
                        {
                            "uniqueName": "Waiter",
                            "aggregation": "count",
                            "active": false,
                            "format": "-awt37oklqxh8v",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Cashier",
                            "aggregation": "count",
                            "active": false,
                            "format": "-awt37oklqxh8v",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Agent",
                            "aggregation": "count",
                            "active": false,
                            "format": "-awt37oklqxh8v",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Paid On",
                            "aggregation": "count",
                            "active": false,
                            "format": "-awt37oklqxh8v",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Sales",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-awt37oklqxh8v"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("taxBeforeDiscount", "Tax Before Discount", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-awt37oklqxh8v"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("netTaxBeforeDiscount", "Net Tax Before Discount", false),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-awt37oklqxh8v"
                        },
                        {
                            "uniqueName": "Paid Type",
                            "aggregation": "count",
                            "active": false,
                            "format": "-awt37oklqxh8v",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Discount(%)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-awt37oklqxh8v"
                        },
                        {
                            "uniqueName": "Discount",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-awt37oklqxh8v"
                        },
                        {
                            "uniqueName": "Sub Total",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-awt37oklqxh8v"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("taxBeforeDiscount", "Tax Before Discount", false),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-awt37oklqxh8v"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax1", "Tax 1 (%)", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-awt37oklqxh8v"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax1", "Tax 1", false),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-awt37oklqxh8v"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2 (%)", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-awt37oklqxh8v"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2", false),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-awt37oklqxh8v"
                        },
                        {
                            "uniqueName": "Gross",
                            "formula": "sum(\"Gross\")",
                            "caption": "Gross",
                            "active": false,
                            "format": "-awt37oklqxh8v"
                        },
                        {
                            "uniqueName": "Received-v1",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-awt37oklqxh8v"
                        },
                        {
                            "uniqueName": "Note-v1",
                            "aggregation": "count",
                            "active": false,
                            "format": "-awt37oklqxh8v",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Received",
                            "formula": "sum(\"Received\")",
                            "caption": "Sum of Received",
                            "active": false,
                            "format": "-awt37oklqxh8v"
                        },
                        {
                            "uniqueName": "Note",
                            "aggregation": "count",
                            "active": false,
                            "format": "-awt37oklqxh8v",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Split No.",
                            "aggregation": "count",
                            "active": false,
                            "format": "-awt37oklqxh8v",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "FilterType",
                            "aggregation": "count",
                            "active": false,
                            "format": "-awt37oklqxh8v",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Gross (Exclude  Tax)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-awt37oklqxh8v"
                        },
                        {
                            "uniqueName": "Received-v1 (Exclude  Tax)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-awt37oklqxh8v"
                        },
                        {
                            "uniqueName": "Received (Exclude  Tax)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-awt37oklqxh8v"
                        },
                        {
                            "uniqueName": "Table/Bill",
                            "formula": "sum(\"Table/Bill\")",
                            "caption": "Table/Bill",
                            "active": false,
                            "format": "-awt37oklqxh8v"
                        },
                        {
                            "uniqueName": "Short Pay(-) -v1",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-awt37oklqxh8v"
                        },
                        {
                            "uniqueName": "Over Pay(+) -v1",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-awt37oklqxh8v"
                        },
                        {
                            "uniqueName": "Short Pay(-)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-awt37oklqxh8v"
                        },
                        {
                            "uniqueName": "Over Pay(+)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-awt37oklqxh8v"
                        },
                        {
                            "uniqueName": "Day of Week",
                            "aggregation": "count",
                            "active": false,
                            "format": "-awt37oklqxh8v",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Date(Days)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-awt37oklqxh8v"
                        },
                        {
                            "uniqueName": "Date(Month)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-awt37oklqxh8v",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Date(Year)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-awt37oklqxh8v"
                        },
                        {
                            "uniqueName": "Date(Week)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-awt37oklqxh8v"
                        },
                        {
                            "uniqueName": "Hour of Day",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-awt37oklqxh8v"
                        },
                        {
                            "uniqueName": "Block of 30 minutes",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-awt37oklqxh8v"
                        },
                        {
                            "uniqueName": "Date(MM D, YYYY)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-awt37oklqxh8v",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Start Time",
                            "aggregation": "count",
                            "active": false,
                            "format": "-awt37oklqxh8v",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "End Time",
                            "aggregation": "count",
                            "active": false,
                            "format": "-awt37oklqxh8v",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Report No.",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-awt37oklqxh8v"
                        },
                        {
                            "uniqueName": "Meal Time",
                            "aggregation": "count",
                            "active": false,
                            "format": "-awt37oklqxh8v",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Quarter",
                            "aggregation": "count",
                            "active": false,
                            "format": "-awt37oklqxh8v",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Cash",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-awt37oklqxh8v"
                        },
                        {
                            "uniqueName": "Pineapple",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-awt37oklqxh8v"
                        },
                        {
                            "uniqueName": "Avg (Pax)",
                            "formula": "sum(\"Gross\") / sum(\"Pax\")",
                            "caption": "Avg (Pax)",
                            "active": false,
                            "format": "-awt37oklqxh8v"
                        },
                        {
                            "uniqueName": "Avg (Bill)",
                            "formula": "sum(\"Gross\") / sum(\"Table/Bill\")",
                            "caption": "Avg (Bill)",
                            "active": false,
                            "format": "-awt37oklqxh8v"
                        },
                        {
                            "uniqueName": "Avg Net Sales / Bill",
                            "formula": "sum(\"Net Sales\")",
                            "caption": "Avg Net Sales / Bill",
                            "active": false,
                            "format": "-awt37oklqxh8v"
                        }
                    ]
                },
                "options": {
                    "grid": {
                        "type": "classic"
                    },
                    "viewType": "grid"
                },
                "formats": [
                    {
                        "name": "-awt37oklqxh8v"
                    },
                    getFormats(),
                ]
            }
        },
        {
            "name": " Individual Bill",
            "configuation": {
                "slice": {
                    "reportFilters": [
                        {
                            "uniqueName": "FilterType",
                            "filter": {
                                "members": [
                                    "filtertype.[individual bill summary]"
                                ]
                            },
                            "sort": "unsorted"
                        }
                    ],
                    "rows": [
                        {
                            "uniqueName": "Controller Name",
                            "sort": "asc"
                        },
                        {
                            "uniqueName": "Date Time",
                            "sort": "asc"
                        },
                        {
                            "uniqueName": "Order No",
                            "sort": "asc"
                        },
                        {
                            "uniqueName": "Membership",
                            "sort": "asc"
                        },
                        {
                            "uniqueName": "Cashier",
                            "sort": "asc"
                        },
                        {
                            "uniqueName": "Agent",
                            "sort": "asc"
                        },
                        {
                            "uniqueName": "Table",
                            "sort": "asc"
                        },
                        {
                            "uniqueName": "Pax",
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Total Dish(es)",
                            "sort": "asc"
                        },
                        {
                            "uniqueName": "Cancel Dish(es)",
                            "sort": "asc"
                        },
                        {
                            "uniqueName": "Sales",
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("taxBeforeDiscount", "Tax Before Discount", false),
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Discount(%)",
                            "sort": "asc"
                        },
                        {
                            "uniqueName": "Discount",
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("netTaxBeforeDiscount", "Net Tax Before Discount", false),
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Net Sales",
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax1", "Tax 1 (%)", true),
                            "sort": "asc"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax1", "Tax 1", false),
                            "sort": "asc"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2 (%)", true),
                            "sort": "asc"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2", false),
                            "sort": "asc"
                        },
                        {
                            "uniqueName": "Gross",
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Over Pay(+)",
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Short Pay(-)",
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Paid Type",
                            "sort": "asc"
                        },
                        {
                            "uniqueName": "Note",
                            "sort": "asc"
                        },
                        {
                            "uniqueName": "Discount Note",
                            "sort": "asc"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("taxBeforeDiscount", "Tax Before Discount", true),
                            "sort": "asc"
                        },
                        {
                            "uniqueName": "Paid On",
                            "sort": "asc"
                        },
                        {
                            "uniqueName": "Waiter",
                            "sort": "asc"
                        },
                        {
                            "uniqueName": "End Time",
                            "sort": "asc"
                        },
                        {
                            "uniqueName": "Sub Total",
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Status",
                            "sort": "asc"
                        }
                    ],
                    "columns": [
                        {
                            "uniqueName": "Sale Type",
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "[Measures]"
                        }
                    ],
                    "measures": [
                        {
                            "uniqueName": "Received",
                            "formula": "sum(\"Received\")",
                            "caption": "Sum of Received",
                            "format": "-nnptxfsxwg432"
                        },
                        {
                            "uniqueName": "Controller ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-1bje4wlq3xvb3r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Controller Name",
                            "aggregation": "count",
                            "active": false,
                            "format": "-1bje4wlq3xvb3r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Sale Type",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-1bje4wlq3xvb3r"
                        },
                        {
                            "uniqueName": "Date Time",
                            "aggregation": "count",
                            "active": false,
                            "format": "-1bje4wlq3xvb3r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Order No",
                            "aggregation": "count",
                            "active": false,
                            "format": "-1bje4wlq3xvb3r"
                        },
                        {
                            "uniqueName": "Status",
                            "aggregation": "count",
                            "active": false,
                            "format": "-1bje4wlq3xvb3r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Table",
                            "aggregation": "count",
                            "active": false,
                            "format": "-1bje4wlq3xvb3r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Pax",
                            "formula": "sum(\"Pax\")",
                            "caption": "Pax",
                            "grandTotalCaption": "Sum of Pax",
                            "active": false,
                            "format": "-1bje4wlq3xvb3r"
                        },
                        {
                            "uniqueName": "Total Dish(es)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-1bje4wlq3xvb3r"
                        },
                        {
                            "uniqueName": "Cancel Dish(es)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-1bje4wlq3xvb3r"
                        },
                        {
                            "uniqueName": "Waiter",
                            "aggregation": "count",
                            "active": false,
                            "format": "-1bje4wlq3xvb3r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Cashier",
                            "aggregation": "count",
                            "active": false,
                            "format": "-1bje4wlq3xvb3r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Agent",
                            "aggregation": "count",
                            "active": false,
                            "format": "-1bje4wlq3xvb3r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Paid On",
                            "aggregation": "count",
                            "active": false,
                            "format": "-1bje4wlq3xvb3r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Sales",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-1bje4wlq3xvb3r"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("taxBeforeDiscount", "Tax Before Discount", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-1bje4wlq3xvb3r"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("netTaxBeforeDiscount", "Net Tax Before Discount", false),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-1bje4wlq3xvb3r"
                        },
                        {
                            "uniqueName": "Paid Type",
                            "aggregation": "count",
                            "active": false,
                            "format": "-1bje4wlq3xvb3r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Discount(%)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-1bje4wlq3xvb3r"
                        },
                        {
                            "uniqueName": "Discount",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-1bje4wlq3xvb3r"
                        },
                        {
                            "uniqueName": "Sub Total",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-1bje4wlq3xvb3r"
                        },
                        {
                            "uniqueName": "Net Sales",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-1bje4wlq3xvb3r"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("taxBeforeDiscount", "Tax Before Discount", false),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-1bje4wlq3xvb3r"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax1", "Tax 1 (%)", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-1bje4wlq3xvb3r"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax1", "Tax 1", false),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-1bje4wlq3xvb3r"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2 (%)", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-1bje4wlq3xvb3r"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2", false),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-1bje4wlq3xvb3r"
                        },
                        {
                            "uniqueName": "Gross",
                            "formula": "sum(\"Gross\")",
                            "caption": "Gross",
                            "active": false,
                            "format": "-1bje4wlq3xvb3r"
                        },
                        {
                            "uniqueName": "Received-v1",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-1bje4wlq3xvb3r"
                        },
                        {
                            "uniqueName": "Note-v1",
                            "aggregation": "count",
                            "active": false,
                            "format": "-1bje4wlq3xvb3r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Note",
                            "aggregation": "count",
                            "active": false,
                            "format": "-1bje4wlq3xvb3r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Split No.",
                            "aggregation": "count",
                            "active": false,
                            "format": "-1bje4wlq3xvb3r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "FilterType",
                            "aggregation": "count",
                            "active": false,
                            "format": "-1bje4wlq3xvb3r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Gross (Exclude  Tax)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-1bje4wlq3xvb3r"
                        },
                        {
                            "uniqueName": "Received-v1 (Exclude  Tax)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-1bje4wlq3xvb3r"
                        },
                        {
                            "uniqueName": "Received (Exclude  Tax)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-1bje4wlq3xvb3r"
                        },
                        {
                            "uniqueName": "Table/Bill",
                            "formula": "sum(\"Table/Bill\")",
                            "caption": "Table/Bill",
                            "active": false,
                            "format": "-1bje4wlq3xvb3r"
                        },
                        {
                            "uniqueName": "Short Pay(-) -v1",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-1bje4wlq3xvb3r"
                        },
                        {
                            "uniqueName": "Over Pay(+) -v1",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-1bje4wlq3xvb3r"
                        },
                        {
                            "uniqueName": "Short Pay(-)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-1bje4wlq3xvb3r"
                        },
                        {
                            "uniqueName": "Over Pay(+)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-1bje4wlq3xvb3r"
                        },
                        {
                            "uniqueName": "Day of Week",
                            "aggregation": "count",
                            "active": false,
                            "format": "-1bje4wlq3xvb3r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Date(Days)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-1bje4wlq3xvb3r"
                        },
                        {
                            "uniqueName": "Date(Month)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-1bje4wlq3xvb3r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Date(Year)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-1bje4wlq3xvb3r"
                        },
                        {
                            "uniqueName": "Date(Week)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-1bje4wlq3xvb3r"
                        },
                        {
                            "uniqueName": "Hour of Day",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-1bje4wlq3xvb3r"
                        },
                        {
                            "uniqueName": "Block of 30 minutes",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-1bje4wlq3xvb3r"
                        },
                        {
                            "uniqueName": "Date(MM D, YYYY)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-1bje4wlq3xvb3r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Start Time",
                            "aggregation": "count",
                            "active": false,
                            "format": "-1bje4wlq3xvb3r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "End Time",
                            "aggregation": "count",
                            "active": false,
                            "format": "-1bje4wlq3xvb3r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Report No.",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-1bje4wlq3xvb3r"
                        },
                        {
                            "uniqueName": "Meal Time",
                            "aggregation": "count",
                            "active": false,
                            "format": "-1bje4wlq3xvb3r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Quarter",
                            "aggregation": "count",
                            "active": false,
                            "format": "-1bje4wlq3xvb3r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Cash",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-1bje4wlq3xvb3r"
                        },
                        {
                            "uniqueName": "Pineapple",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-1bje4wlq3xvb3r"
                        },
                        {
                            "uniqueName": "Avg Net Sales / Pax",
                            "formula": "if(sum(\"Net Sales\")>0,sum(\"Net Sales\") / sum(\"Pax\"),0)",
                            "caption": "Avg Net Sales / Pax",
                            "active": false,
                            "format": "-1bje4wlq3xvb3r"
                        },
                        {
                            "uniqueName": "Bill ",
                            "formula": "Count(\"Order No\")",
                            "caption": "Bill ",
                            "active": false,
                            "format": "-1bje4wlq3xvb3r"
                        },
                        {
                            "uniqueName": "Avg Net Sales / Bill - 2",
                            "formula": "if(sum(\"Net Sales\")>0,sum(\"Net Sales\") / Count(\"Order No\"),0)",
                            "caption": "Avg Net Sales / Bill",
                            "active": false,
                            "format": "-1bje4wlq3xvb3r"
                        },
                        {
                            "uniqueName": "Avg (Pax)",
                            "formula": "sum(\"Gross\") / sum(\"Pax\")",
                            "caption": "Avg (Pax)",
                            "active": false,
                            "format": "-1bje4wlq3xvb3r"
                        },
                        {
                            "uniqueName": "Avg (Bill)",
                            "formula": "sum(\"Gross\") / sum(\"Table/Bill\")",
                            "caption": "Avg (Bill)",
                            "active": false,
                            "format": "-1bje4wlq3xvb3r"
                        },
                        {
                            "uniqueName": "Avg Net Sales / Bill",
                            "formula": "sum(\"Net Sales\")",
                            "caption": "Avg Net Sales / Bill",
                            "active": false,
                            "format": "-1bje4wlq3xvb3r"
                        }
                    ],
                    "flatOrder": [
                        "Controller Name",
                        "Order No",
                        "Date Time",
                        "Status",
                        "Waiter",
                        "Paid On",
                        "Cashier",
                        "Agent",
                        "Table",
                        "Pax",
                        "Total Dish(es)",
                        "Cancel Dish(es)",
                        "Sale Type",
                        "Sub Total",
                        "Sales",
                        Filter.changeToNameSettings("taxBeforeDiscount", "Tax Before Discount", true),
                        Filter.changeToNameSettings("netTaxBeforeDiscount", "Net Tax Before Discount", false),
                        "Discount(%)",
                        "Discount",
                        "Net Sales",
                        Filter.changeToNameSettings("taxBeforeDiscount", "Tax Before Discount", false),
                        Filter.changeToNameSettings("tax1", "Tax 1 (%)", true),
                        Filter.changeToNameSettings("tax1", "Tax 1", false),
                        Filter.changeToNameSettings("tax2", "Tax 2 (%)", true),
                        Filter.changeToNameSettings("tax2", "Tax 2", false),
                        "Gross",
                        "Over Pay(+)",
                        "Short Pay(-)",
                        "Paid Type",
                        "Note",
                        "Received",
                        "FilterType",
                        "End Time"
                    ]
                },
                "options": {
                    "grid": {
                        "type": "flat",
                    },
                    "viewType": "grid"
                },
                "formats": [
                    {
                        "name": "-nnptxfsxwg432"
                    },
                    getFormats(),
                ]
            }
        },
        {
            "name": "Payment Type",
            "configuation": {
                "slice": {
                    "reportFilters": [
                        {
                            "uniqueName": "FilterType",
                            "filter": {
                                "members": [
                                    "filtertype.[payment type summary]"
                                ]
                            },
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Status",
                            "filter": {
                                "members": [
                                    "status.[paid]"
                                ]
                            }
                        }
                    ],
                    "rows": [
                        {
                            "uniqueName": "Controller Name"
                        },
                        {
                            "uniqueName": "Date(Year)",
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Date(Month)",
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Date(Days)"
                        }
                    ],
                    "columns": [
                        {
                            "uniqueName": "Paid Type"
                        },
                        {
                            "uniqueName": "[Measures]"
                        }
                    ],
                    "measures": [
                        {
                            "uniqueName": "Received",
                            "formula": "sum(\"Received\")",
                            "caption": "Sum of Received",
                            "format": "-11chryx17nw3sm"
                        },
                        {
                            "uniqueName": "Controller ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11chryx17nw3sm",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Controller Name",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11chryx17nw3sm",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Sale Type",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11chryx17nw3sm"
                        },
                        {
                            "uniqueName": "Date Time",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11chryx17nw3sm",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Order No",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11chryx17nw3sm"
                        },
                        {
                            "uniqueName": "Status",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11chryx17nw3sm",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Table",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11chryx17nw3sm",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Pax",
                            "formula": "sum(\"Pax\")",
                            "caption": "Pax",
                            "grandTotalCaption": "Sum of Pax",
                            "active": false,
                            "format": "-11chryx17nw3sm"
                        },
                        {
                            "uniqueName": "Total Dish(es)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11chryx17nw3sm"
                        },
                        {
                            "uniqueName": "Cancel Dish(es)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11chryx17nw3sm"
                        },
                        {
                            "uniqueName": "Waiter",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11chryx17nw3sm",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Cashier",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11chryx17nw3sm",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Agent",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11chryx17nw3sm",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Paid On",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11chryx17nw3sm",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Sales",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11chryx17nw3sm"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("taxBeforeDiscount", "Tax Before Discount", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11chryx17nw3sm"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("netTaxBeforeDiscount", "Net Tax Before Discount", false),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11chryx17nw3sm"
                        },
                        {
                            "uniqueName": "Paid Type",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11chryx17nw3sm",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Discount(%)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11chryx17nw3sm"
                        },
                        {
                            "uniqueName": "Discount",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11chryx17nw3sm"
                        },
                        {
                            "uniqueName": "Sub Total",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11chryx17nw3sm"
                        },
                        {
                            "uniqueName": "Net Sales",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11chryx17nw3sm"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("taxBeforeDiscount", "Tax Before Discount", false),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11chryx17nw3sm"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax1", "Tax 1 (%)", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11chryx17nw3sm"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax1", "Tax 1", false),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11chryx17nw3sm"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2 (%)", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11chryx17nw3sm"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2", false),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11chryx17nw3sm"
                        },
                        {
                            "uniqueName": "Gross",
                            "formula": "sum(\"Gross\")",
                            "caption": "Gross",
                            "active": false,
                            "format": "-11chryx17nw3sm"
                        },
                        {
                            "uniqueName": "Received-v1",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11chryx17nw3sm"
                        },
                        {
                            "uniqueName": "Note-v1",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11chryx17nw3sm",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Note",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11chryx17nw3sm",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Split No.",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11chryx17nw3sm",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "FilterType",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11chryx17nw3sm",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Gross (Exclude  Tax)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11chryx17nw3sm"
                        },
                        {
                            "uniqueName": "Received-v1 (Exclude  Tax)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11chryx17nw3sm"
                        },
                        {
                            "uniqueName": "Received (Exclude  Tax)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11chryx17nw3sm"
                        },
                        {
                            "uniqueName": "Table/Bill",
                            "formula": "sum(\"Table/Bill\")",
                            "caption": "Table/Bill",
                            "active": false,
                            "format": "-11chryx17nw3sm"
                        },
                        {
                            "uniqueName": "Short Pay(-) -v1",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11chryx17nw3sm"
                        },
                        {
                            "uniqueName": "Over Pay(+) -v1",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11chryx17nw3sm"
                        },
                        {
                            "uniqueName": "Short Pay(-)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11chryx17nw3sm"
                        },
                        {
                            "uniqueName": "Over Pay(+)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11chryx17nw3sm"
                        },
                        {
                            "uniqueName": "Day of Week",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11chryx17nw3sm",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Date(Days)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11chryx17nw3sm"
                        },
                        {
                            "uniqueName": "Date(Month)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11chryx17nw3sm",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Date(Year)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11chryx17nw3sm"
                        },
                        {
                            "uniqueName": "Date(Week)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11chryx17nw3sm"
                        },
                        {
                            "uniqueName": "Hour of Day",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11chryx17nw3sm"
                        },
                        {
                            "uniqueName": "Block of 30 minutes",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11chryx17nw3sm"
                        },
                        {
                            "uniqueName": "Date(MM D, YYYY)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11chryx17nw3sm",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Start Time",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11chryx17nw3sm",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "End Time",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11chryx17nw3sm",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Report No.",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11chryx17nw3sm"
                        },
                        {
                            "uniqueName": "Meal Time",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11chryx17nw3sm",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Quarter",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11chryx17nw3sm",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Cash",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11chryx17nw3sm"
                        },
                        {
                            "uniqueName": "Pineapple",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11chryx17nw3sm"
                        },
                        {
                            "uniqueName": "Avg Net Sales / Pax",
                            "formula": "if(sum(\"Net Sales\")>0,sum(\"Net Sales\") / sum(\"Pax\"),0)",
                            "caption": "Avg Net Sales / Pax",
                            "active": false,
                            "format": "-11chryx17nw3sm"
                        },
                        {
                            "uniqueName": "Bill ",
                            "formula": "Count(\"Order No\")",
                            "caption": "Bill ",
                            "active": false,
                            "format": "-11chryx17nw3sm"
                        },
                        {
                            "uniqueName": "Avg Net Sales / Bill - 2",
                            "formula": "if(sum(\"Net Sales\")>0,sum(\"Net Sales\") / Count(\"Order No\"),0)",
                            "caption": "Avg Net Sales / Bill",
                            "active": false,
                            "format": "-11chryx17nw3sm"
                        },
                        {
                            "uniqueName": "Avg (Pax)",
                            "formula": "sum(\"Gross\") / sum(\"Pax\")",
                            "caption": "Avg (Pax)",
                            "active": false,
                            "format": "-11chryx17nw3sm"
                        },
                        {
                            "uniqueName": "Avg (Bill)",
                            "formula": "sum(\"Gross\") / sum(\"Table/Bill\")",
                            "caption": "Avg (Bill)",
                            "active": false,
                            "format": "-11chryx17nw3sm"
                        },
                        {
                            "uniqueName": "Avg Net Sales / Bill",
                            "formula": "sum(\"Net Sales\")",
                            "caption": "Avg Net Sales / Bill",
                            "active": false,
                            "format": "-11chryx17nw3sm"
                        }
                    ]
                },
                "options": {
                    "grid": {
                        "type": "classic"
                    },
                    "viewType": "grid"
                },
                "formats": [
                    {
                        "name": "-11chryx17nw3sm"
                    },
                    getFormats(),
                ]
            }
        },
        {
            "name": "Sales Type",
            "configuation": {
                "slice": {
                    "reportFilters": [
                        {
                            "uniqueName": "FilterType",
                            "filter": {
                                "members": [
                                    "filtertype.[payment type summary]"
                                ]
                            },
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Status",
                            "filter": {
                                "members": [
                                    "status.[paid]"
                                ]
                            }
                        }
                    ],
                    "rows": [
                        {
                            "uniqueName": "Controller Name"
                        },
                        {
                            "uniqueName": "Date(Year)",
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Date(Month)",
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Date(Days)"
                        }
                    ],
                    "columns": [
                        {
                            "uniqueName": "Sale Type",
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Paid Type"
                        },
                        {
                            "uniqueName": "[Measures]"
                        }
                    ],
                    "measures": [
                        {
                            "uniqueName": "Received",
                            "formula": "sum(\"Received\")",
                            "caption": "Sum of Received",
                            "format": "-q6aue8bvms2px"
                        },
                        {
                            "uniqueName": "Controller ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-q6aue8bvms2px",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Controller Name",
                            "aggregation": "count",
                            "active": false,
                            "format": "-q6aue8bvms2px",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Sale Type",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-q6aue8bvms2px"
                        },
                        {
                            "uniqueName": "Date Time",
                            "aggregation": "count",
                            "active": false,
                            "format": "-q6aue8bvms2px",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Order No",
                            "aggregation": "count",
                            "active": false,
                            "format": "-q6aue8bvms2px"
                        },
                        {
                            "uniqueName": "Status",
                            "aggregation": "count",
                            "active": false,
                            "format": "-q6aue8bvms2px",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Table",
                            "aggregation": "count",
                            "active": false,
                            "format": "-q6aue8bvms2px",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Pax",
                            "formula": "sum(\"Pax\")",
                            "caption": "Pax",
                            "grandTotalCaption": "Sum of Pax",
                            "active": false,
                            "format": "-q6aue8bvms2px"
                        },
                        {
                            "uniqueName": "Total Dish(es)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-q6aue8bvms2px"
                        },
                        {
                            "uniqueName": "Cancel Dish(es)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-q6aue8bvms2px"
                        },
                        {
                            "uniqueName": "Waiter",
                            "aggregation": "count",
                            "active": false,
                            "format": "-q6aue8bvms2px",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Cashier",
                            "aggregation": "count",
                            "active": false,
                            "format": "-q6aue8bvms2px",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Agent",
                            "aggregation": "count",
                            "active": false,
                            "format": "-q6aue8bvms2px",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Paid On",
                            "aggregation": "count",
                            "active": false,
                            "format": "-q6aue8bvms2px",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Sales",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-q6aue8bvms2px"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("taxBeforeDiscount", "Tax Before Discount", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-q6aue8bvms2px"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("netTaxBeforeDiscount", "Net Tax Before Discount", false),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-q6aue8bvms2px"
                        },
                        {
                            "uniqueName": "Paid Type",
                            "aggregation": "count",
                            "active": false,
                            "format": "-q6aue8bvms2px",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Discount(%)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-q6aue8bvms2px"
                        },
                        {
                            "uniqueName": "Discount",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-q6aue8bvms2px"
                        },
                        {
                            "uniqueName": "Sub Total",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-q6aue8bvms2px"
                        },
                        {
                            "uniqueName": "Net Sales",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-q6aue8bvms2px"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("taxBeforeDiscount", "Tax Before Discount", false),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-q6aue8bvms2px"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax1", "Tax 1 (%)", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-q6aue8bvms2px"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax1", "Tax 1", false),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-q6aue8bvms2px"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2 (%)", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-q6aue8bvms2px"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2", false),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-q6aue8bvms2px"
                        },
                        {
                            "uniqueName": "Gross",
                            "formula": "sum(\"Gross\")",
                            "caption": "Gross",
                            "active": false,
                            "format": "-q6aue8bvms2px"
                        },
                        {
                            "uniqueName": "Received-v1",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-q6aue8bvms2px"
                        },
                        {
                            "uniqueName": "Note-v1",
                            "aggregation": "count",
                            "active": false,
                            "format": "-q6aue8bvms2px",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Note",
                            "aggregation": "count",
                            "active": false,
                            "format": "-q6aue8bvms2px",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Split No.",
                            "aggregation": "count",
                            "active": false,
                            "format": "-q6aue8bvms2px",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "FilterType",
                            "aggregation": "count",
                            "active": false,
                            "format": "-q6aue8bvms2px",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Gross (Exclude  Tax)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-q6aue8bvms2px"
                        },
                        {
                            "uniqueName": "Received-v1 (Exclude  Tax)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-q6aue8bvms2px"
                        },
                        {
                            "uniqueName": "Received (Exclude  Tax)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-q6aue8bvms2px"
                        },
                        {
                            "uniqueName": "Table/Bill",
                            "formula": "sum(\"Table/Bill\")",
                            "caption": "Table/Bill",
                            "active": false,
                            "format": "-q6aue8bvms2px"
                        },
                        {
                            "uniqueName": "Short Pay(-) -v1",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-q6aue8bvms2px"
                        },
                        {
                            "uniqueName": "Over Pay(+) -v1",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-q6aue8bvms2px"
                        },
                        {
                            "uniqueName": "Short Pay(-)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-q6aue8bvms2px"
                        },
                        {
                            "uniqueName": "Over Pay(+)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-q6aue8bvms2px"
                        },
                        {
                            "uniqueName": "Day of Week",
                            "aggregation": "count",
                            "active": false,
                            "format": "-q6aue8bvms2px",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Date(Days)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-q6aue8bvms2px"
                        },
                        {
                            "uniqueName": "Date(Month)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-q6aue8bvms2px",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Date(Year)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-q6aue8bvms2px"
                        },
                        {
                            "uniqueName": "Date(Week)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-q6aue8bvms2px"
                        },
                        {
                            "uniqueName": "Hour of Day",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-q6aue8bvms2px"
                        },
                        {
                            "uniqueName": "Block of 30 minutes",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-q6aue8bvms2px"
                        },
                        {
                            "uniqueName": "Date(MM D, YYYY)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-q6aue8bvms2px",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Start Time",
                            "aggregation": "count",
                            "active": false,
                            "format": "-q6aue8bvms2px",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "End Time",
                            "aggregation": "count",
                            "active": false,
                            "format": "-q6aue8bvms2px",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Report No.",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-q6aue8bvms2px"
                        },
                        {
                            "uniqueName": "Meal Time",
                            "aggregation": "count",
                            "active": false,
                            "format": "-q6aue8bvms2px",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Quarter",
                            "aggregation": "count",
                            "active": false,
                            "format": "-q6aue8bvms2px",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Cash",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-q6aue8bvms2px"
                        },
                        {
                            "uniqueName": "Pineapple",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-q6aue8bvms2px"
                        },
                        {
                            "uniqueName": "Avg Net Sales / Pax",
                            "formula": "if(sum(\"Net Sales\")>0,sum(\"Net Sales\") / sum(\"Pax\"),0)",
                            "caption": "Avg Net Sales / Pax",
                            "active": false,
                            "format": "-q6aue8bvms2px"
                        },
                        {
                            "uniqueName": "Bill ",
                            "formula": "Count(\"Order No\")",
                            "caption": "Bill ",
                            "active": false,
                            "format": "-q6aue8bvms2px"
                        },
                        {
                            "uniqueName": "Avg Net Sales / Bill - 2",
                            "formula": "if(sum(\"Net Sales\")>0,sum(\"Net Sales\") / Count(\"Order No\"),0)",
                            "caption": "Avg Net Sales / Bill",
                            "active": false,
                            "format": "-q6aue8bvms2px"
                        },
                        {
                            "uniqueName": "Avg (Pax)",
                            "formula": "sum(\"Gross\") / sum(\"Pax\")",
                            "caption": "Avg (Pax)",
                            "active": false,
                            "format": "-q6aue8bvms2px"
                        },
                        {
                            "uniqueName": "Avg (Bill)",
                            "formula": "sum(\"Gross\") / sum(\"Table/Bill\")",
                            "caption": "Avg (Bill)",
                            "active": false,
                            "format": "-q6aue8bvms2px"
                        },
                        {
                            "uniqueName": "Avg Net Sales / Bill",
                            "formula": "sum(\"Net Sales\")",
                            "caption": "Avg Net Sales / Bill",
                            "active": false,
                            "format": "-q6aue8bvms2px"
                        }
                    ]
                },
                "options": {
                    "grid": {
                        "type": "classic"
                    },
                    "viewType": "grid"
                },
                "formats": [
                    {
                        "name": "-q6aue8bvms2px"
                    },
                    getFormats(),
                ]
            }
        },
        {
            "name": "Agents Sales",
            "configuation": {
                "slice": {
                    "reportFilters": [
                        {
                            "uniqueName": "FilterType",
                            "filter": {
                                "members": [
                                    "filtertype.[individual bill summary]"
                                ]
                            },
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Controller Name"
                        },
                        {
                            "uniqueName": "Status",
                            "filter": {
                                "members": [
                                    "status.[paid]"
                                ]
                            },
                            "sort": "unsorted"
                        }
                    ],
                    "rows": [
                        {
                            "uniqueName": "Date(Year)",
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Date(Month)",
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Order No",
                            "sort": "unsorted"
                        }
                    ],
                    "columns": [
                        {
                            "uniqueName": "Agent",
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "[Measures]"
                        }
                    ],
                    "measures": [
                        {
                            "uniqueName": "Discount",
                            "aggregation": "sum",
                            "format": "-j6wfk3jp4dhkg"
                        },
                        {
                            "uniqueName": "Net Sales",
                            "aggregation": "sum",
                            "format": "-j6wfk3jp4dhkg"
                        },
                        {
                            "uniqueName": "Received",
                            "formula": "sum(\"Received\")",
                            "caption": "Sum of Received",
                            "format": "-j6wfk3jp4dhkg"
                        },
                        {
                            "uniqueName": "Controller ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-j6wfk3jp4dhkg",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Controller Name",
                            "aggregation": "count",
                            "active": false,
                            "format": "-j6wfk3jp4dhkg",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Sale Type",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-j6wfk3jp4dhkg"
                        },
                        {
                            "uniqueName": "Date Time",
                            "aggregation": "count",
                            "active": false,
                            "format": "-j6wfk3jp4dhkg",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Order No",
                            "aggregation": "count",
                            "active": false,
                            "format": "-j6wfk3jp4dhkg"
                        },
                        {
                            "uniqueName": "Status",
                            "aggregation": "count",
                            "active": false,
                            "format": "-j6wfk3jp4dhkg",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Table",
                            "aggregation": "count",
                            "active": false,
                            "format": "-j6wfk3jp4dhkg",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Pax",
                            "formula": "sum(\"Pax\")",
                            "caption": "Pax",
                            "grandTotalCaption": "Sum of Pax",
                            "active": false,
                            "format": "-j6wfk3jp4dhkg"
                        },
                        {
                            "uniqueName": "Total Dish(es)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-j6wfk3jp4dhkg"
                        },
                        {
                            "uniqueName": "Cancel Dish(es)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-j6wfk3jp4dhkg"
                        },
                        {
                            "uniqueName": "Waiter",
                            "aggregation": "count",
                            "active": false,
                            "format": "-j6wfk3jp4dhkg",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Cashier",
                            "aggregation": "count",
                            "active": false,
                            "format": "-j6wfk3jp4dhkg",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Agent",
                            "aggregation": "count",
                            "active": false,
                            "format": "-j6wfk3jp4dhkg",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Paid On",
                            "aggregation": "count",
                            "active": false,
                            "format": "-j6wfk3jp4dhkg",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Sales",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-j6wfk3jp4dhkg"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("taxBeforeDiscount", "Tax Before Discount", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-j6wfk3jp4dhkg"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("netTaxBeforeDiscount", "Net Tax Before Discount", false),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-j6wfk3jp4dhkg"
                        },
                        {
                            "uniqueName": "Paid Type",
                            "aggregation": "count",
                            "active": false,
                            "format": "-j6wfk3jp4dhkg",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Discount(%)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-j6wfk3jp4dhkg"
                        },
                        {
                            "uniqueName": "Sub Total",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-j6wfk3jp4dhkg"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("taxBeforeDiscount", "Tax Before Discount", false),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-j6wfk3jp4dhkg"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax1", "Tax 1 (%)", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-j6wfk3jp4dhkg"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax1", "Tax 1", false),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-j6wfk3jp4dhkg"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2 (%)", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-j6wfk3jp4dhkg"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2", false),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-j6wfk3jp4dhkg"
                        },
                        {
                            "uniqueName": "Gross",
                            "formula": "sum(\"Gross\")",
                            "caption": "Gross",
                            "active": false,
                            "format": "-j6wfk3jp4dhkg"
                        },
                        {
                            "uniqueName": "Received-v1",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-j6wfk3jp4dhkg"
                        },
                        {
                            "uniqueName": "Note-v1",
                            "aggregation": "count",
                            "active": false,
                            "format": "-j6wfk3jp4dhkg",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Note",
                            "aggregation": "count",
                            "active": false,
                            "format": "-j6wfk3jp4dhkg",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Split No.",
                            "aggregation": "count",
                            "active": false,
                            "format": "-j6wfk3jp4dhkg",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "FilterType",
                            "aggregation": "count",
                            "active": false,
                            "format": "-j6wfk3jp4dhkg",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Gross (Exclude  Tax)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-j6wfk3jp4dhkg"
                        },
                        {
                            "uniqueName": "Received-v1 (Exclude  Tax)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-j6wfk3jp4dhkg"
                        },
                        {
                            "uniqueName": "Received (Exclude  Tax)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-j6wfk3jp4dhkg"
                        },
                        {
                            "uniqueName": "Table/Bill",
                            "formula": "sum(\"Table/Bill\")",
                            "caption": "Table/Bill",
                            "active": false,
                            "format": "-j6wfk3jp4dhkg"
                        },
                        {
                            "uniqueName": "Short Pay(-) -v1",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-j6wfk3jp4dhkg"
                        },
                        {
                            "uniqueName": "Over Pay(+) -v1",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-j6wfk3jp4dhkg"
                        },
                        {
                            "uniqueName": "Short Pay(-)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-j6wfk3jp4dhkg"
                        },
                        {
                            "uniqueName": "Over Pay(+)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-j6wfk3jp4dhkg"
                        },
                        {
                            "uniqueName": "Day of Week",
                            "aggregation": "count",
                            "active": false,
                            "format": "-j6wfk3jp4dhkg",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Date(Days)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-j6wfk3jp4dhkg"
                        },
                        {
                            "uniqueName": "Date(Month)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-j6wfk3jp4dhkg",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Date(Year)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-j6wfk3jp4dhkg"
                        },
                        {
                            "uniqueName": "Date(Week)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-j6wfk3jp4dhkg"
                        },
                        {
                            "uniqueName": "Hour of Day",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-j6wfk3jp4dhkg"
                        },
                        {
                            "uniqueName": "Block of 30 minutes",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-j6wfk3jp4dhkg"
                        },
                        {
                            "uniqueName": "Date(MM D, YYYY)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-j6wfk3jp4dhkg",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Start Time",
                            "aggregation": "count",
                            "active": false,
                            "format": "-j6wfk3jp4dhkg",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "End Time",
                            "aggregation": "count",
                            "active": false,
                            "format": "-j6wfk3jp4dhkg",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Report No.",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-j6wfk3jp4dhkg"
                        },
                        {
                            "uniqueName": "Meal Time",
                            "aggregation": "count",
                            "active": false,
                            "format": "-j6wfk3jp4dhkg",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Quarter",
                            "aggregation": "count",
                            "active": false,
                            "format": "-j6wfk3jp4dhkg",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Cash",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-j6wfk3jp4dhkg"
                        },
                        {
                            "uniqueName": "Pineapple",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-j6wfk3jp4dhkg"
                        },
                        {
                            "uniqueName": "Avg Net Sales / Pax",
                            "formula": "if(sum(\"Net Sales\")>0,sum(\"Net Sales\") / sum(\"Pax\"),0)",
                            "caption": "Avg Net Sales / Pax",
                            "active": false,
                            "format": "-j6wfk3jp4dhkg"
                        },
                        {
                            "uniqueName": "Bill ",
                            "formula": "Count(\"Order No\")",
                            "caption": "Bill ",
                            "active": false,
                            "format": "-j6wfk3jp4dhkg"
                        },
                        {
                            "uniqueName": "Avg Net Sales / Bill - 2",
                            "formula": "if(sum(\"Net Sales\")>0,sum(\"Net Sales\") / Count(\"Order No\"),0)",
                            "caption": "Avg Net Sales / Bill",
                            "active": false,
                            "format": "-j6wfk3jp4dhkg"
                        },
                        {
                            "uniqueName": "Avg (Pax)",
                            "formula": "sum(\"Gross\") / sum(\"Pax\")",
                            "caption": "Avg (Pax)",
                            "active": false,
                            "format": "-j6wfk3jp4dhkg"
                        },
                        {
                            "uniqueName": "Avg (Bill)",
                            "formula": "sum(\"Gross\") / sum(\"Table/Bill\")",
                            "caption": "Avg (Bill)",
                            "active": false,
                            "format": "-j6wfk3jp4dhkg"
                        },
                        {
                            "uniqueName": "Avg Net Sales / Bill",
                            "formula": "sum(\"Net Sales\")",
                            "caption": "Avg Net Sales / Bill",
                            "active": false,
                            "format": "-j6wfk3jp4dhkg"
                        },
                        {
                            "uniqueName": "Bill",
                            "formula": "Count(\"Order No\")",
                            "caption": "Bill",
                            "active": false,
                            "format": "-j6wfk3jp4dhkg"
                        }
                    ]
                },
                "options": {
                    "grid": {
                        "type": "classic"
                    },
                    "chart": {
                        "type": "stacked_column",
                        "activeMeasure": {
                            "uniqueName": "Net Sales",
                            "aggregation": "sum"
                        }
                    },
                    "viewType": "grid"
                },
                "formats": [
                    getFormats()
                ]
            }
        },
        {
            "name": "Cashier",
            "configuation": {
                "slice": {
                    "reportFilters": [
                        {
                            "uniqueName": "FilterType",
                            "filter": {
                                "members": [
                                    "filtertype.[individual bill summary]"
                                ]
                            },
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Controller Name"
                        },
                        {
                            "uniqueName": "Status",
                            "filter": {
                                "members": [
                                    "status.[paid]"
                                ]
                            },
                            "sort": "unsorted"
                        }
                    ],
                    "rows": [
                        {
                            "uniqueName": "Date(Year)",
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Date(Month)",
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Order No",
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Paid On",
                            "sort": "unsorted"
                        }
                    ],
                    "columns": [
                        {
                            "uniqueName": "Cashier",
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "[Measures]"
                        }
                    ],
                    "measures": [
                        {
                            "uniqueName": "Bill",
                            "formula": "Count(\"Order No\")",
                            "caption": "Bill",
                            "format": "-lfjpylnd7hfhi"
                        },
                        {
                            "uniqueName": "Received",
                            "formula": "sum(\"Received\")",
                            "caption": "Sum of Received",
                            "format": "-lfjpylnd7hfhi"
                        },
                        {
                            "uniqueName": "Controller ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-lfjpylnd7hfhi",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Controller Name",
                            "aggregation": "count",
                            "active": false,
                            "format": "-lfjpylnd7hfhi",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Sale Type",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-lfjpylnd7hfhi"
                        },
                        {
                            "uniqueName": "Date Time",
                            "aggregation": "count",
                            "active": false,
                            "format": "-lfjpylnd7hfhi",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Order No",
                            "aggregation": "count",
                            "active": false,
                            "format": "-lfjpylnd7hfhi"
                        },
                        {
                            "uniqueName": "Status",
                            "aggregation": "count",
                            "active": false,
                            "format": "-lfjpylnd7hfhi",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Table",
                            "aggregation": "count",
                            "active": false,
                            "format": "-lfjpylnd7hfhi",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Pax",
                            "formula": "sum(\"Pax\")",
                            "caption": "Pax",
                            "grandTotalCaption": "Sum of Pax",
                            "active": false,
                            "format": "-lfjpylnd7hfhi"
                        },
                        {
                            "uniqueName": "Total Dish(es)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-lfjpylnd7hfhi"
                        },
                        {
                            "uniqueName": "Cancel Dish(es)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-lfjpylnd7hfhi"
                        },
                        {
                            "uniqueName": "Waiter",
                            "aggregation": "count",
                            "active": false,
                            "format": "-lfjpylnd7hfhi",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Cashier",
                            "aggregation": "count",
                            "active": false,
                            "format": "-lfjpylnd7hfhi",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Agent",
                            "aggregation": "count",
                            "active": false,
                            "format": "-lfjpylnd7hfhi",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Paid On",
                            "aggregation": "count",
                            "active": false,
                            "format": "-lfjpylnd7hfhi",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Sales",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-lfjpylnd7hfhi"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("taxBeforeDiscount", "Tax Before Discount", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-lfjpylnd7hfhi"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("netTaxBeforeDiscount", "Net Tax Before Discount", false),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-lfjpylnd7hfhi"
                        },
                        {
                            "uniqueName": "Paid Type",
                            "aggregation": "count",
                            "active": false,
                            "format": "-lfjpylnd7hfhi",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Discount(%)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-lfjpylnd7hfhi"
                        },
                        {
                            "uniqueName": "Discount",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-lfjpylnd7hfhi"
                        },
                        {
                            "uniqueName": "Sub Total",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-lfjpylnd7hfhi"
                        },
                        {
                            "uniqueName": "Net Sales",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-lfjpylnd7hfhi"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("taxBeforeDiscount", "Tax Before Discount", false),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-lfjpylnd7hfhi"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax1", "Tax 1 (%)", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-lfjpylnd7hfhi"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax1", "Tax 1", false),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-lfjpylnd7hfhi"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2 (%)", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-lfjpylnd7hfhi"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2", false),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-lfjpylnd7hfhi"
                        },
                        {
                            "uniqueName": "Gross",
                            "formula": "sum(\"Gross\")",
                            "caption": "Gross",
                            "active": false,
                            "format": "-lfjpylnd7hfhi"
                        },
                        {
                            "uniqueName": "Received-v1",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-lfjpylnd7hfhi"
                        },
                        {
                            "uniqueName": "Note-v1",
                            "aggregation": "count",
                            "active": false,
                            "format": "-lfjpylnd7hfhi",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Note",
                            "aggregation": "count",
                            "active": false,
                            "format": "-lfjpylnd7hfhi",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Split No.",
                            "aggregation": "count",
                            "active": false,
                            "format": "-lfjpylnd7hfhi",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "FilterType",
                            "aggregation": "count",
                            "active": false,
                            "format": "-lfjpylnd7hfhi",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Gross (Exclude  Tax)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-lfjpylnd7hfhi"
                        },
                        {
                            "uniqueName": "Received-v1 (Exclude  Tax)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-lfjpylnd7hfhi"
                        },
                        {
                            "uniqueName": "Received (Exclude  Tax)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-lfjpylnd7hfhi"
                        },
                        {
                            "uniqueName": "Table/Bill",
                            "formula": "sum(\"Table/Bill\")",
                            "caption": "Table/Bill",
                            "active": false,
                            "format": "-lfjpylnd7hfhi"
                        },
                        {
                            "uniqueName": "Short Pay(-) -v1",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-lfjpylnd7hfhi"
                        },
                        {
                            "uniqueName": "Over Pay(+) -v1",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-lfjpylnd7hfhi"
                        },
                        {
                            "uniqueName": "Short Pay(-)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-lfjpylnd7hfhi"
                        },
                        {
                            "uniqueName": "Over Pay(+)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-lfjpylnd7hfhi"
                        },
                        {
                            "uniqueName": "Day of Week",
                            "aggregation": "count",
                            "active": false,
                            "format": "-lfjpylnd7hfhi",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Date(Days)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-lfjpylnd7hfhi"
                        },
                        {
                            "uniqueName": "Date(Month)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-lfjpylnd7hfhi",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Date(Year)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-lfjpylnd7hfhi"
                        },
                        {
                            "uniqueName": "Date(Week)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-lfjpylnd7hfhi"
                        },
                        {
                            "uniqueName": "Hour of Day",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-lfjpylnd7hfhi"
                        },
                        {
                            "uniqueName": "Block of 30 minutes",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-lfjpylnd7hfhi"
                        },
                        {
                            "uniqueName": "Date(MM D, YYYY)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-lfjpylnd7hfhi",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Start Time",
                            "aggregation": "count",
                            "active": false,
                            "format": "-lfjpylnd7hfhi",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "End Time",
                            "aggregation": "count",
                            "active": false,
                            "format": "-lfjpylnd7hfhi",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Report No.",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-lfjpylnd7hfhi"
                        },
                        {
                            "uniqueName": "Meal Time",
                            "aggregation": "count",
                            "active": false,
                            "format": "-lfjpylnd7hfhi",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Quarter",
                            "aggregation": "count",
                            "active": false,
                            "format": "-lfjpylnd7hfhi",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Cash",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-lfjpylnd7hfhi"
                        },
                        {
                            "uniqueName": "Pineapple",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-lfjpylnd7hfhi"
                        },
                        {
                            "uniqueName": "Avg Net Sales / Pax",
                            "formula": "if(sum(\"Net Sales\")>0,sum(\"Net Sales\") / sum(\"Pax\"),0)",
                            "caption": "Avg Net Sales / Pax",
                            "active": false,
                            "format": "-lfjpylnd7hfhi"
                        },
                        {
                            "uniqueName": "Bill ",
                            "formula": "Count(\"Order No\")",
                            "caption": "Bill ",
                            "active": false,
                            "format": "-lfjpylnd7hfhi"
                        },
                        {
                            "uniqueName": "Avg Net Sales / Bill - 2",
                            "formula": "if(sum(\"Net Sales\")>0,sum(\"Net Sales\") / Count(\"Order No\"),0)",
                            "caption": "Avg Net Sales / Bill",
                            "active": false,
                            "format": "-lfjpylnd7hfhi"
                        },
                        {
                            "uniqueName": "Avg (Pax)",
                            "formula": "sum(\"Gross\") / sum(\"Pax\")",
                            "caption": "Avg (Pax)",
                            "active": false,
                            "format": "-lfjpylnd7hfhi"
                        },
                        {
                            "uniqueName": "Avg (Bill)",
                            "formula": "sum(\"Gross\") / sum(\"Table/Bill\")",
                            "caption": "Avg (Bill)",
                            "active": false,
                            "format": "-lfjpylnd7hfhi"
                        },
                        {
                            "uniqueName": "Avg Net Sales / Bill",
                            "formula": "sum(\"Net Sales\")",
                            "caption": "Avg Net Sales / Bill",
                            "active": false,
                            "format": "-lfjpylnd7hfhi"
                        }
                    ]
                },
                "options": {
                    "grid": {
                        "type": "classic"
                    },
                    "chart": {
                        "type": "stacked_column",
                        "activeMeasure": {
                            "uniqueName": "Net Sales",
                            "aggregation": "sum"
                        }
                    },
                    "viewType": "grid"
                },
                "formats": [
                    getFormats()
                ]
            }
        },
        {
            "name": "Sales (Meal Time)",
            "configuation": {
                "slice": {
                    "reportFilters": [
                        {
                            "uniqueName": "FilterType",
                            "filter": {
                                "members": [
                                    "filtertype.[individual bill summary]"
                                ]
                            },
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Status",
                            "filter": {
                                "members": [
                                    "status.[paid]"
                                ]
                            },
                            "sort": "unsorted"
                        }
                    ],
                    "rows": [
                        {
                            "uniqueName": "Controller Name"
                        }
                    ],
                    "columns": [
                        {
                            "uniqueName": "Meal Time",
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "[Measures]"
                        }
                    ],
                    "measures": [
                        {
                            "uniqueName": "Gross",
                            "formula": "sum(\"Gross\")",
                            "caption": "Gross",
                            "format": "-135avdsimfg9nx"
                        },
                        {
                            "uniqueName": "Table/Bill",
                            "formula": "sum(\"Table/Bill\")",
                            "caption": "Table/Bill",
                            "format": "-135avdsimfg9nx"
                        },
                        {
                            "uniqueName": "Pax",
                            "formula": "sum(\"Pax\")",
                            "caption": "Pax",
                            "grandTotalCaption": "Sum of Pax",
                            "format": "-135avdsimfg9nx"
                        },
                        {
                            "uniqueName": "Avg (Pax)",
                            "formula": "sum(\"Gross\") / sum(\"Pax\")",
                            "caption": "Avg (Pax)",
                            "format": "-3i34yr6h13gl4"
                        },
                        {
                            "uniqueName": "Avg (Bill)",
                            "formula": "sum(\"Gross\") / sum(\"Table/Bill\")",
                            "caption": "Avg (Bill)",
                            "format": "-4k22jxy01hyhn"
                        },
                        {
                            "uniqueName": "Controller ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-135avdsimfg9nx",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Controller Name",
                            "aggregation": "count",
                            "active": false,
                            "format": "-135avdsimfg9nx",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Sale Type",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-135avdsimfg9nx"
                        },
                        {
                            "uniqueName": "Date Time",
                            "aggregation": "count",
                            "active": false,
                            "format": "-135avdsimfg9nx",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Order No",
                            "aggregation": "count",
                            "active": false,
                            "format": "-135avdsimfg9nx"
                        },
                        {
                            "uniqueName": "Status",
                            "aggregation": "count",
                            "active": false,
                            "format": "-135avdsimfg9nx",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Table",
                            "aggregation": "count",
                            "active": false,
                            "format": "-135avdsimfg9nx",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Total Dish(es)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-135avdsimfg9nx"
                        },
                        {
                            "uniqueName": "Cancel Dish(es)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-135avdsimfg9nx"
                        },
                        {
                            "uniqueName": "Waiter",
                            "aggregation": "count",
                            "active": false,
                            "format": "-135avdsimfg9nx",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Cashier",
                            "aggregation": "count",
                            "active": false,
                            "format": "-135avdsimfg9nx",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Agent",
                            "aggregation": "count",
                            "active": false,
                            "format": "-135avdsimfg9nx",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Paid On",
                            "aggregation": "count",
                            "active": false,
                            "format": "-135avdsimfg9nx",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Sales",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-135avdsimfg9nx"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("taxBeforeDiscount", "Tax Before Discount", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-135avdsimfg9nx"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("netTaxBeforeDiscount", "Net Tax Before Discount", false),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-135avdsimfg9nx"
                        },
                        {
                            "uniqueName": "Paid Type",
                            "aggregation": "count",
                            "active": false,
                            "format": "-135avdsimfg9nx",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Discount(%)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-135avdsimfg9nx"
                        },
                        {
                            "uniqueName": "Discount",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-135avdsimfg9nx"
                        },
                        {
                            "uniqueName": "Sub Total",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-135avdsimfg9nx"
                        },
                        {
                            "uniqueName": "Net Sales",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-135avdsimfg9nx"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("taxBeforeDiscount", "Tax Before Discount", false),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-135avdsimfg9nx"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax1", "Tax 1 (%)", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-135avdsimfg9nx"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax1", "Tax 1", false),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-135avdsimfg9nx"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2 (%)", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-135avdsimfg9nx"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2", false),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-135avdsimfg9nx"
                        },
                        {
                            "uniqueName": "Received-v1",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-135avdsimfg9nx"
                        },
                        {
                            "uniqueName": "Note-v1",
                            "aggregation": "count",
                            "active": false,
                            "format": "-135avdsimfg9nx",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Received",
                            "formula": "sum(\"Received\")",
                            "caption": "Sum of Received",
                            "active": false,
                            "format": "-135avdsimfg9nx"
                        },
                        {
                            "uniqueName": "Note",
                            "aggregation": "count",
                            "active": false,
                            "format": "-135avdsimfg9nx",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Split No.",
                            "aggregation": "count",
                            "active": false,
                            "format": "-135avdsimfg9nx",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "FilterType",
                            "aggregation": "count",
                            "active": false,
                            "format": "-135avdsimfg9nx",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Gross (Exclude  Tax)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-135avdsimfg9nx"
                        },
                        {
                            "uniqueName": "Received-v1 (Exclude  Tax)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-135avdsimfg9nx"
                        },
                        {
                            "uniqueName": "Received (Exclude  Tax)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-135avdsimfg9nx"
                        },
                        {
                            "uniqueName": "Short Pay(-) -v1",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-135avdsimfg9nx"
                        },
                        {
                            "uniqueName": "Over Pay(+) -v1",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-135avdsimfg9nx"
                        },
                        {
                            "uniqueName": "Short Pay(-)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-135avdsimfg9nx"
                        },
                        {
                            "uniqueName": "Over Pay(+)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-135avdsimfg9nx"
                        },
                        {
                            "uniqueName": "Day of Week",
                            "aggregation": "count",
                            "active": false,
                            "format": "-135avdsimfg9nx",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Date(Days)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-135avdsimfg9nx"
                        },
                        {
                            "uniqueName": "Date(Month)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-135avdsimfg9nx",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Date(Year)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-135avdsimfg9nx"
                        },
                        {
                            "uniqueName": "Date(Week)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-135avdsimfg9nx"
                        },
                        {
                            "uniqueName": "Hour of Day",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-135avdsimfg9nx"
                        },
                        {
                            "uniqueName": "Block of 30 minutes",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-135avdsimfg9nx"
                        },
                        {
                            "uniqueName": "Date(MM D, YYYY)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-135avdsimfg9nx",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Start Time",
                            "aggregation": "count",
                            "active": false,
                            "format": "-135avdsimfg9nx",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "End Time",
                            "aggregation": "count",
                            "active": false,
                            "format": "-135avdsimfg9nx",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Report No.",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-135avdsimfg9nx"
                        },
                        {
                            "uniqueName": "Meal Time",
                            "aggregation": "count",
                            "active": false,
                            "format": "-135avdsimfg9nx",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Quarter",
                            "aggregation": "count",
                            "active": false,
                            "format": "-135avdsimfg9nx",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Cash",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-135avdsimfg9nx"
                        },
                        {
                            "uniqueName": "Pineapple",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-135avdsimfg9nx"
                        },
                        {
                            "uniqueName": "Avg Net Sales / Pax",
                            "formula": "if(sum(\"Net Sales\")>0,sum(\"Net Sales\") / sum(\"Pax\"),0)",
                            "caption": "Avg Net Sales / Pax",
                            "active": false,
                            "format": "-135avdsimfg9nx"
                        },
                        {
                            "uniqueName": "Bill ",
                            "formula": "Count(\"Order No\")",
                            "caption": "Bill ",
                            "active": false,
                            "format": "-135avdsimfg9nx"
                        },
                        {
                            "uniqueName": "Avg Net Sales / Bill - 2",
                            "formula": "if(sum(\"Net Sales\")>0,sum(\"Net Sales\") / Count(\"Order No\"),0)",
                            "caption": "Avg Net Sales / Bill",
                            "active": false,
                            "format": "-135avdsimfg9nx"
                        },
                        {
                            "uniqueName": "Avg Net Sales / Bill",
                            "formula": "sum(\"Net Sales\")",
                            "caption": "Avg Net Sales / Bill",
                            "active": false,
                            "format": "-135avdsimfg9nx"
                        },
                        {
                            "uniqueName": "Bill",
                            "formula": "Count(\"Order No\")",
                            "caption": "Bill",
                            "active": false,
                            "format": "-135avdsimfg9nx"
                        }
                    ]
                },
                "options": {
                    "grid": {
                        "type": "classic"
                    },
                    "chart": {
                        "type": "stacked_column",
                        "activeMeasure": {
                            "uniqueName": "Net Sales",
                            "aggregation": "sum"
                        }
                    },
                    "viewType": "grid"
                },
                "formats": [
                    {
                        "name": "-3i34yr6h13gl4",
                        "decimalPlaces": 2
                    },
                    {
                        "name": "-4k22jxy01hyhn",
                        "decimalPlaces": 2
                    },
                    getFormats(),
                ]
            }
        },
        {
            "name": "Sales (Hourly)",
            "configuation": {
                "slice": {
                    "reportFilters": [
                        {
                            "uniqueName": "FilterType",
                            "filter": {
                                "members": [
                                    "filtertype.[individual bill summary]"
                                ]
                            },
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Controller Name",
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Status",
                            "filter": {
                                "members": [
                                    "status.[paid]"
                                ]
                            },
                            "sort": "unsorted"
                        }
                    ],
                    "rows": [
                        {
                            "uniqueName": "Hour of Day"
                        }
                    ],
                    "columns": [
                        {
                            "uniqueName": "Day of Week"
                        },
                        {
                            "uniqueName": "[Measures]"
                        }
                    ],
                    "measures": [
                        {
                            "uniqueName": "Bill ",
                            "formula": "Count(\"Order No\")",
                            "caption": "Bill ",
                            "format": "-h8h26d8lj5i00"
                        },
                        {
                            "uniqueName": "Total Dish(es)",
                            "aggregation": "sum",
                            "format": "-10th1ypduvgn00"
                        },
                        {
                            "uniqueName": "Avg Net Sales/Bill",
                            "formula": "if( \"Bill \" > 0, ( sum(\"Net Sales\") / \"Bill \" ), 0)",
                            "caption": "Avg Net Sales/Bill",
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Net Sales",
                            "aggregation": "sum",
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Sum of Taxes",
                            "formula": "sum(\""+Filter.changeToNameSettings("netTaxBeforeDiscount", "Net Tax Before Discount", false)+"\") + sum(\""+ Filter.changeToNameSettings("tax1", "Tax 1", false) +"\") + sum(\""+ Filter.changeToNameSettings("tax2", "Tax 2", false) +"\")",
                            "caption": "Sum of Taxes",
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Gross",
                            "formula": "sum(\"Gross\")",
                            "caption": "Sum of Gross",
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Cash Rounding",
                            "formula": "sum(\"Short Pay(-)\") + sum(\"Over Pay(+)\")",
                            "caption": "Cash Rounding",
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Received",
                            "formula": "sum(\"Received\")",
                            "caption": "Received",
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Net Sales Percentage (%)",
                            "formula": "percentofcolumn(\"Net Sales\")",
                            "caption": "Net Sales Percentage (%)",
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Controller ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Controller Name",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Sale Type",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Date Time",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Date Time (YYYY-MM-DD)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Order No",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Status",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Table",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Pax",
                            "formula": "sum(\"Pax\")",
                            "caption": "Sum of Pax",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Cancel Dish(es)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Waiter",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Cashier",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Agent",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Paid On",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Sales",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("taxBeforeDiscount", "Tax Before Discount (%)", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("taxBeforeDiscount", "Tax Before Discount", false),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Paid Type",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Discount(%)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Discount",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Sub Total",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("netTaxBeforeDiscount", "Net Tax Before Discount", false),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax1", "Tax 1 (%)", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2", false),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Received-v1",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Note-v1",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Note",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Split No.",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "FilterType",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Gross (Exclude  Tax)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Received-v1 (Exclude  Tax)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Received (Exclude  Tax)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Table/Bill",
                            "formula": "sum(\"Table/Bill\")",
                            "caption": "Sum of Table/Bill",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Short Pay(-) -v1",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Over Pay(+) -v1",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Short Pay(-)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Over Pay(+)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Day of Week",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Date(Days)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Date(Month)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Date(Year)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Date(Week)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Hour of Day",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Date(HH:mm)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Block of 30 minutes",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Date(MM D, YYYY)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Date(YYYY-MM-DD)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Start Time",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "End Time",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "End Time (YYYY-MM-DD, hh:mm:ss)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Report No.",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Meal Time",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Quarter",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Period",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Cash",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Gross Difference",
                            "formula": "difference(\"Gross\")",
                            "caption": "Gross Difference",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Gross Percentage Increase/Decrease (%)",
                            "formula": "%difference(\"Gross\")",
                            "caption": "Gross Percentage Increase/Decrease (%)",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        }
                    ]
                },
                "options": {
                    "grid": {
                        "type": "classic"
                    },
                    "chart": {
                        "activeMeasure": {
                            "uniqueName": ""
                        }
                    },
                    "showEmptyData": false,
                    "viewType": "grid"
                },
                "formats": [
                    {
                        "name": "-10ir2s6itv0ega",
                        "decimalPlaces": 2
                    },
                    {
                        "name": "",
                        "decimalPlaces": 2
                    },
                    {
                        "name": "-h8h26d8lj5i00",
                        "decimalPlaces": -1
                    },
                    {
                        "name": "-10th1ypduvgn00",
                        "decimalPlaces": -1
                    },
                    getFormats(),
                ],
                "conditions": [
                    {
                        "formula": "#value = 0",
                        "measure": "Bill ",
                        "format": {
                            "backgroundColor": "#FFFFFF",
                            "color": "#FFFFFF",
                            "fontFamily": "Arial",
                            "fontSize": "12px"
                        }
                    },
                    {
                        "formula": "#value = 0",
                        "measure": "Avg Net Sales/Bill",
                        "format": {
                            "backgroundColor": "#FFFFFF",
                            "color": "#FFFFFF",
                            "fontFamily": "Arial",
                            "fontSize": "12px"
                        }
                    }
                ]
            }
        },
        {
            "name": "Sales (Daily)",
            "configuation": {
                "slice": {
                    "reportFilters": [
                        {
                            "uniqueName": "FilterType",
                            "filter": {
                                "members": [
                                    "filtertype.[individual bill summary]"
                                ]
                            },
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Controller Name",
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Status",
                            "filter": {
                                "members": [
                                    "status.[paid]"
                                ]
                            },
                            "sort": "unsorted"
                        }
                    ],
                    "rows": [
                        {
                            "uniqueName": "Date(YYYY-MM-DD)"
                        }
                    ],
                    "columns": [
                        {
                            "uniqueName": "[Measures]"
                        }
                    ],
                    "measures": [
                        {
                            "uniqueName": "Bill ",
                            "formula": "Count(\"Order No\")",
                            "caption": "Bill ",
                            "format": "-vn37cn3b05o00"
                        },
                        {
                            "uniqueName": "Sales",
                            "aggregation": "sum",
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Discount",
                            "aggregation": "sum",
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Net Sales",
                            "aggregation": "sum",
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("netTaxBeforeDiscount", "Net Tax Before Discount", false),
                            "aggregation": "sum",
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax1", "Tax 1", false),
                            "aggregation": "sum",
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2", false),
                            "aggregation": "sum",
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Gross",
                            "formula": "sum(\"Gross\")",
                            "caption": "Sum of Gross",
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Over Pay(+)",
                            "aggregation": "sum",
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Short Pay(-)",
                            "aggregation": "sum",
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Received",
                            "formula": "sum(\"Received\")",
                            "caption": "Received",
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Avg Net Sales/Bill",
                            "formula": "if( \"Bill \" > 0, ( sum(\"Net Sales\") / \"Bill \" ), 0)",
                            "caption": "Avg Net Sales/Bill",
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Controller ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Controller Name",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Sale Type",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Date Time",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Date Time (YYYY-MM-DD)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Order No",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Status",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Table",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Pax",
                            "formula": "sum(\"Pax\")",
                            "caption": "Sum of Pax",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Total Dish(es)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Cancel Dish(es)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Waiter",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Cashier",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Agent",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Paid On",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("taxBeforeDiscount", "Tax Before Discount (%)", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("taxBeforeDiscount", "Tax Before Discount", false),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Paid Type",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Discount(%)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Sub Total",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax1", "Tax 1 (%)", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2 (%)", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Received-v1",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Note-v1",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Note",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Split No.",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "FilterType",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Gross (Exclude  Tax)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Received-v1 (Exclude  Tax)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Received (Exclude  Tax)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Table/Bill",
                            "formula": "sum(\"Table/Bill\")",
                            "caption": "Sum of Table/Bill",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Short Pay(-) -v1",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Over Pay(+) -v1",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Day of Week",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Date(Days)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Date(Month)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Date(Year)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Date(Week)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Hour of Day",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Date(HH:mm)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Block of 30 minutes",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Date(MM D, YYYY)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Date(YYYY-MM-DD)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Start Time",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "End Time",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "End Time (YYYY-MM-DD, hh:mm:ss)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Report No.",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Meal Time",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Quarter",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Period",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Cash",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Net Sales Percentage (%)",
                            "formula": "percentofcolumn(\"Net Sales\")",
                            "caption": "Net Sales Percentage (%)",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Sum of Taxes",
                            "formula": "sum(\""+ Filter.changeToNameSettings("netTaxBeforeDiscount", "Net Tax Before Discount", false) +"\") + sum(\""+Filter.changeToNameSettings("tax1", "Tax 1", false)+"\") + sum(\""+Filter.changeToNameSettings("tax2", "Tax 2", false)+"\")",
                            "caption": "Sum of Taxes",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Cash Rounding",
                            "formula": "sum(\"Short Pay(-)\") + sum(\"Over Pay(+)\")",
                            "caption": "Cash Rounding",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Gross Difference",
                            "formula": "difference(\"Gross\")",
                            "caption": "Gross Difference",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Gross Percentage Increase/Decrease (%)",
                            "formula": "%difference(\"Gross\")",
                            "caption": "Gross Percentage Increase/Decrease (%)",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        }
                    ]
                },
                "options": {
                    "grid": {
                        "type": "classic",
                        "showTotals": "off"
                    },
                    "chart": {
                        "type": "bar",
                        "activeMeasure": {
                            "uniqueName": ""
                        }
                    },
                    "showEmptyData": false,
                    "viewType": "grid"
                },
                "formats": [
                    {
                        "name": "",
                        "decimalPlaces": 2
                    },
                    {
                        "name": "-vn37cn3b05o00",
                        "decimalPlaces": -1
                    },
                    getFormats(),
                ]
            }
        },
        {
            "name": "Sales (Monthly)",
            "configuation": {
                "slice": {
                    "reportFilters": [
                        {
                            "uniqueName": "FilterType",
                            "filter": {
                                "members": [
                                    "filtertype.[individual bill summary]"
                                ]
                            },
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Controller Name",
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Status",
                            "filter": {
                                "members": [
                                    "status.[paid]"
                                ]
                            },
                            "sort": "unsorted"
                        }
                    ],
                    "rows": [
                        {
                            "uniqueName": "Date(Month)",
                            "sort": "unsorted"
                        }
                    ],
                    "columns": [
                        {
                            "uniqueName": "[Measures]"
                        }
                    ],
                    "measures": [
                        {
                            "uniqueName": "Bill ",
                            "formula": "Count(\"Order No\")",
                            "caption": "Bill ",
                            "format": "-4vq9nokjrrc00"
                        },
                        {
                            "uniqueName": "Sales",
                            "aggregation": "sum",
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Discount",
                            "aggregation": "sum",
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Net Sales",
                            "aggregation": "sum",
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Sum of Taxes",
                            "formula": "sum(\""+ Filter.changeToNameSettings("netTaxBeforeDiscount", "Net Tax Before Discount", false) +"\") + sum(\""+Filter.changeToNameSettings("tax1", "Tax 1", false)+"\") + sum(\""+Filter.changeToNameSettings("tax2", "Tax 2", false)+"\")",
                            "caption": "Sum of Taxes",
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Gross",
                            "formula": "sum(\"Gross\")",
                            "caption": "Sum of Gross",
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Cash Rounding",
                            "formula": "sum(\"Short Pay(-)\") + sum(\"Over Pay(+)\")",
                            "caption": "Cash Rounding",
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Received",
                            "formula": "sum(\"Received\")",
                            "caption": "Received",
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Avg Net Sales/Bill",
                            "formula": "if( \"Bill \" > 0, ( sum(\"Net Sales\") / \"Bill \" ), 0)",
                            "caption": "Avg Net Sales/Bill",
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Gross Percentage Increase/Decrease (%)",
                            "formula": "%difference(\"Net Sales\")",
                            "caption": "Net Sales Increase/Decrease (%)",
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Controller ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Controller Name",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Sale Type",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Date Time",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Date Time (YYYY-MM-DD)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Order No",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Status",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Table",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Pax",
                            "formula": "sum(\"Pax\")",
                            "caption": "Sum of Pax",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Total Dish(es)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Cancel Dish(es)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Waiter",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Cashier",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Agent",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Paid On",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Paid Type",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Discount(%)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Sub Total",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2 (%)", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2", false),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Received-v1",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Note-v1",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Note",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Split No.",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "FilterType",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Gross (Exclude  Tax)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Received-v1 (Exclude  Tax)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Received (Exclude  Tax)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Table/Bill",
                            "formula": "sum(\"Table/Bill\")",
                            "caption": "Sum of Table/Bill",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Short Pay(-) -v1",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Over Pay(+) -v1",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Short Pay(-)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Over Pay(+)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Day of Week",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Date(Days)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Date(Month)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Date(Year)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Date(Week)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Hour of Day",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Date(HH:mm)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Block of 30 minutes",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Date(MM D, YYYY)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Date(YYYY-MM-DD)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Start Time",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "End Time",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "End Time (YYYY-MM-DD, hh:mm:ss)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Report No.",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Meal Time",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Quarter",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Period",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Cash",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Net Sales Percentage (%)",
                            "formula": "percentofcolumn(\"Net Sales\")",
                            "caption": "Net Sales Percentage (%)",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Gross Difference",
                            "formula": "difference(\"Gross\")",
                            "caption": "Gross Difference",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        }
                    ]
                },
                "options": {
                    "grid": {
                        "type": "classic"
                    },
                    "chart": {
                        "activeMeasure": {
                            "uniqueName": ""
                        }
                    },
                    "showEmptyData": false,
                    "viewType": "grid"
                },
                "formats": [
                    {
                        "name": "",
                        "decimalPlaces": 2
                    },
                    {
                        "name": "-4vq9nokjrrc00",
                        "decimalPlaces": -1
                    },
                    getFormats(),
                ]
            }
        },
        {
            "name": "Sales Comparison",
            "configuation" : {
                "slice": {
                    "reportFilters": [
                        {
                            "uniqueName": "FilterType",
                            "filter": {
                                "members": [
                                    "filtertype.[individual bill summary]"
                                ]
                            },
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Controller Name",
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Status",
                            "filter": {
                                "members": [
                                    "status.[paid]"
                                ]
                            },
                            "sort": "unsorted"
                        }
                    ],
                    "rows": [
                        {
                            "uniqueName": "Period"
                        }
                    ],
                    "columns": [
                        {
                            "uniqueName": "[Measures]"
                        }
                    ],
                    "measures": [
                        {
                            "uniqueName": "Bill ",
                            "formula": "Count(\"Order No\")",
                            "caption": "Bill ",
                            "format": "-gvfx9vjkj4d00"
                        },
                        {
                            "uniqueName": "Sales",
                            "aggregation": "sum",
                            "format": "-gvfx9vjkj4d00"
                        },
                        {
                            "uniqueName": "Discount",
                            "aggregation": "sum",
                            "format": "-gvfx9vjkj4d00"
                        },
                        {
                            "uniqueName": "Net Sales",
                            "aggregation": "sum",
                            "format": "-gvfx9vjkj4d00"
                        },
                        {
                            "uniqueName": "Sum of Taxes",
                            "formula": "sum(\""+Filter.changeToNameSettings("netTaxBeforeDiscount", "Net Tax Before Discount", false)+"\") + sum(\""+ Filter.changeToNameSettings("tax1", "Tax 1", false) +"\") + sum(\""+ Filter.changeToNameSettings("tax2", "Tax 2", false) +"\")",
                            "caption": "Sum of Taxes",
                            "format": "-gvfx9vjkj4d00"
                        },
                        {
                            "uniqueName": "Gross",
                            "formula": "sum(\"Gross\")",
                            "caption": "Sum of Gross",
                            "format": "-gvfx9vjkj4d00"
                        },
                        {
                            "uniqueName": "Cash Rounding",
                            "formula": "sum(\"Short Pay(-)\") + sum(\"Over Pay(+)\")",
                            "caption": "Cash Rounding",
                            "format": "-gvfx9vjkj4d00"
                        },
                        {
                            "uniqueName": "Received",
                            "formula": "sum(\"Received\")",
                            "caption": "Received",
                            "format": "-gvfx9vjkj4d00"
                        },
                        {
                            "uniqueName": "Gross Percentage Increase/Decrease (%)",
                            "formula": "%difference(\"Net Sales\")",
                            "caption": "Net Sales Increase/Decrease (%)",
                            "format": "-gvfx9vjkj4d00"
                        },
                        {
                            "uniqueName": "Controller ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-gvfx9vjkj4d00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Controller Name",
                            "aggregation": "count",
                            "active": false,
                            "format": "-gvfx9vjkj4d00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Sale Type",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-gvfx9vjkj4d00"
                        },
                        {
                            "uniqueName": "Date Time",
                            "aggregation": "count",
                            "active": false,
                            "format": "-gvfx9vjkj4d00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Date Time (YYYY-MM-DD)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-gvfx9vjkj4d00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Order No",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-gvfx9vjkj4d00"
                        },
                        {
                            "uniqueName": "Status",
                            "aggregation": "count",
                            "active": false,
                            "format": "-gvfx9vjkj4d00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Table",
                            "aggregation": "count",
                            "active": false,
                            "format": "-gvfx9vjkj4d00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Pax",
                            "formula": "sum(\"Pax\")",
                            "caption": "Sum of Pax",
                            "active": false,
                            "format": "-gvfx9vjkj4d00"
                        },
                        {
                            "uniqueName": "Total Dish(es)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-gvfx9vjkj4d00"
                        },
                        {
                            "uniqueName": "Cancel Dish(es)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-gvfx9vjkj4d00"
                        },
                        {
                            "uniqueName": "Waiter",
                            "aggregation": "count",
                            "active": false,
                            "format": "-gvfx9vjkj4d00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Cashier",
                            "aggregation": "count",
                            "active": false,
                            "format": "-gvfx9vjkj4d00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Agent",
                            "aggregation": "count",
                            "active": false,
                            "format": "-gvfx9vjkj4d00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Paid On",
                            "aggregation": "count",
                            "active": false,
                            "format": "-gvfx9vjkj4d00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("taxBeforeDiscount", "Tax Before Discount (%)", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-gvfx9vjkj4d00"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("taxBeforeDiscount", "Tax Before Discount", false),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-gvfx9vjkj4d00"
                        },
                        {
                            "uniqueName": "Paid Type",
                            "aggregation": "count",
                            "active": false,
                            "format": "-gvfx9vjkj4d00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Discount(%)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-gvfx9vjkj4d00"
                        },
                        {
                            "uniqueName": "Sub Total",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-gvfx9vjkj4d00"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("netTaxBeforeDiscount", "Net Tax Before Discount", false),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-gvfx9vjkj4d00"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax1", "Tax 1 (%)", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-gvfx9vjkj4d00"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax1", "Tax 1", false),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-gvfx9vjkj4d00"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2 (%)", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-gvfx9vjkj4d00"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2", false),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-gvfx9vjkj4d00"
                        },
                        {
                            "uniqueName": "Received-v1",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-gvfx9vjkj4d00"
                        },
                        {
                            "uniqueName": "Note-v1",
                            "aggregation": "count",
                            "active": false,
                            "format": "-gvfx9vjkj4d00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Note",
                            "aggregation": "count",
                            "active": false,
                            "format": "-gvfx9vjkj4d00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Split No.",
                            "aggregation": "count",
                            "active": false,
                            "format": "-gvfx9vjkj4d00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "FilterType",
                            "aggregation": "count",
                            "active": false,
                            "format": "-gvfx9vjkj4d00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Gross (Exclude  Tax)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-gvfx9vjkj4d00"
                        },
                        {
                            "uniqueName": "Received-v1 (Exclude  Tax)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-gvfx9vjkj4d00"
                        },
                        {
                            "uniqueName": "Received (Exclude  Tax)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-gvfx9vjkj4d00"
                        },
                        {
                            "uniqueName": "Table/Bill",
                            "formula": "sum(\"Table/Bill\")",
                            "caption": "Sum of Table/Bill",
                            "active": false,
                            "format": "-gvfx9vjkj4d00"
                        },
                        {
                            "uniqueName": "Short Pay(-) -v1",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-gvfx9vjkj4d00"
                        },
                        {
                            "uniqueName": "Over Pay(+) -v1",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-gvfx9vjkj4d00"
                        },
                        {
                            "uniqueName": "Short Pay(-)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-gvfx9vjkj4d00"
                        },
                        {
                            "uniqueName": "Over Pay(+)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-gvfx9vjkj4d00"
                        },
                        {
                            "uniqueName": "Day of Week",
                            "aggregation": "count",
                            "active": false,
                            "format": "-gvfx9vjkj4d00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Date(Days)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-gvfx9vjkj4d00"
                        },
                        {
                            "uniqueName": "Date(Month)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-gvfx9vjkj4d00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Date(Year)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-gvfx9vjkj4d00"
                        },
                        {
                            "uniqueName": "Date(Week)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-gvfx9vjkj4d00"
                        },
                        {
                            "uniqueName": "Hour of Day",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-gvfx9vjkj4d00"
                        },
                        {
                            "uniqueName": "Date(HH:mm)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-gvfx9vjkj4d00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Block of 30 minutes",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-gvfx9vjkj4d00"
                        },
                        {
                            "uniqueName": "Date(MM D, YYYY)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-gvfx9vjkj4d00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Date(YYYY-MM-DD)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-gvfx9vjkj4d00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Start Time",
                            "aggregation": "count",
                            "active": false,
                            "format": "-gvfx9vjkj4d00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "End Time",
                            "aggregation": "count",
                            "active": false,
                            "format": "-gvfx9vjkj4d00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "End Time (YYYY-MM-DD, hh:mm:ss)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-gvfx9vjkj4d00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Report No.",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-gvfx9vjkj4d00"
                        },
                        {
                            "uniqueName": "Meal Time",
                            "aggregation": "count",
                            "active": false,
                            "format": "-gvfx9vjkj4d00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Quarter",
                            "aggregation": "count",
                            "active": false,
                            "format": "-gvfx9vjkj4d00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Period",
                            "aggregation": "count",
                            "active": false,
                            "format": "-gvfx9vjkj4d00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Cash",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-gvfx9vjkj4d00"
                        },
                        {
                            "uniqueName": "Avg Net Sales/Bill",
                            "formula": "if( \"Bill \" > 0, ( sum(\"Net Sales\") / \"Bill \" ), 0)",
                            "caption": "Avg Net Sales/Bill",
                            "active": false,
                            "format": "-gvfx9vjkj4d00"
                        },
                        {
                            "uniqueName": "Net Sales Percentage (%)",
                            "formula": "percentofcolumn(\"Net Sales\")",
                            "caption": "Net Sales Percentage (%)",
                            "active": false,
                            "format": "-gvfx9vjkj4d00"
                        },
                        {
                            "uniqueName": "Gross Difference",
                            "formula": "difference(\"Gross\")",
                            "caption": "Gross Difference",
                            "active": false,
                            "format": "-gvfx9vjkj4d00"
                        },
                        {
                            "uniqueName": "Bill",
                            "formula": "distinctcount(\"Order No\")",
                            "caption": "Bill",
                            "active": false,
                            "format": "-gvfx9vjkj4d00"
                        },
                        {
                            "uniqueName": "Avg Net Sales / Pax",
                            "formula": "if(sum(\"Net Sales\")>0,sum(\"Net Sales\") / sum(\"Pax\"),0)",
                            "caption": "Avg Net Sales / Pax",
                            "active": false,
                            "format": "-gvfx9vjkj4d00"
                        },
                        {
                            "uniqueName": "Avg Net Sales / Bill - 2",
                            "formula": "if(sum(\"Net Sales\")>0,sum(\"Net Sales\") / Count(\"Order No\"),0)",
                            "caption": "Avg Net Sales / Bill",
                            "active": false,
                            "format": "-gvfx9vjkj4d00"
                        },
                        {
                            "uniqueName": "Avg (Pax)",
                            "formula": "sum(\"Gross\") / sum(\"Pax\")",
                            "caption": "Avg (Pax)",
                            "active": false,
                            "format": "-gvfx9vjkj4d00"
                        },
                        {
                            "uniqueName": "Avg (Bill)",
                            "formula": "sum(\"Gross\") / sum(\"Table/Bill\")",
                            "caption": "Avg (Bill)",
                            "active": false,
                            "format": "-gvfx9vjkj4d00"
                        },
                        {
                            "uniqueName": "Avg Net Sales / Bill",
                            "formula": "sum(\"Net Sales\")",
                            "caption": "Avg Net Sales / Bill",
                            "active": false,
                            "format": "-gvfx9vjkj4d00"
                        }
                    ]
                },
                "options": {
                    "grid": {
                        "type": "classic"
                    },
                    "chart": {
                        "type": "bar",
                        "activeMeasure": {
                            "uniqueName": ""
                        }
                    },
                    "showEmptyData": false,
                    "viewType": "grid"
                },
                "formats": [
                    {
                        "name": "",
                        "decimalPlaces": 2
                    },
                    getFormats(),
                ]
            }
        },
        {
            "name": "Daily Sales Summary",
            "configuation": {
                "slice": {
                    "reportFilters": [
                        {
                            "uniqueName": "FilterType",
                            "filter": {
                                "members": [
                                    "filtertype.[individual bill summary]"
                                ]
                            },
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Controller Name"
                        },
                        {
                            "uniqueName": "Status",
                            "filter": {
                                "members": [
                                    "status.[paid]"
                                ]
                            }
                        }
                    ],
                    "rows": [
                        {
                            "uniqueName": "Date(YYYY-MM-DD)"
                        }
                    ],
                    "columns": [
                        {
                            "uniqueName": "[Measures]"
                        }
                    ],
                    "measures": [
                        {
                            "uniqueName": "Sales",
                            "aggregation": "sum",
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Controller ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Controller Name",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Sale Type",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Date Time",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Order No",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Status",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Table",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Pax",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Total Dish(es)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Cancel Dish(es)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Waiter",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Cashier",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Agent",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Paid On",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Service Charge (%)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Service Charge",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Paid Type",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Discount(%)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Discount",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Sub Total",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Net Sales",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Net Service Charge",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Gross",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Received-v1",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Note-v1",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Received",
                            "formula": "sum(\"Received\")",
                            "caption": "Received",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Note",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Split No.",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "FilterType",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Gross (Exclude  Tax)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Received-v1 (Exclude  Tax)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Received (Exclude  Tax)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Table/Bill",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Short Pay(-) -v1",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Over Pay(+) -v1",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Short Pay(-)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Over Pay(+)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Day of Week",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Date(Days)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Date(Month)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Date(Year)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Date(Week)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Hour of Day",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Block of 30 minutes",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Date(MM D, YYYY)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Start Time",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "End Time",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Report No.",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Meal Time",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Quarter",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Cash",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        }
                    ]
                },
                "options": {
                    "viewType": "charts",
                    "grid": {
                        "type": "classic",
                        "showTotals": "off",
                        "showGrandTotals": "off"
                    },
                    "chart": {
                        "type": "line"
                    }
                },
                "formats": [
                    {
                        "name": "-10ir2s6itv0ega"
                    },
                    getFormats(),
                ]
            }
        },
        {
            "name": "Hourly Revenue Comparison",
            "configuation": {
                "slice": {
                    "reportFilters": [
                        {
                            "uniqueName": "FilterType",
                            "filter": {
                                "members": [
                                    "filtertype.[individual bill summary]"
                                ]
                            },
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Controller Name"
                        },
                        {
                            "uniqueName": "Status",
                            "filter": {
                                "members": [
                                    "status.[paid]"
                                ]
                            }
                        }
                    ],
                    "rows": [
                        {
                            "uniqueName": "Hour of Day"
                        }
                    ],
                    "columns": [
                        {
                            "uniqueName": "Day of Week"
                        },
                        {
                            "uniqueName": "[Measures]"
                        }
                    ],
                    "measures": [
                        {
                            "uniqueName": "Sales",
                            "aggregation": "sum",
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Controller ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Controller Name",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Sale Type",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Date Time",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Date Time (YYYY-MM-DD)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Order No",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Status",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Table",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Pax",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Total Dish(es)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Cancel Dish(es)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Waiter",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Cashier",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Agent",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Paid On",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Service Charge (%)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Service Charge",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Paid Type",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Discount(%)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Discount",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Sub Total",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Net Sales",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Net Service Charge",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "SST (%)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "SST",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2 (%)", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2", false),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Gross",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Received-v1",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Note-v1",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Received",
                            "formula": "sum(\"Received\")",
                            "caption": "Received",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Note",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Split No.",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "FilterType",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Gross (Exclude  Tax)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Received-v1 (Exclude  Tax)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Received (Exclude  Tax)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Table/Bill",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Short Pay(-) -v1",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Over Pay(+) -v1",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Short Pay(-)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Over Pay(+)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Day of Week",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Date(Days)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Date(Month)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Date(Year)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Date(Week)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Hour of Day",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Date(HH:mm)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Block of 30 minutes",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Date(MM D, YYYY)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Date(YYYY-MM-DD)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Start Time",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "End Time",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "End Time (YYYY-MM-DD, hh:mm:ss)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Report No.",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        },
                        {
                            "uniqueName": "Meal Time",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Quarter",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Period",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Membership",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Discount Note",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10ir2s6itv0ega",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Cash",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10ir2s6itv0ega"
                        }
                    ]
                },
                "options": {
                    "viewType": "charts",
                    "grid": {
                        "type": "classic",
                        "showTotals": "off",
                        "showGrandTotals": "off"
                    },
                    "chart": {
                        "type": "line",
                        "activeMeasure": {
                            "uniqueName": ""
                        }
                    },
                    "showEmptyData": false
                },
                "formats": [
                    {
                        "name": "-10ir2s6itv0ega"
                    },
                    getFormats(),
                ]
            }
        }
    ],
    items: [
        {
            "name": "Default",
            "configuation": {
                "slice": {
                    "reportFilters": [
                        {
                            "uniqueName": "Controller Name",
                            "sort": "asc"
                        },
                        {
                            "uniqueName": "Status",
                            "sort": "asc"
                        }
                    ],
                    "rows": [
                        {
                            "uniqueName": "Name of Item",
                            "sort": "asc"
                        },
                        {
                            "uniqueName": "Master Item ID",
                            "sort": "asc"
                        },
                        {
                            "uniqueName": "Category",
                            "sort": "asc"
                        },
                        {
                            "uniqueName": "Category Sub",
                            "sort": "asc"
                        },
                        {
                            "uniqueName": "Parent",
                            "sort": "asc"
                        },
                        {
                            "uniqueName": "Prepare Station",
                            "sort": "asc"
                        },
                        {
                            "uniqueName": "Unit Original Price",
                            "sort": "asc"
                        },
                        {
                            "uniqueName": "Sale Type",
                            "sort": "asc"
                        },
                        {
                            "uniqueName": "Unit Selling Price",
                            "sort": "asc"
                        },
                        {
                            "uniqueName": "Agent",
                            "sort": "asc"
                        },
                        {
                            "uniqueName": "Comment",
                            "sort": "asc"
                        },
                        {
                            "uniqueName": "Waiter",
                            "sort": "asc"
                        },
                        {
                            "uniqueName": "Create",
                            "sort": "asc"
                        }
                    ],
                    "columns": [
                        {
                            "uniqueName": "[Measures]"
                        }
                    ],
                    "measures": [
                        {
                            "uniqueName": "Quantity",
                            "aggregation": "sum",
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Total Discount - 2",
                            "formula": "sum(\"Total Unit Discount\")+sum(\"Item (Bill Discount)\")",
                            "caption": "Total Discount - 2"
                        },
                        {
                            "uniqueName": "Item Sales",
                            "aggregation": "sum",
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Controller",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Controller Name",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Transaction ID",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Create",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Sale Type",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Master Item ID",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Name of Item",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Status",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Prepare Station",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Agent",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Waiter",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Membership ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Member Note",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Tax Type",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Bill Discount (%)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Unit Price After Item Disc",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Unit Selling Price",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Item Gross Sales",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Price Name",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Payment Type",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Order No",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Count Order",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Table No",
                            "active": false
                        },
                        {
                            "uniqueName": "Total Net Price",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Item (Bill Discount)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Name of Tax Before",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Tax Before(Taxable Amt)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Tax Before(%)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Tax Before",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Tax Before (Bill Discount)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Tax Before (After Bill Discount)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("netTaxBeforeDiscount", "Net Tax Before Discount", false),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Bill Discount",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Sub Total",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Gross",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Name of Tax 1",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax1", "Tax 1 (%)", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax1", "Tax 1", false) + "(Taxable Amt*)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Name of Tax 2",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2", false),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2", false) + "(Taxable Amt*)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Bill Discount (Note)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Complimentary by",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Shift",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Original Order No",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Reopen Bill",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "No. of Reopen Bill",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Unit Original Price",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Comment",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Unit Discount",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Unit Change",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Total Unit Discount",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Total Original Price",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Unit Discount(%)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Unit Discount Note",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "No. of Copy Bill Print",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Category",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Category Sub",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Promotion",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Paid Device ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Order Device ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Cancel Device ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Cancel by",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Payment Note",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Total Discount",
                            "formula": "sum(\"Total Unit Discount\")+sum(\"Item (Bill Discount)\")",
                            "caption": "Total Discount",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Create(Day of Week)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Create Date(Days)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Create Date(Month)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Create Date(Year)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Create Date(Week)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Create(Hour of Day)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Create (Block of 15 minutes)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Create Date(DD -MM-YYYY)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Create Date(YYYY-MM-DD)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify(Day of Week)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify Date(Days)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Modify Date(Month)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify Date(Year)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Modify Date(Week)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Modify(Hour of Day)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Modify (Block of 15 minutes)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Modify Date(DD-MM-YYYY)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify Date(YYYY-MM-DD)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Quarter",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "MealTime",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Parent",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Unit Discount - 2",
                            "formula": "sum(\"Total Unit Discount\")",
                            "caption": "Sum of Unit Discount",
                            "active": false
                        }
                    ]
                },
                "options": {
                    "grid": {
                        "type": "flat"
                    },
                    "viewType": "grid"
                }
            }
        },
        {
            "name": "Category",
            "configuation": {
                "slice": {
                    "reportFilters": [
                        {
                            "uniqueName": "Controller Name"
                        },
                        {
                            "uniqueName": "Status",
                            "filter": {
                                "members": [
                                    "status.[paid]"
                                ]
                            }
                        }
                    ],
                    "rows": [
                        {
                            "uniqueName": "Category"
                        },
                        {
                            "uniqueName": "Name of Item"
                        },
                        {
                            "uniqueName": "Unit Selling Price"
                        }
                    ],
                    "columns": [
                        {
                            "uniqueName": "[Measures]"
                        }
                    ],
                    "measures": [
                        {
                            "uniqueName": "Quantity",
                            "aggregation": "sum",
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Item Sales",
                            "formula": "sum(\"Item Sales\")",
                            "caption": "Sum of Item Sales",
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Controller",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Controller Name",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Transaction ID",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Create",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Sale Type",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Master Item ID",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Name of Item",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Status",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Prepare Station",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Agent",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Waiter",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Membership ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Member Note",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Tax Type",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Bill Discount (%)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Unit Price After Item Disc",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Unit Selling Price",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Item Gross Sales",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Price Name",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Payment Type",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Order No",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Count Order",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Table No",
                            "active": false
                        },
                        {
                            "uniqueName": "Total Net Price",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Item (Bill Discount)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Name of Tax Before",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Tax Before(Taxable Amt)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Tax Before(%)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Tax Before",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Tax Before (Bill Discount)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Tax Before (After Bill Discount)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("netTaxBeforeDiscount", "Net Tax Before Discount", false),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Bill Discount",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Sub Total",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Gross",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Name of Tax 1",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax1", "Tax 1 (%)", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax1", "Tax 1", false) + "(Taxable Amt*)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Name of Tax 2",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2", false),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2", false) + "(Taxable Amt*)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Bill Discount (Note)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Complimentary by",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Shift",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Original Order No",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Reopen Bill",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "No. of Reopen Bill",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Unit Original Price",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Comment",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Unit Discount",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Unit Change",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Total Unit Discount",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Total Original Price",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Unit Discount(%)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Unit Discount Note",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "No. of Copy Bill Print",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Category",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Category Sub",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Promotion",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Paid Device ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Order Device ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Cancel Device ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Cancel by",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Payment Note",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Total Discount",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Create(Day of Week)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Create Date(Days)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Create Date(Month)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Create Date(Year)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Create Date(Week)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Create(Hour of Day)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Create (Block of 15 minutes)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Create Date(DD -MM-YYYY)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Create Date(YYYY-MM-DD)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify(Day of Week)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify Date(Days)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Modify Date(Month)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify Date(Year)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Modify Date(Week)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Modify(Hour of Day)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Modify (Block of 15 minutes)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Modify Date(DD-MM-YYYY)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify Date(YYYY-MM-DD)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Quarter",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "MealTime",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Parent",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        }
                    ]
                },
                "options": {
                    "grid": {
                        "type": "classic",
                        "showTotals": "off"
                    },
                    "viewType": "grid"
                },
                "formats": [
                    {
                        "name": "-11i6750iv26uy9"
                    },
                    getFormats(),
                ]
            }
        },
        {
            "name": "Prepare Station",
            "configuation": {
                "slice": {
                    "reportFilters": [
                        {
                            "uniqueName": "Controller Name",
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Status",
                            "filter": {
                                "members": [
                                    "status.[paid]"
                                ]
                            }
                        }
                    ],
                    "rows": [
                        {
                            "uniqueName": "Prepare Station"
                        },
                        {
                            "uniqueName": "Name of Item",
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Unit Selling Price",
                            "sort": "unsorted"
                        }
                    ],
                    "columns": [
                        {
                            "uniqueName": "[Measures]"
                        }
                    ],
                    "measures": [
                        {
                            "uniqueName": "Item Sales",
                            "formula": "sum(\"Item Sales\")",
                            "caption": "Sum of Item Sales",
                            "format": "-n9j3xws80nbt"
                        },
                        {
                            "uniqueName": "Quantity",
                            "aggregation": "sum",
                            "format": "-n9j3xws80nbt"
                        },
                        {
                            "uniqueName": "Controller",
                            "aggregation": "count",
                            "active": false,
                            "format": "-n9j3xws80nbt",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Controller Name",
                            "aggregation": "count",
                            "active": false,
                            "format": "-n9j3xws80nbt",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Transaction ID",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-n9j3xws80nbt"
                        },
                        {
                            "uniqueName": "Create",
                            "aggregation": "count",
                            "active": false,
                            "format": "-n9j3xws80nbt",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify",
                            "aggregation": "count",
                            "active": false,
                            "format": "-n9j3xws80nbt",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Sale Type",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-n9j3xws80nbt"
                        },
                        {
                            "uniqueName": "Master Item ID",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-n9j3xws80nbt"
                        },
                        {
                            "uniqueName": "Name of Item",
                            "aggregation": "count",
                            "active": false,
                            "format": "-n9j3xws80nbt",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Status",
                            "aggregation": "count",
                            "active": false,
                            "format": "-n9j3xws80nbt",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Prepare Station",
                            "aggregation": "count",
                            "active": false,
                            "format": "-n9j3xws80nbt",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Agent",
                            "aggregation": "count",
                            "active": false,
                            "format": "-n9j3xws80nbt",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Waiter",
                            "aggregation": "count",
                            "active": false,
                            "format": "-n9j3xws80nbt",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Membership ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-n9j3xws80nbt",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Member Note",
                            "aggregation": "count",
                            "active": false,
                            "format": "-n9j3xws80nbt",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Tax Type",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-n9j3xws80nbt"
                        },
                        {
                            "uniqueName": "Bill Discount (%)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-n9j3xws80nbt"
                        },
                        {
                            "uniqueName": "Unit Price After Item Disc",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-n9j3xws80nbt"
                        },
                        {
                            "uniqueName": "Unit Selling Price",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-n9j3xws80nbt"
                        },
                        {
                            "uniqueName": "Item Gross Sales",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-n9j3xws80nbt"
                        },
                        {
                            "uniqueName": "Price Name",
                            "aggregation": "count",
                            "active": false,
                            "format": "-n9j3xws80nbt",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Payment Type",
                            "aggregation": "count",
                            "active": false,
                            "format": "-n9j3xws80nbt",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Order No",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-n9j3xws80nbt"
                        },
                        {
                            "uniqueName": "Count Order",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-n9j3xws80nbt"
                        },
                        {
                            "uniqueName": "Table No",
                            "active": false
                        },
                        {
                            "uniqueName": "Total Net Price",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-n9j3xws80nbt"
                        },
                        {
                            "uniqueName": "Item (Bill Discount)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-n9j3xws80nbt"
                        },
                        {
                            "uniqueName": "Name of Tax Before",
                            "aggregation": "count",
                            "active": false,
                            "format": "-n9j3xws80nbt",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Tax Before(Taxable Amt)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-n9j3xws80nbt"
                        },
                        {
                            "uniqueName": "Tax Before(%)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-n9j3xws80nbt"
                        },
                        {
                            "uniqueName": "Tax Before",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-n9j3xws80nbt"
                        },
                        {
                            "uniqueName": "Tax Before (Bill Discount)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-n9j3xws80nbt"
                        },
                        {
                            "uniqueName": "Tax Before (After Bill Discount)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-n9j3xws80nbt"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("netTaxBeforeDiscount", "Net Tax Before Discount", false),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-n9j3xws80nbt"
                        },
                        {
                            "uniqueName": "Bill Discount",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-n9j3xws80nbt"
                        },
                        {
                            "uniqueName": "Sub Total",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-n9j3xws80nbt"
                        },
                        {
                            "uniqueName": "Gross",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-n9j3xws80nbt"
                        },
                        {
                            "uniqueName": "Name of Tax 1",
                            "aggregation": "count",
                            "active": false,
                            "format": "-n9j3xws80nbt",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-n9j3xws80nbt"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax1", "Tax 1 (%)", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-n9j3xws80nbt"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax1", "Tax 1", false) + "(Taxable Amt*)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-n9j3xws80nbt"
                        },
                        {
                            "uniqueName": "Name of Tax 2",
                            "aggregation": "count",
                            "active": false,
                            "format": "-n9j3xws80nbt",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2", false),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-n9j3xws80nbt"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-n9j3xws80nbt"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2", false) + "(Taxable Amt*)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-n9j3xws80nbt"
                        },
                        {
                            "uniqueName": "Bill Discount (Note)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-n9j3xws80nbt",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Complimentary by",
                            "aggregation": "count",
                            "active": false,
                            "format": "-n9j3xws80nbt",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Shift",
                            "aggregation": "count",
                            "active": false,
                            "format": "-n9j3xws80nbt",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Original Order No",
                            "aggregation": "count",
                            "active": false,
                            "format": "-n9j3xws80nbt",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Reopen Bill",
                            "aggregation": "count",
                            "active": false,
                            "format": "-n9j3xws80nbt",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "No. of Reopen Bill",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-n9j3xws80nbt"
                        },
                        {
                            "uniqueName": "Unit Original Price",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-n9j3xws80nbt"
                        },
                        {
                            "uniqueName": "Comment",
                            "aggregation": "count",
                            "active": false,
                            "format": "-n9j3xws80nbt",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Unit Discount",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-n9j3xws80nbt"
                        },
                        {
                            "uniqueName": "Unit Change",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-n9j3xws80nbt"
                        },
                        {
                            "uniqueName": "Total Unit Discount",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-n9j3xws80nbt"
                        },
                        {
                            "uniqueName": "Total Original Price",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-n9j3xws80nbt"
                        },
                        {
                            "uniqueName": "Unit Discount(%)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-n9j3xws80nbt"
                        },
                        {
                            "uniqueName": "Unit Discount Note",
                            "aggregation": "count",
                            "active": false,
                            "format": "-n9j3xws80nbt",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "No. of Copy Bill Print",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-n9j3xws80nbt"
                        },
                        {
                            "uniqueName": "Category",
                            "aggregation": "count",
                            "active": false,
                            "format": "-n9j3xws80nbt",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Category Sub",
                            "aggregation": "count",
                            "active": false,
                            "format": "-n9j3xws80nbt",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Promotion",
                            "aggregation": "count",
                            "active": false,
                            "format": "-n9j3xws80nbt",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Paid Device ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-n9j3xws80nbt",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Order Device ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-n9j3xws80nbt",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Cancel Device ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-n9j3xws80nbt",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Cancel by",
                            "aggregation": "count",
                            "active": false,
                            "format": "-n9j3xws80nbt",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Payment Note",
                            "aggregation": "count",
                            "active": false,
                            "format": "-n9j3xws80nbt",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Total Discount",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-n9j3xws80nbt"
                        },
                        {
                            "uniqueName": "Create(Day of Week)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-n9j3xws80nbt",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Create Date(Days)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-n9j3xws80nbt"
                        },
                        {
                            "uniqueName": "Create Date(Month)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-n9j3xws80nbt",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Create Date(Year)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-n9j3xws80nbt"
                        },
                        {
                            "uniqueName": "Create Date(Week)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-n9j3xws80nbt"
                        },
                        {
                            "uniqueName": "Create(Hour of Day)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-n9j3xws80nbt"
                        },
                        {
                            "uniqueName": "Create (Block of 15 minutes)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-n9j3xws80nbt"
                        },
                        {
                            "uniqueName": "Create Date(DD -MM-YYYY)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-n9j3xws80nbt",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Create Date(YYYY-MM-DD)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-n9j3xws80nbt",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify(Day of Week)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-n9j3xws80nbt",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify Date(Days)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-n9j3xws80nbt"
                        },
                        {
                            "uniqueName": "Modify Date(Month)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-n9j3xws80nbt",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify Date(Year)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-n9j3xws80nbt"
                        },
                        {
                            "uniqueName": "Modify Date(Week)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-n9j3xws80nbt"
                        },
                        {
                            "uniqueName": "Modify(Hour of Day)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-n9j3xws80nbt"
                        },
                        {
                            "uniqueName": "Modify (Block of 15 minutes)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-n9j3xws80nbt"
                        },
                        {
                            "uniqueName": "Modify Date(DD-MM-YYYY)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-n9j3xws80nbt",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify Date(YYYY-MM-DD)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-n9j3xws80nbt",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Quarter",
                            "aggregation": "count",
                            "active": false,
                            "format": "-n9j3xws80nbt",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "MealTime",
                            "aggregation": "count",
                            "active": false,
                            "format": "-n9j3xws80nbt",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Parent",
                            "aggregation": "count",
                            "active": false,
                            "format": "-n9j3xws80nbt",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        }
                    ],
                },
                "options": {
                    "grid": {
                        "type": "classic",
                        "showTotals": "off"
                    },
                    "viewType": "grid"
                },
                "formats": [
                    {
                        "name": "-n9j3xws80nbt"
                    },
                    getFormats(),
                ]
            }
        },
        {
            "name": "Promotion",
            "configuation": {
                "slice": {
                    "reportFilters": [
                        {
                            "uniqueName": "Controller Name",
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Status",
                            "filter": {
                                "members": [
                                    "status.[paid]"
                                ]
                            }
                        }
                    ],
                    "rows": [
                        {
                            "uniqueName": "Promotion",
                            "filter": {
                                "exclude": [
                                    "promotion.[n.a.]"
                                ]
                            }
                        },
                        {
                            "uniqueName": "Category"
                        },
                        {
                            "uniqueName": "Name of Item",
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Unit Selling Price",
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Unit Change"
                        },
                        {
                            "uniqueName": "Unit Discount"
                        }
                    ],
                    "columns": [
                        {
                            "uniqueName": "[Measures]"
                        }
                    ],
                    "measures": [
                        {
                            "uniqueName": "Quantity",
                            "aggregation": "sum",
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Item Sales",
                            "formula": "sum(\"Item Sales\")",
                            "caption": "Sum of Item Sales",
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Controller",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Controller Name",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Transaction ID",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Create",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Sale Type",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Master Item ID",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Name of Item",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Status",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Prepare Station",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Agent",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Waiter",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Membership ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Member Note",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Tax Type",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Bill Discount (%)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Unit Price After Item Disc",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Unit Selling Price",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Item Gross Sales",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Price Name",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Payment Type",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Order No",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Count Order",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Table No",
                            "active": false
                        },
                        {
                            "uniqueName": "Total Net Price",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Item (Bill Discount)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Name of Tax Before",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Tax Before(Taxable Amt)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Tax Before(%)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Tax Before",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Tax Before (Bill Discount)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Tax Before (After Bill Discount)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("netTaxBeforeDiscount", "Net Tax Before Discount", false),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Bill Discount",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Sub Total",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Gross",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Name of Tax 1",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax1", "Tax 1 (%)", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax1", "Tax 1", false) + "(Taxable Amt*)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Name of Tax 2",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2", false),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2", false) + "(Taxable Amt*)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Bill Discount (Note)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Complimentary by",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Shift",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Original Order No",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Reopen Bill",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "No. of Reopen Bill",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Unit Original Price",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Comment",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Unit Discount",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Unit Change",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Total Unit Discount",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Total Original Price",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Unit Discount(%)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Unit Discount Note",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "No. of Copy Bill Print",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Category",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Category Sub",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Promotion",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Paid Device ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Order Device ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Cancel Device ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Cancel by",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Payment Note",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Total Discount",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Create(Day of Week)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Create Date(Days)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Create Date(Month)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Create Date(Year)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Create Date(Week)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Create(Hour of Day)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Create (Block of 15 minutes)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Create Date(DD -MM-YYYY)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Create Date(YYYY-MM-DD)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify(Day of Week)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify Date(Days)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Modify Date(Month)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify Date(Year)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Modify Date(Week)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Modify(Hour of Day)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Modify (Block of 15 minutes)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-11i6750iv26uy9"
                        },
                        {
                            "uniqueName": "Modify Date(DD-MM-YYYY)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify Date(YYYY-MM-DD)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Quarter",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "MealTime",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Parent",
                            "aggregation": "count",
                            "active": false,
                            "format": "-11i6750iv26uy9",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        }
                    ]
                },
                "options": {
                    "grid": {
                        "type": "classic",
                        "showTotals": "off"
                    },
                    "viewType": "grid"
                }
            }
        },
        {
            "name": "Membership",
            "configuation": {
                "slice": {
                    "reportFilters": [
                        {
                            "uniqueName": "Controller Name"
                        },
                        {
                            "uniqueName": "Status",
                            "filter": {
                                "members": [
                                    "status.[paid]"
                                ]
                            }
                        }
                    ],
                    "rows": [
                        {
                            "uniqueName": "Membership ID",
                            "filter": {
                                "exclude": [
                                    "membership id.[]"
                                ]
                            }
                        },
                        {
                            "uniqueName": "Bill Discount (%)"
                        },
                        {
                            "uniqueName": "Name of Item"
                        }
                    ],
                    "columns": [
                        {
                            "uniqueName": "[Measures]"
                        }
                    ],
                    "measures": [
                        {
                            "uniqueName": "Quantity",
                            "aggregation": "sum"
                        },
                        {
                            "uniqueName": "Item Sales",
                            "aggregation": "sum"
                        }
                    ]
                },
                "options": {
                    "grid": {
                        "type": "classic",
                        "showTotals": "off"
                    },
                    "viewType": "grid"
                }
            }
        },
        {
            "name": "Waiter",
            "configuation": {
                "slice": {
                    "reportFilters": [
                        {
                            "uniqueName": "Controller Name"
                        },
                        {
                            "uniqueName": "Status",
                            "filter": {
                                "members": [
                                    "status.[paid]"
                                ]
                            }
                        }
                    ],
                    "rows": [
                        {
                            "uniqueName": "Waiter"
                        },
                        {
                            "uniqueName": "Name of Item"
                        }
                    ],
                    "columns": [
                        {
                            "uniqueName": "[Measures]"
                        }
                    ],
                    "measures": [
                        {
                            "uniqueName": "Quantity",
                            "aggregation": "sum"
                        },
                        {
                            "uniqueName": "Item Sales",
                            "aggregation": "sum"
                        }
                    ]
                },
                "options": {
                    "grid": {
                        "type": "classic"
                    },
                    "viewType": "grid"
                }
            }
        },
        {
            "name": "Discount (Bill)",
            "configuation": {
                "slice": {
                    "reportFilters": [
                        {
                            "uniqueName": "Controller Name"
                        },
                        {
                            "uniqueName": "Status"
                        }
                    ],
                    "rows": [
                        {
                            "uniqueName": "Order No"
                        },
                        {
                            "uniqueName": "Name of Item"
                        },
                        {
                            "uniqueName": "Unit Original Price"
                        },
                        {
                            "uniqueName": "Unit Discount(%)"
                        },
                        {
                            "uniqueName": "Unit Price After Item Disc"
                        },
                        {
                            "uniqueName": "Bill Discount (%)"
                        },
                        {
                            "uniqueName": "Unit Selling Price"
                        }
                    ],
                    "columns": [
                        {
                            "uniqueName": "[Measures]"
                        }
                    ],
                    "measures": [
                        {
                            "uniqueName": "Unit Discount",
                            "aggregation": "sum",
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Item (Bill Discount)",
                            "aggregation": "sum",
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Total Discount - 2",
                            "formula": "sum(\"Total Unit Discount\")+sum(\"Item (Bill Discount)\")",
                            "caption": "Total Discount - 2"
                        },
                        {
                            "uniqueName": "Controller",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Controller Name",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Transaction ID",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Create",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Sale Type",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Quantity",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Master Item ID",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Name of Item",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Status",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Prepare Station",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Agent",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Waiter",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Membership ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Member Note",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Tax Type",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Bill Discount (%)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Unit Price After Item Disc",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Unit Selling Price",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Item Gross Sales",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Item Sales",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Price Name",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Payment Type",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Order No",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Count Order",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Table No",
                            "active": false,
                        },
                        {
                            "uniqueName": "Total Net Price",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Name of Tax Before",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Tax Before(Taxable Amt)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Tax Before(%)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Tax Before",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Tax Before (Bill Discount)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Tax Before (After Bill Discount)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("netTaxBeforeDiscount", "Net Tax Before Discount", false),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Bill Discount",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Sub Total",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Gross",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Name of Tax 1",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax1", "Tax 1 (%)", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax1", "Tax 1", false) + "(Taxable Amt*)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Name of Tax 2",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2", false),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2", false) + "(Taxable Amt*)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Bill Discount (Note)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Complimentary by",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Shift",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Original Order No",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Reopen Bill",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "No. of Reopen Bill",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Unit Original Price",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Comment",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Unit Change",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Total Unit Discount",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Total Original Price",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Unit Discount(%)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Unit Discount Note",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "No. of Copy Bill Print",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Category",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Category Sub",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Promotion",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Paid Device ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Order Device ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Cancel Device ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Cancel by",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Payment Note",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Total Discount",
                            "formula": "percentofcolumns( sum(\"Item Sale\") )",
                            "caption": "Total Discount",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Create(Day of Week)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Create Date(Days)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Create Date(Month)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Create Date(Year)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Create Date(Week)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Create(Hour of Day)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Create (Block of 15 minutes)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Create Date(DD -MM-YYYY)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Create Date(YYYY-MM-DD)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify(Day of Week)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify Date(Days)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Modify Date(Month)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify Date(Year)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Modify Date(Week)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Modify(Hour of Day)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Modify (Block of 15 minutes)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Modify Date(DD-MM-YYYY)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify Date(YYYY-MM-DD)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Quarter",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "MealTime",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Parent",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Unit Discount - 2",
                            "formula": "sum(\"Total Unit Discount\")",
                            "caption": "Sum of Unit Discount",
                            "active": false
                        }
                    ]
                },
                "options": {
                    "grid": {
                        "type": "classic",
                        "showTotals": "off"
                    },
                    "viewType": "grid"
                },
                "formats": [
                    {
                        "name": "-brtiysj6dg63r"
                    },
                    {
                        "name": "",
                        "decimalPlaces": 2,
                        "nullValue": "0"
                    },
                    getFormats(),
                ]
            }
        },
        {
            "name": "Discount (Items)",
            "configuation": {
                "slice": {
                    "reportFilters": [
                        {
                            "uniqueName": "Controller Name"
                        },
                        {
                            "uniqueName": "Status"
                        }
                    ],
                    "rows": [
                        {
                            "uniqueName": "Name of Item"
                        },
                        {
                            "uniqueName": "Unit Selling Price"
                        },
                        {
                            "uniqueName": "Unit Original Price"
                        },
                        {
                            "uniqueName": "Unit Price After Item Disc"
                        },
                        {
                            "uniqueName": "Unit Discount"
                        }
                    ],
                    "columns": [
                        {
                            "uniqueName": "[Measures]"
                        }
                    ],
                    "measures": [
                        {
                            "uniqueName": "Quantity",
                            "aggregation": "sum",
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Total Unit Discount",
                            "aggregation": "sum",
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Item (Bill Discount)",
                            "aggregation": "sum",
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Total Discount",
                            "formula": "sum(\"Total Unit Discount\")+sum(\"Item (Bill Discount)\")",
                            "caption": "Total Discount",
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Controller",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Controller Name",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Transaction ID",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Create",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Sale Type",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Master Item ID",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Name of Item",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Status",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Prepare Station",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Agent",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Waiter",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Membership ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Member Note",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Tax Type",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Bill Discount (%)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Unit Price After Item Disc",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Unit Selling Price",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Item Gross Sales",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Item Sales",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Price Name",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Payment Type",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Order No",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Count Order",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Table No",
                            "active": false
                        },
                        {
                            "uniqueName": "Total Net Price",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Name of Tax Before",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Tax Before(Taxable Amt)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Tax Before(%)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Tax Before",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Tax Before (Bill Discount)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Tax Before (After Bill Discount)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("netTaxBeforeDiscount", "Net Tax Before Discount", false),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Bill Discount",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Sub Total",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Gross",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Name of Tax 1",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax1", "Tax 1 (%)", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax1", "Tax 1", false) + "(Taxable Amt*)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Name of Tax 2",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2", false),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2", false) + "(Taxable Amt*)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Bill Discount (Note)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Complimentary by",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Shift",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Original Order No",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Reopen Bill",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "No. of Reopen Bill",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Unit Original Price",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Comment",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Unit Discount",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Unit Change",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Total Original Price",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Unit Discount(%)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Unit Discount Note",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "No. of Copy Bill Print",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Category",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Category Sub",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Promotion",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Paid Device ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Order Device ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Cancel Device ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Cancel by",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Payment Note",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Create(Day of Week)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Create Date(Days)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Create Date(Month)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Create Date(Year)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Create Date(Week)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Create(Hour of Day)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Create (Block of 15 minutes)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Create Date(DD -MM-YYYY)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Create Date(YYYY-MM-DD)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify(Day of Week)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify Date(Days)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Modify Date(Month)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify Date(Year)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Modify Date(Week)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Modify(Hour of Day)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Modify (Block of 15 minutes)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Modify Date(DD-MM-YYYY)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify Date(YYYY-MM-DD)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Quarter",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "MealTime",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Parent",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Unit Discount - 2",
                            "formula": "sum(\"Total Unit Discount\")",
                            "caption": "Sum of Unit Discount",
                            "active": false
                        }
                    ],
                },
                "options": {
                    "grid": {
                        "type": "classic",
                        "showTotals": "off"
                    },
                    "viewType": "grid"
                },
                "formats": [
                    {
                        "name": "-brtiysj6dg63r"
                    },
                    {
                        "name": "",
                        "decimalPlaces": 2,
                        "nullValue": "0"
                    },
                    getFormats(),
                ]
            }
        },
        {
            "name": "Wastage/Free",
            "configuation": {
                "slice": {
                    "reportFilters": [
                        {
                            "uniqueName": "Controller Name"
                        },
                        {
                            "uniqueName": "Status"
                        },
                        {
                            "uniqueName": "Unit Discount(%)",
                            "filter": {
                                "exclude": [
                                    "unit discount(%).[20]",
                                    "unit discount(%).[0]"
                                ]
                            }
                        }
                    ],
                    "rows": [
                        {
                            "uniqueName": "Unit Discount Note"
                        },
                        {
                            "uniqueName": "Name of Item"
                        }
                    ],
                    "columns": [
                        {
                            "uniqueName": "[Measures]"
                        }
                    ],
                    "measures": [
                        {
                            "uniqueName": "Quantity",
                            "aggregation": "sum"
                        }
                    ],
                },
                "options": {
                    "grid": {
                        "type": "classic",
                        "showTotals": "off"
                    },
                    "viewType": "grid"
                }
            }
        },
        {
            "name": "Item Sales",
            "configuation": {
                "slice": {
                    "reportFilters": [
                        {
                            "uniqueName": "Controller Name",
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Status",
                            "filter": {
                                "exclude": [
                                    "status.[cooking]",
                                    "status.[confirming]",
                                    "status.[delivered]"
                                ]
                            },
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Prepare Station",
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Category",
                            "sort": "unsorted"
                        }
                    ],
                    "rows": [
                        {
                            "uniqueName": "Name of Item",
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Unit Selling Price",
                            "sort": "unsorted"
                        }
                    ],
                    "columns": [
                        {
                            "uniqueName": "[Measures]"
                        }
                    ],
                    "measures": [
                        {
                            "uniqueName": "Quantity",
                            "aggregation": "sum",
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Item Sales",
                            "formula": "sum(\"Item Sales\")",
                            "caption": "Sum of Item Sales",
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Controller",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Controller Name",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Transaction ID",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Create",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Sale Type",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Master Item ID",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Name of Item",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Status",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Prepare Station",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Agent",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Waiter",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Membership ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Member Note",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Tax Type",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Bill Discount (%)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Unit Price After Item Disc",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Unit Selling Price",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Item Gross Sales",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Price Name",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Payment Type",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Order No",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Count Order",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Table No",
                            "active": false
                        },
                        {
                            "uniqueName": "Total Net Price",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Item (Bill Discount)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Name of Tax Before",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Tax Before(Taxable Amt)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Tax Before(%)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Tax Before",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Tax Before (Bill Discount)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Tax Before (After Bill Discount)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("netTaxBeforeDiscount", "Net Tax Before Discount", false),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Bill Discount",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Sub Total",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Gross",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Name of Tax 1",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax1", "Tax 1 (%)", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax1", "Tax 1", false) + "(Taxable Amt*)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Name of Tax 2",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2", false),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2", false) + "(Taxable Amt*)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Bill Discount (Note)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Complimentary by",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Shift",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Original Order No",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Reopen Bill",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "No. of Reopen Bill",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Unit Original Price",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Comment",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Unit Discount",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Unit Change",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Total Unit Discount",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Total Original Price",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Unit Discount(%)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Unit Discount Note",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "No. of Copy Bill Print",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Category",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Category Sub",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Promotion",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Paid Device ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Order Device ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Cancel Device ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Cancel by",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Payment Note",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Total Discount",
                            "formula": "sum(\"Total Unit Discount\")+sum(\"Item (Bill Discount)\")",
                            "caption": "Total Discount",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Create(Day of Week)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Create Date(Days)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Create Date(Month)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Create Date(Year)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Create Date(Week)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Create(Hour of Day)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Create (Block of 15 minutes)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Create Date(DD -MM-YYYY)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Create Date(YYYY-MM-DD)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify(Day of Week)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify Date(Days)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Modify Date(Month)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify Date(Year)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Modify Date(Week)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Modify(Hour of Day)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Modify (Block of 15 minutes)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Modify Date(DD-MM-YYYY)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify Date(YYYY-MM-DD)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Quarter",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "MealTime",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Parent",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Total Discount - 2",
                            "formula": "sum(\"Total Unit Discount\")+sum(\"Item (Bill Discount)\")",
                            "caption": "Total Discount - 2",
                            "active": false
                        },
                        {
                            "uniqueName": "Unit Discount - 2",
                            "formula": "sum(\"Total Unit Discount\")",
                            "caption": "Sum of Unit Discount",
                            "active": false
                        }
                    ]
                },
                "options": {
                    "grid": {
                        "type": "classic"
                    },
                    "viewType": "grid"
                },
                "formats": [
                    getFormats(),
                ]
            }
        },
        {
            "name": "Item Sales (MealTime)",
            "configuation": {
                "slice": {
                    "reportFilters": [
                        {
                            "uniqueName": "Controller Name",
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Status",
                            "filter": {
                                "exclude": [
                                    "status.[cooking]",
                                    "status.[confirming]",
                                    "status.[delivered]"
                                ]
                            },
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Prepare Station",
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Category",
                            "sort": "unsorted"
                        }
                    ],
                    "rows": [
                        {
                            "uniqueName": "Name of Item",
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Unit Selling Price",
                            "sort": "unsorted"
                        }
                    ],
                    "columns": [
                        {
                            "uniqueName": "MealTime",
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "[Measures]"
                        }
                    ],
                    "measures": [
                        {
                            "uniqueName": "Quantity",
                            "aggregation": "sum",
                            "format": "-1a9um5cv18yn00"
                        },
                        {
                            "uniqueName": "Item Sales",
                            "formula": "sum(\"Item Sales\")",
                            "caption": "Sum of Item Sales",
                            "format": "-14g8dm2jclft00"
                        },
                        {
                            "uniqueName": "Controller",
                            "aggregation": "count",
                            "active": false,
                            "format": "-e9476r98co200",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Controller Name",
                            "aggregation": "count",
                            "active": false,
                            "format": "-e9476r98co200",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Transaction ID",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-e9476r98co200"
                        },
                        {
                            "uniqueName": "Create",
                            "aggregation": "count",
                            "active": false,
                            "format": "-e9476r98co200",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify",
                            "aggregation": "count",
                            "active": false,
                            "format": "-e9476r98co200",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Sale Type",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-e9476r98co200"
                        },
                        {
                            "uniqueName": "Master Item ID",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-e9476r98co200"
                        },
                        {
                            "uniqueName": "Name of Item",
                            "aggregation": "count",
                            "active": false,
                            "format": "-e9476r98co200",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Status",
                            "aggregation": "count",
                            "active": false,
                            "format": "-e9476r98co200",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Prepare Station",
                            "aggregation": "count",
                            "active": false,
                            "format": "-e9476r98co200",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Agent",
                            "aggregation": "count",
                            "active": false,
                            "format": "-e9476r98co200",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Waiter",
                            "aggregation": "count",
                            "active": false,
                            "format": "-e9476r98co200",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Membership ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-e9476r98co200",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Member Note",
                            "aggregation": "count",
                            "active": false,
                            "format": "-e9476r98co200",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Tax Type",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-e9476r98co200"
                        },
                        {
                            "uniqueName": "Bill Discount (%)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-e9476r98co200"
                        },
                        {
                            "uniqueName": "Unit Price After Item Disc",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-e9476r98co200"
                        },
                        {
                            "uniqueName": "Unit Selling Price",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-e9476r98co200"
                        },
                        {
                            "uniqueName": "Item Gross Sales",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-e9476r98co200"
                        },
                        {
                            "uniqueName": "Price Name",
                            "aggregation": "count",
                            "active": false,
                            "format": "-e9476r98co200",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Payment Type",
                            "aggregation": "count",
                            "active": false,
                            "format": "-e9476r98co200",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Order No",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-e9476r98co200"
                        },
                        {
                            "uniqueName": "Count Order",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-e9476r98co200"
                        },
                        {
                            "uniqueName": "Table No",
                            "active": false
                        },
                        {
                            "uniqueName": "Total Net Price",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-e9476r98co200"
                        },
                        {
                            "uniqueName": "Item (Bill Discount)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-e9476r98co200"
                        },
                        {
                            "uniqueName": "Name of Tax Before",
                            "aggregation": "count",
                            "active": false,
                            "format": "-e9476r98co200",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Tax Before(Taxable Amt)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-e9476r98co200"
                        },
                        {
                            "uniqueName": "Tax Before(%)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-e9476r98co200"
                        },
                        {
                            "uniqueName": "Tax Before",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-e9476r98co200"
                        },
                        {
                            "uniqueName": "Tax Before (Bill Discount)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-e9476r98co200"
                        },
                        {
                            "uniqueName": "Tax Before (After Bill Discount)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-e9476r98co200"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("netTaxBeforeDiscount", "Net Tax Before Discount", false),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-e9476r98co200"
                        },
                        {
                            "uniqueName": "Bill Discount",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-e9476r98co200"
                        },
                        {
                            "uniqueName": "Sub Total",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-e9476r98co200"
                        },
                        {
                            "uniqueName": "Gross",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-e9476r98co200"
                        },
                        {
                            "uniqueName": "Name of Tax 1",
                            "aggregation": "count",
                            "active": false,
                            "format": "-e9476r98co200",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-e9476r98co200"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax1", "Tax 1 (%)", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-e9476r98co200"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax1", "Tax 1", false) + "(Taxable Amt*)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-e9476r98co200"
                        },
                        {
                            "uniqueName": "Name of Tax 2",
                            "aggregation": "count",
                            "active": false,
                            "format": "-e9476r98co200",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2", false),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-e9476r98co200"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-e9476r98co200"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2", false) + "(Taxable Amt*)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-e9476r98co200"
                        },
                        {
                            "uniqueName": "Bill Discount (Note)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-e9476r98co200",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Complimentary by",
                            "aggregation": "count",
                            "active": false,
                            "format": "-e9476r98co200",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Shift",
                            "aggregation": "count",
                            "active": false,
                            "format": "-e9476r98co200",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Original Order No",
                            "aggregation": "count",
                            "active": false,
                            "format": "-e9476r98co200",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Reopen Bill",
                            "aggregation": "count",
                            "active": false,
                            "format": "-e9476r98co200",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "No. of Reopen Bill",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-e9476r98co200"
                        },
                        {
                            "uniqueName": "Unit Original Price",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-e9476r98co200"
                        },
                        {
                            "uniqueName": "Comment",
                            "aggregation": "count",
                            "active": false,
                            "format": "-e9476r98co200",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Unit Discount",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-e9476r98co200"
                        },
                        {
                            "uniqueName": "Unit Change",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-e9476r98co200"
                        },
                        {
                            "uniqueName": "Total Unit Discount",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-e9476r98co200"
                        },
                        {
                            "uniqueName": "Total Original Price",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-e9476r98co200"
                        },
                        {
                            "uniqueName": "Unit Discount(%)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-e9476r98co200"
                        },
                        {
                            "uniqueName": "Unit Discount Note",
                            "aggregation": "count",
                            "active": false,
                            "format": "-e9476r98co200",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "No. of Copy Bill Print",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-e9476r98co200"
                        },
                        {
                            "uniqueName": "Category",
                            "aggregation": "count",
                            "active": false,
                            "format": "-e9476r98co200",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Category Sub",
                            "aggregation": "count",
                            "active": false,
                            "format": "-e9476r98co200",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Promotion",
                            "aggregation": "count",
                            "active": false,
                            "format": "-e9476r98co200",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Paid Device ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-e9476r98co200",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Order Device ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-e9476r98co200",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Cancel Device ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-e9476r98co200",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Cancel by",
                            "aggregation": "count",
                            "active": false,
                            "format": "-e9476r98co200",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Payment Note",
                            "aggregation": "count",
                            "active": false,
                            "format": "-e9476r98co200",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Total Discount",
                            "formula": "sum(\"Total Unit Discount\")+sum(\"Item (Bill Discount)\")",
                            "caption": "Total Discount",
                            "active": false,
                            "format": "-e9476r98co200"
                        },
                        {
                            "uniqueName": "Create(Day of Week)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-e9476r98co200",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Create Date(Days)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-e9476r98co200"
                        },
                        {
                            "uniqueName": "Create Date(Month)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-e9476r98co200",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Create Date(Year)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-e9476r98co200"
                        },
                        {
                            "uniqueName": "Create Date(Week)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-e9476r98co200"
                        },
                        {
                            "uniqueName": "Create(Hour of Day)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-e9476r98co200"
                        },
                        {
                            "uniqueName": "Create (Block of 15 minutes)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-e9476r98co200"
                        },
                        {
                            "uniqueName": "Create Date(DD -MM-YYYY)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-e9476r98co200",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Create Date(YYYY-MM-DD)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-e9476r98co200",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify(Day of Week)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-e9476r98co200",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify Date(Days)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-e9476r98co200"
                        },
                        {
                            "uniqueName": "Modify Date(Month)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-e9476r98co200",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify Date(Year)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-e9476r98co200"
                        },
                        {
                            "uniqueName": "Modify Date(Week)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-e9476r98co200"
                        },
                        {
                            "uniqueName": "Modify(Hour of Day)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-e9476r98co200"
                        },
                        {
                            "uniqueName": "Modify (Block of 15 minutes)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-e9476r98co200"
                        },
                        {
                            "uniqueName": "Modify Date(DD-MM-YYYY)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-e9476r98co200",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify Date(YYYY-MM-DD)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-e9476r98co200",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Quarter",
                            "aggregation": "count",
                            "active": false,
                            "format": "-e9476r98co200",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "MealTime",
                            "aggregation": "count",
                            "active": false,
                            "format": "-e9476r98co200",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Parent",
                            "aggregation": "count",
                            "active": false,
                            "format": "-e9476r98co200",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Total Discount - 2",
                            "formula": "sum(\"Total Unit Discount\")+sum(\"Item (Bill Discount)\")",
                            "caption": "Total Discount - 2",
                            "active": false,
                            "format": "-e9476r98co200"
                        },
                        {
                            "uniqueName": "Unit Discount - 2",
                            "formula": "sum(\"Total Unit Discount\")",
                            "caption": "Sum of Unit Discount",
                            "active": false,
                            "format": "-e9476r98co200"
                        }
                    ]
                },
                "options": {
                    "grid": {
                        "type": "classic"
                    },
                    "viewType": "grid"
                },
                "formats": [
                    {
                        "name": "-e9476r98co200"
                    },
                    {
                        "name": "-1a9um5cv18yn00",
                        "nullValue": "0"
                    },
                    {
                        "name": "-14g8dm2jclft00",
                        "nullValue": "0"
                    },
                    getFormats(),
                ]
            }
        },
        {
            "name": "Sales by Shift",
            "configuation": {
                "slice": {
                    "reportFilters": [
                        {
                            "uniqueName": "Controller Name",
                            "sort": "unsorted"
                        }
                    ],
                    "rows": [
                        {
                            "uniqueName": "Shift",
                            "filter": {
                                "exclude": [
                                    "shift.[]"
                                ]
                            },
                            "sort": "unsorted"
                        }
                    ],
                    "columns": [
                        {
                            "uniqueName": "Status",
                            "filter": {
                                "members": [
                                    "status.[cancelled]",
                                    "status.[paid]"
                                ]
                            },
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "[Measures]"
                        }
                    ],
                    "measures": [
                        {
                            "uniqueName": "Bill",
                            "formula": "count(\"Order No\")",
                            "caption": "Bill",
                            "format": "-1b4v3x0f9t3t00"
                        },
                        {
                            "uniqueName": "Gross Sales",
                            "formula": "sum(\"Gross\")",
                            "caption": "Gross Sales",
                            "format": "-14sc5o7km61e00"
                        },
                        {
                            "uniqueName": "Sum of Taxes",
                            "formula": "sum(\""+ Filter.changeToNameSettings("tax1", "Tax 1", false) +"\") + sum(\""+ Filter.changeToNameSettings("tax2", "Tax 2", false) +"\") + sum(\""+ Filter.changeToNameSettings("netTaxBeforeDiscount", "Net Tax Before Discount", false) +"\")",
                            "caption": "Sum of Taxes",
                            "format": "-14sc5o7km61e00"
                        },
                        {
                            "uniqueName": "Net Sales",
                            "formula": "sum(\"Item Sales\")",
                            "caption": "Net Sales",
                            "format": "-14sc5o7km61e00"
                        },
                        {
                            "uniqueName": "Quantity",
                            "aggregation": "sum",
                            "format": "-14sc5o7km61e00"
                        },
                        {
                            "uniqueName": "Controller",
                            "aggregation": "count",
                            "active": false,
                            "format": "-14sc5o7km61e00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Controller Name",
                            "aggregation": "count",
                            "active": false,
                            "format": "-14sc5o7km61e00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Transaction ID",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-14sc5o7km61e00"
                        },
                        {
                            "uniqueName": "Create",
                            "aggregation": "count",
                            "active": false,
                            "format": "-14sc5o7km61e00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify",
                            "aggregation": "count",
                            "active": false,
                            "format": "-14sc5o7km61e00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Sale Type",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-14sc5o7km61e00"
                        },
                        {
                            "uniqueName": "Master Item ID",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-14sc5o7km61e00"
                        },
                        {
                            "uniqueName": "Name of Item",
                            "aggregation": "count",
                            "active": false,
                            "format": "-14sc5o7km61e00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Status",
                            "aggregation": "count",
                            "active": false,
                            "format": "-14sc5o7km61e00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Prepare Station",
                            "aggregation": "count",
                            "active": false,
                            "format": "-14sc5o7km61e00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Agent",
                            "aggregation": "count",
                            "active": false,
                            "format": "-14sc5o7km61e00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Waiter",
                            "aggregation": "count",
                            "active": false,
                            "format": "-14sc5o7km61e00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Membership ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-14sc5o7km61e00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Member Note",
                            "aggregation": "count",
                            "active": false,
                            "format": "-14sc5o7km61e00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Tax Type",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-14sc5o7km61e00"
                        },
                        {
                            "uniqueName": "Bill Discount (%)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-14sc5o7km61e00"
                        },
                        {
                            "uniqueName": "Unit Price After Item Disc",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-14sc5o7km61e00"
                        },
                        {
                            "uniqueName": "Unit Selling Price",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-14sc5o7km61e00"
                        },
                        {
                            "uniqueName": "Item Gross Sales",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-14sc5o7km61e00"
                        },
                        {
                            "uniqueName": "Item Sales",
                            "formula": "sum(\"Item Sales\")",
                            "caption": "Sum of Item Sales",
                            "active": false,
                            "format": "-14sc5o7km61e00"
                        },
                        {
                            "uniqueName": "Price Name",
                            "aggregation": "count",
                            "active": false,
                            "format": "-14sc5o7km61e00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Payment Type",
                            "aggregation": "count",
                            "active": false,
                            "format": "-14sc5o7km61e00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Order No",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-14sc5o7km61e00"
                        },
                        {
                            "uniqueName": "Count Order",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-14sc5o7km61e00"
                        },
                        {
                            "uniqueName": "Table No",
                            "aggregation": "count",
                            "active": false,
                            "format": "-14sc5o7km61e00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Total Net Price",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-14sc5o7km61e00"
                        },
                        {
                            "uniqueName": "Item (Bill Discount)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-14sc5o7km61e00"
                        },
                        {
                            "uniqueName": "Name of Tax Before",
                            "aggregation": "count",
                            "active": false,
                            "format": "-14sc5o7km61e00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Tax Before(Taxable Amt)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-14sc5o7km61e00"
                        },
                        {
                            "uniqueName": "Tax Before(%)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-14sc5o7km61e00"
                        },
                        {
                            "uniqueName": "Tax Before",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-14sc5o7km61e00"
                        },
                        {
                            "uniqueName": "Tax Before (Bill Discount)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-14sc5o7km61e00"
                        },
                        {
                            "uniqueName": "Tax Before (After Bill Discount)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-14sc5o7km61e00"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("netTaxBeforeDiscount", "Net Tax Before Discount", false),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-14sc5o7km61e00"
                        },
                        {
                            "uniqueName": "Bill Discount",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-14sc5o7km61e00"
                        },
                        {
                            "uniqueName": "Sub Total",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-14sc5o7km61e00"
                        },
                        {
                            "uniqueName": "Gross",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-14sc5o7km61e00"
                        },
                        {
                            "uniqueName": "Name of Tax 1",
                            "aggregation": "count",
                            "active": false,
                            "format": "-14sc5o7km61e00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax1", "Tax 1", false),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-14sc5o7km61e00"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax1", "Tax 1 (%)", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-14sc5o7km61e00"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax1", "Tax 1", false) + "(Taxable Amt*)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-14sc5o7km61e00"
                        },
                        {
                            "uniqueName": "Name of Tax 2",
                            "aggregation": "count",
                            "active": false,
                            "format": "-14sc5o7km61e00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2", false),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-14sc5o7km61e00"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2 (%)", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-14sc5o7km61e00"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2", false) + "(Taxable Amt*)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-14sc5o7km61e00"
                        },
                        {
                            "uniqueName": "Bill Discount (Note)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-14sc5o7km61e00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Complimentary by",
                            "aggregation": "count",
                            "active": false,
                            "format": "-14sc5o7km61e00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Shift",
                            "aggregation": "count",
                            "active": false,
                            "format": "-14sc5o7km61e00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Original Order No",
                            "aggregation": "count",
                            "active": false,
                            "format": "-14sc5o7km61e00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Reopen Bill",
                            "aggregation": "count",
                            "active": false,
                            "format": "-14sc5o7km61e00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "No. of Reopen Bill",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-14sc5o7km61e00"
                        },
                        {
                            "uniqueName": "Unit Original Price",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-14sc5o7km61e00"
                        },
                        {
                            "uniqueName": "Comment",
                            "aggregation": "count",
                            "active": false,
                            "format": "-14sc5o7km61e00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Unit Discount",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-14sc5o7km61e00"
                        },
                        {
                            "uniqueName": "Unit Change",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-14sc5o7km61e00"
                        },
                        {
                            "uniqueName": "Total Unit Discount",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-14sc5o7km61e00"
                        },
                        {
                            "uniqueName": "Total Original Price",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-14sc5o7km61e00"
                        },
                        {
                            "uniqueName": "Unit Discount(%)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-14sc5o7km61e00"
                        },
                        {
                            "uniqueName": "Unit Discount Note",
                            "aggregation": "count",
                            "active": false,
                            "format": "-14sc5o7km61e00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "No. of Copy Bill Print",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-14sc5o7km61e00"
                        },
                        {
                            "uniqueName": "Category",
                            "aggregation": "count",
                            "active": false,
                            "format": "-14sc5o7km61e00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Category Sub",
                            "aggregation": "count",
                            "active": false,
                            "format": "-14sc5o7km61e00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Promotion",
                            "aggregation": "count",
                            "active": false,
                            "format": "-14sc5o7km61e00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Paid Device ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-14sc5o7km61e00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Order Device ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-14sc5o7km61e00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Cancel Device ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-14sc5o7km61e00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Cancel by",
                            "aggregation": "count",
                            "active": false,
                            "format": "-14sc5o7km61e00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Payment Note",
                            "aggregation": "count",
                            "active": false,
                            "format": "-14sc5o7km61e00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Total Discount",
                            "formula": "sum(\"Total Unit Discount\")+sum(\"Item (Bill Discount)\")",
                            "caption": "Total Discount",
                            "active": false,
                            "format": "-14sc5o7km61e00"
                        },
                        {
                            "uniqueName": "Create(Day of Week)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-14sc5o7km61e00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Create Date(Days)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-14sc5o7km61e00"
                        },
                        {
                            "uniqueName": "Create Date(Month)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-14sc5o7km61e00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Create Date(Year)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-14sc5o7km61e00"
                        },
                        {
                            "uniqueName": "Create Date(Week)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-14sc5o7km61e00"
                        },
                        {
                            "uniqueName": "Create(Hour of Day)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-14sc5o7km61e00"
                        },
                        {
                            "uniqueName": "Create (Block of 15 minutes)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-14sc5o7km61e00"
                        },
                        {
                            "uniqueName": "Create Date(DD-MM-YYYY)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-14sc5o7km61e00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Create Date(YYYY-MM-DD)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-14sc5o7km61e00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify(Day of Week)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-14sc5o7km61e00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify Date(Days)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-14sc5o7km61e00"
                        },
                        {
                            "uniqueName": "Modify Date(Month)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-14sc5o7km61e00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify Date(Year)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-14sc5o7km61e00"
                        },
                        {
                            "uniqueName": "Modify Date(Week)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-14sc5o7km61e00"
                        },
                        {
                            "uniqueName": "Modify(Hour of Day)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-14sc5o7km61e00"
                        },
                        {
                            "uniqueName": "Modify (Block of 15 minutes)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-14sc5o7km61e00"
                        },
                        {
                            "uniqueName": "Modify Date(DD-MM-YYYY)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-14sc5o7km61e00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify Date(YYYY-MM-DD)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-14sc5o7km61e00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Quarter",
                            "aggregation": "count",
                            "active": false,
                            "format": "-14sc5o7km61e00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "MealTime",
                            "aggregation": "count",
                            "active": false,
                            "format": "-14sc5o7km61e00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Parent",
                            "aggregation": "count",
                            "active": false,
                            "format": "-14sc5o7km61e00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Period",
                            "aggregation": "count",
                            "active": false,
                            "format": "-14sc5o7km61e00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Total Discount - 2",
                            "formula": "sum(\"Total Unit Discount\")+sum(\"Item (Bill Discount)\")",
                            "caption": "Total Discount - 2",
                            "active": false,
                            "format": "-14sc5o7km61e00"
                        },
                        {
                            "uniqueName": "Unit Discount - 2",
                            "formula": "sum(\"Total Unit Discount\")",
                            "caption": "Sum of Unit Discount",
                            "active": false,
                            "format": "-14sc5o7km61e00"
                        },
                        {
                            "uniqueName": "No of Items Purchased",
                            "formula": "sum(\"Quantity\")",
                            "caption": "No of Items Purchased",
                            "active": false,
                            "format": "-14sc5o7km61e00"
                        },
                        {
                            "uniqueName": "Avg Items Purchased per Visit",
                            "formula": "sum(\"Quantity\") / \"Bill\"",
                            "caption": "Avg Items Purchased per Visit",
                            "active": false,
                            "format": "-14sc5o7km61e00"
                        },
                        {
                            "uniqueName": "Discount",
                            "formula": "sum(\"Bill Discount\")",
                            "caption": "Amount Discounted",
                            "active": false,
                            "format": "-14sc5o7km61e00"
                        },
                        {
                            "uniqueName": "Total Sales",
                            "formula": "sum(\"Item Sales\")",
                            "caption": "Total Sales",
                            "active": false,
                            "format": "-14sc5o7km61e00"
                        },
                        {
                            "uniqueName": "Avg Spent per Purchase",
                            "formula": "\"Total Sales\" / \"Bill\"",
                            "caption": "Avg Spent per Visit",
                            "active": false,
                            "format": "-14sc5o7km61e00"
                        },
                        {
                            "uniqueName": "Sales Percentage (%)",
                            "formula": "percent(\"Item Sales\")",
                            "caption": "Sales Percentage (%)",
                            "active": false,
                            "format": "-14sc5o7km61e00"
                        }
                    ],
                    "flatOrder": [
                        "Shift"
                    ]
                },
                "options": {
                    "grid": {
                        "type": "classic",
                        "showTotals": "off"
                    },
                    "chart": {
                        "activeMeasure": {
                            "uniqueName": ""
                        }
                    },
                    "showEmptyData": false,
                    "viewType": "grid"
                },
                "formats": [
                    {
                        "name": "",
                        "decimalPlaces": 2
                    },
                    {
                        "name": "-1b4v3x0f9t3t00",
                        "decimalPlaces": -1
                    },
                    getFormats(),
                ],
                "conditions": [
                    {
                        "formula": "#value = 0",
                        "measure": "Bill",
                        "format": {
                            "backgroundColor": "#FFFFFF",
                            "color": "#FFFFFF",
                            "fontFamily": "Arial",
                            "fontSize": "12px"
                        }
                    }
                ]
            }
        },
        {
            "name": "Member Overview",
            "configuation": {
                "slice": {
                    "reportFilters": [
                        {
                            "uniqueName": "Controller Name",
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Status",
                            "filter": {
                                "members": [
                                    "status.[paid]"
                                ]
                            },
                            "sort": "unsorted"
                        }
                    ],
                    "rows": [
                        {
                            "uniqueName": "Membership ID",
                            "filter": {
                                "exclude": [
                                    "membership id.[]"
                                ]
                            },
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Name of Item",
                            "sort": "unsorted"
                        }
                    ],
                    "columns": [
                        {
                            "uniqueName": "[Measures]"
                        }
                    ],
                    "measures": [
                        {
                            "uniqueName": "Bill",
                            "formula": "distinctcount(\"Order No\")",
                            "caption": "Bill",
                            "format": "-mdjr4of1yd800"
                        },
                        {
                            "uniqueName": "No of Items Purchased",
                            "formula": "sum(\"Quantity\")",
                            "caption": "No of Items Purchased",
                            "format": "-mdjr4of1yd800"
                        },
                        {
                            "uniqueName": "Discount",
                            "formula": "sum(\"Bill Discount\")",
                            "caption": "Amount Discounted",
                            "format": "-mdjr4of1yd800"
                        },
                        {
                            "uniqueName": "Total Sales",
                            "formula": "sum(\"Item Sales\")",
                            "caption": "Total Sales",
                            "format": "-mdjr4of1yd800"
                        },
                        {
                            "uniqueName": "Controller",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Controller Name",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Transaction ID",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Create",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Sale Type",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Quantity",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Master Item ID",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Name of Item",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Status",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Prepare Station",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Agent",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Waiter",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Membership ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Member Note",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Tax Type",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Bill Discount (%)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Unit Price After Item Disc",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Unit Selling Price",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Item Gross Sales",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Item Sales",
                            "formula": "sum(\"Item Sales\")",
                            "caption": "Sum of Item Sales",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Price Name",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Payment Type",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Order No",
                            "aggregation": "distinctcount",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Count Order",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Table No",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Total Net Price",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Item (Bill Discount)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Name of Tax Before",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Tax Before(Taxable Amt)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Tax Before(%)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Tax Before",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Tax Before (Bill Discount)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Tax Before (After Bill Discount)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("netTaxBeforeDiscount", "Net Tax Before Discount", false),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Bill Discount",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Sub Total",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Gross",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Name of Tax 1",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax1", "Tax 1", false),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax1", "Tax 1 (%)", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax1", "Tax 1", false) + "(Taxable Amt*)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Name of Tax 2",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2", false),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2 (%)", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2", false) + "(Taxable Amt*)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Bill Discount (Note)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Complimentary by",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Shift",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Original Order No",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Reopen Bill",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "No. of Reopen Bill",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Unit Original Price",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Comment",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Unit Discount",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Unit Change",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Total Unit Discount",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Total Original Price",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Unit Discount(%)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Unit Discount Note",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "No. of Copy Bill Print",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Category",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Category Sub",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Promotion",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Paid Device ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Order Device ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Cancel Device ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Cancel by",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Payment Note",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Total Discount",
                            "formula": "sum(\"Total Unit Discount\")+sum(\"Item (Bill Discount)\")",
                            "caption": "Total Discount",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Create(Day of Week)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Create Date(Days)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Create Date(Month)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Create Date(Year)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Create Date(Week)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Create(Hour of Day)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Create (Block of 15 minutes)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Create Date(DD-MM-YYYY)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Create Date(YYYY-MM-DD)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify(Day of Week)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify Date(Days)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Modify Date(Month)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify Date(Year)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Modify Date(Week)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Modify(Hour of Day)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Modify (Block of 15 minutes)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Modify Date(DD-MM-YYYY)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify Date(YYYY-MM-DD)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Quarter",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "MealTime",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Parent",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Period",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Gross Sales",
                            "formula": "sum(\"Gross\")",
                            "caption": "Gross Sales",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Sum of Taxes",
                            "formula": "sum(\""+ Filter.changeToNameSettings("tax1", "Tax 1", false) +"\") + sum(\""+ Filter.changeToNameSettings("tax2", "Tax 2", false) +"\") + sum(\""+ Filter.changeToNameSettings("netTaxBeforeDiscount", "Net Tax Before Discount", false) +"\")",
                            "caption": "Sum of Taxes",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Net Sales",
                            "formula": "sum(\"Item Sales\")",
                            "caption": "Net Sales",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Total Discount - 2",
                            "formula": "sum(\"Total Unit Discount\")+sum(\"Item (Bill Discount)\")",
                            "caption": "Total Discount - 2",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Unit Discount - 2",
                            "formula": "sum(\"Total Unit Discount\")",
                            "caption": "Sum of Unit Discount",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Avg Items Purchased per Visit",
                            "formula": "sum(\"Quantity\") / \"Bill\"",
                            "caption": "Avg Items Purchased per Visit",
                            "active": false,
                            "format": "-mdjr4of1yd800"
                        },
                        {
                            "uniqueName": "Avg Spent per Purchase",
                            "formula": "\"Total Sales\" / \"Bill\"",
                            "caption": "Avg Spent per Visit",
                            "active": false,
                            "format": "-mdjr4of1yd800"
                        },
                        {
                            "uniqueName": "Sales Percentage (%)",
                            "formula": "percent(\"Item Sales\")",
                            "caption": "Sales Percentage (%)",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        }
                    ],
                    "sorting": {
                        "column": {
                            "type": "desc",
                            "tuple": [],
                            "measure": {
                                "uniqueName": "No of Items Purchased",
                                "aggregation": "none"
                            }
                        }
                    },
                    "flatOrder": [
                        "Membership ID"
                    ]
                },
                "options": {
                    "grid": {
                        "type": "classic"
                    },
                    "chart": {
                        "type": "bar",
                        "activeMeasure": {
                            "uniqueName": ""
                        }
                    },
                    "showEmptyData": false,
                    "viewType": "grid"
                },
                "formats": [
                    {
                        "name": "",
                        "decimalPlaces": 2
                    },
                    getFormats(),
                ]
            }
        },
        {
            "name": "Popular Item among Members",
            "configuation": {
                "slice": {
                    "reportFilters": [
                        {
                            "uniqueName": "Controller Name",
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Status",
                            "filter": {
                                "members": [
                                    "status.[paid]"
                                ]
                            },
                            "sort": "unsorted"
                        }
                    ],
                    "rows": [
                        {
                            "uniqueName": "Name of Item",
                            "filter": {
                                "measure": {
                                    "uniqueName": "Membership ID",
                                    "aggregation": "count"
                                },
                                "query": {
                                    "top": 10
                                }
                            },
                            "sort": "unsorted"
                        }
                    ],
                    "columns": [
                        {
                            "uniqueName": "[Measures]"
                        }
                    ],
                    "measures": [
                        {
                            "uniqueName": "Membership ID",
                            "aggregation": "count",
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Controller",
                            "aggregation": "count",
                            "active": false,
                            "format": "-slh2uj8496000",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Controller Name",
                            "aggregation": "count",
                            "active": false,
                            "format": "-slh2uj8496000",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Transaction ID",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-slh2uj8496000"
                        },
                        {
                            "uniqueName": "Create",
                            "aggregation": "count",
                            "active": false,
                            "format": "-slh2uj8496000",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify",
                            "aggregation": "count",
                            "active": false,
                            "format": "-slh2uj8496000",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Sale Type",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-slh2uj8496000"
                        },
                        {
                            "uniqueName": "Quantity",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-slh2uj8496000"
                        },
                        {
                            "uniqueName": "Master Item ID",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-slh2uj8496000"
                        },
                        {
                            "uniqueName": "Name of Item",
                            "aggregation": "count",
                            "active": false,
                            "format": "-slh2uj8496000",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Status",
                            "aggregation": "count",
                            "active": false,
                            "format": "-slh2uj8496000",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Prepare Station",
                            "aggregation": "count",
                            "active": false,
                            "format": "-slh2uj8496000",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Agent",
                            "aggregation": "count",
                            "active": false,
                            "format": "-slh2uj8496000",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Waiter",
                            "aggregation": "count",
                            "active": false,
                            "format": "-slh2uj8496000",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Member Note",
                            "aggregation": "count",
                            "active": false,
                            "format": "-slh2uj8496000",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Tax Type",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-slh2uj8496000"
                        },
                        {
                            "uniqueName": "Bill Discount (%)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-slh2uj8496000"
                        },
                        {
                            "uniqueName": "Unit Price After Item Disc",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-slh2uj8496000"
                        },
                        {
                            "uniqueName": "Unit Selling Price",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-slh2uj8496000"
                        },
                        {
                            "uniqueName": "Item Gross Sales",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-slh2uj8496000"
                        },
                        {
                            "uniqueName": "Item Sales",
                            "formula": "sum(\"Item Sales\")",
                            "caption": "Sum of Item Sales",
                            "active": false,
                            "format": "-slh2uj8496000"
                        },
                        {
                            "uniqueName": "Price Name",
                            "aggregation": "count",
                            "active": false,
                            "format": "-slh2uj8496000",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Payment Type",
                            "aggregation": "count",
                            "active": false,
                            "format": "-slh2uj8496000",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Order No",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-slh2uj8496000"
                        },
                        {
                            "uniqueName": "Count Order",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-slh2uj8496000"
                        },
                        {
                            "uniqueName": "Table No",
                            "aggregation": "count",
                            "active": false,
                            "format": "-slh2uj8496000",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Total Net Price",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-slh2uj8496000"
                        },
                        {
                            "uniqueName": "Item (Bill Discount)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-slh2uj8496000"
                        },
                        {
                            "uniqueName": "Name of Tax Before",
                            "aggregation": "count",
                            "active": false,
                            "format": "-slh2uj8496000",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Tax Before(Taxable Amt)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-slh2uj8496000"
                        },
                        {
                            "uniqueName": "Tax Before(%)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-slh2uj8496000"
                        },
                        {
                            "uniqueName": "Tax Before",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-slh2uj8496000"
                        },
                        {
                            "uniqueName": "Tax Before (Bill Discount)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-slh2uj8496000"
                        },
                        {
                            "uniqueName": "Tax Before (After Bill Discount)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-slh2uj8496000"
                        },
                        {
                            "uniqueName": "Bill Discount",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-slh2uj8496000"
                        },
                        {
                            "uniqueName": "Sub Total",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-slh2uj8496000"
                        },
                        {
                            "uniqueName": "Gross",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-slh2uj8496000"
                        },
                        {
                            "uniqueName": "Name of Tax 1",
                            "aggregation": "count",
                            "active": false,
                            "format": "-slh2uj8496000",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax1", "Tax 1 (%)", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-slh2uj8496000"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax1", "Tax 1", false) + "(Taxable Amt*)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-slh2uj8496000"
                        },
                        {
                            "uniqueName": "Name of Tax 2",
                            "aggregation": "count",
                            "active": false,
                            "format": "-slh2uj8496000",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2", false),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-slh2uj8496000"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2 (%)", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-slh2uj8496000"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2", false) + "(Taxable Amt*)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-slh2uj8496000"
                        },
                        {
                            "uniqueName": "Bill Discount (Note)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-slh2uj8496000",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Complimentary by",
                            "aggregation": "count",
                            "active": false,
                            "format": "-slh2uj8496000",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Shift",
                            "aggregation": "count",
                            "active": false,
                            "format": "-slh2uj8496000",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Original Order No",
                            "aggregation": "count",
                            "active": false,
                            "format": "-slh2uj8496000",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Reopen Bill",
                            "aggregation": "count",
                            "active": false,
                            "format": "-slh2uj8496000",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "No. of Reopen Bill",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-slh2uj8496000"
                        },
                        {
                            "uniqueName": "Unit Original Price",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-slh2uj8496000"
                        },
                        {
                            "uniqueName": "Comment",
                            "aggregation": "count",
                            "active": false,
                            "format": "-slh2uj8496000",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Unit Discount",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-slh2uj8496000"
                        },
                        {
                            "uniqueName": "Unit Change",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-slh2uj8496000"
                        },
                        {
                            "uniqueName": "Total Unit Discount",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-slh2uj8496000"
                        },
                        {
                            "uniqueName": "Total Original Price",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-slh2uj8496000"
                        },
                        {
                            "uniqueName": "Unit Discount(%)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-slh2uj8496000"
                        },
                        {
                            "uniqueName": "Unit Discount Note",
                            "aggregation": "count",
                            "active": false,
                            "format": "-slh2uj8496000",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "No. of Copy Bill Print",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-slh2uj8496000"
                        },
                        {
                            "uniqueName": "Category",
                            "aggregation": "count",
                            "active": false,
                            "format": "-slh2uj8496000",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Category Sub",
                            "aggregation": "count",
                            "active": false,
                            "format": "-slh2uj8496000",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Promotion",
                            "aggregation": "count",
                            "active": false,
                            "format": "-slh2uj8496000",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Paid Device ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-slh2uj8496000",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Order Device ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-slh2uj8496000",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Cancel Device ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-slh2uj8496000",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Cancel by",
                            "aggregation": "count",
                            "active": false,
                            "format": "-slh2uj8496000",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Payment Note",
                            "aggregation": "count",
                            "active": false,
                            "format": "-slh2uj8496000",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Total Discount",
                            "formula": "sum(\"Total Unit Discount\")+sum(\"Item (Bill Discount)\")",
                            "caption": "Total Discount",
                            "active": false,
                            "format": "-slh2uj8496000"
                        },
                        {
                            "uniqueName": "Create(Day of Week)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-slh2uj8496000",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Create Date(Days)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-slh2uj8496000"
                        },
                        {
                            "uniqueName": "Create Date(Month)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-slh2uj8496000",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Create Date(Year)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-slh2uj8496000"
                        },
                        {
                            "uniqueName": "Create Date(Week)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-slh2uj8496000"
                        },
                        {
                            "uniqueName": "Create(Hour of Day)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-slh2uj8496000"
                        },
                        {
                            "uniqueName": "Create (Block of 15 minutes)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-slh2uj8496000"
                        },
                        {
                            "uniqueName": "Create Date(DD-MM-YYYY)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-slh2uj8496000",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Create Date(YYYY-MM-DD)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-slh2uj8496000",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify(Day of Week)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-slh2uj8496000",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify Date(Days)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-slh2uj8496000"
                        },
                        {
                            "uniqueName": "Modify Date(Month)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-slh2uj8496000",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify Date(Year)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-slh2uj8496000"
                        },
                        {
                            "uniqueName": "Modify Date(Week)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-slh2uj8496000"
                        },
                        {
                            "uniqueName": "Modify(Hour of Day)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-slh2uj8496000"
                        },
                        {
                            "uniqueName": "Modify (Block of 15 minutes)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-slh2uj8496000"
                        },
                        {
                            "uniqueName": "Modify Date(DD-MM-YYYY)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-slh2uj8496000",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify Date(YYYY-MM-DD)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-slh2uj8496000",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Quarter",
                            "aggregation": "count",
                            "active": false,
                            "format": "-slh2uj8496000",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "MealTime",
                            "aggregation": "count",
                            "active": false,
                            "format": "-slh2uj8496000",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Parent",
                            "aggregation": "count",
                            "active": false,
                            "format": "-slh2uj8496000",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Period",
                            "aggregation": "count",
                            "active": false,
                            "format": "-slh2uj8496000",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Total Discount - 2",
                            "formula": "sum(\"Total Unit Discount\")+sum(\"Item (Bill Discount)\")",
                            "caption": "Total Discount - 2",
                            "active": false,
                            "format": "-slh2uj8496000"
                        },
                        {
                            "uniqueName": "Unit Discount - 2",
                            "formula": "sum(\"Total Unit Discount\")",
                            "caption": "Sum of Unit Discount",
                            "active": false,
                            "format": "-slh2uj8496000"
                        },
                        {
                            "uniqueName": "Bill",
                            "formula": "distinctcount(\"Order No\")",
                            "caption": "Bill",
                            "active": false,
                            "format": "-slh2uj8496000"
                        },
                        {
                            "uniqueName": "Gross Sales",
                            "formula": "sum(\"Gross\")",
                            "caption": "Gross Sales",
                            "active": false,
                            "format": "-slh2uj8496000"
                        },
                        {
                            "uniqueName": "Net Sales",
                            "formula": "sum(\"Item Sales\")",
                            "caption": "Net Sales",
                            "active": false,
                            "format": "-slh2uj8496000"
                        },
                        {
                            "uniqueName": "No of Items Purchased",
                            "formula": "sum(\"Quantity\")",
                            "caption": "No of Items Purchased",
                            "active": false,
                            "format": "-slh2uj8496000"
                        },
                        {
                            "uniqueName": "Avg Items Purchased per Visit",
                            "formula": "sum(\"Quantity\") / \"Bill\"",
                            "caption": "Avg Items Purchased per Visit",
                            "active": false,
                            "format": "-slh2uj8496000"
                        },
                        {
                            "uniqueName": "Discount",
                            "formula": "sum(\"Bill Discount\")",
                            "caption": "Amount Discounted",
                            "active": false,
                            "format": "-slh2uj8496000"
                        },
                        {
                            "uniqueName": "Total Sales",
                            "formula": "sum(\"Item Sales\")",
                            "caption": "Total Sales",
                            "active": false,
                            "format": "-slh2uj8496000"
                        },
                        {
                            "uniqueName": "Avg Spent per Purchase",
                            "formula": "\"Total Sales\" / \"Bill\"",
                            "caption": "Avg Spent per Visit",
                            "active": false,
                            "format": "-slh2uj8496000"
                        },
                        {
                            "uniqueName": "Sum of Taxes",
                            "formula": "sum(\""+ Filter.changeToNameSettings("tax1", "Tax 1", false) +"\") + sum(\""+ Filter.changeToNameSettings("tax2", "Tax 2", false) +"\") + sum(\""+ Filter.changeToNameSettings("netTaxBeforeDiscount", "Net Tax Before Discount", false) +"\")",
                            "caption": "Sum of Taxes",
                            "active": false,
                            "format": "-slh2uj8496000"
                        },
                        {
                            "uniqueName": "Sales Percentage (%)",
                            "formula": "percent(\"Item Sales\")",
                            "caption": "Sales Percentage (%)",
                            "active": false,
                            "format": "-slh2uj8496000"
                        }
                    ],
                    "sorting": {
                        "column": {
                            "type": "desc",
                            "tuple": [],
                            "measure": {
                                "uniqueName": "Membership ID",
                                "aggregation": "count"
                            }
                        }
                    },
                    "flatOrder": [
                        "Membership ID"
                    ]
                },
                "options": {
                    "grid": {
                        "type": "classic"
                    },
                    "chart": {
                        "type": "bar",
                        "activeMeasure": {
                            "uniqueName": ""
                        }
                    },
                    "showEmptyData": false,
                    "viewType": "grid"
                },
                "formats": [
                    {
                        "name": "",
                        "decimalPlaces": 2
                    },
                    getFormats(),
                ]
            }
        },
        {
            "name": "Top Selling Items",
            "configuation": {
                "slice": {
                    "reportFilters": [
                        {
                            "uniqueName": "Controller Name"
                        },
                        {
                            "uniqueName": "Status",
                            "filter": {
                                "members": [
                                    "status.[paid]"
                                ]
                            },
                            "sort": "unsorted"
                        }
                    ],
                    "rows": [
                        {
                            "uniqueName": "Name of Item",
                            "sort": "unsorted"
                        }
                    ],
                    "columns": [
                        {
                            "uniqueName": "[Measures]"
                        }
                    ],
                    "measures": [
                        {
                            "uniqueName": "Quantity",
                            "aggregation": "sum",
                            "format": "-8slv0rxunp800"
                        },
                        {
                            "uniqueName": "Item Sales",
                            "formula": "sum(\"Item Sales\")",
                            "caption": "Sum of Item Sales",
                            "format": "-oxn87gj2gn900"
                        },
                        {
                            "uniqueName": "Sales Percentage (%)",
                            "formula": "percent(\"Item Sales\")",
                            "caption": "Sales Percentage (%)",
                            "format": "-ecnqbc1so0l00"
                        },
                        {
                            "uniqueName": "Controller",
                            "aggregation": "count",
                            "active": false,
                            "format": "-oxn87gj2gn900",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Controller Name",
                            "aggregation": "count",
                            "active": false,
                            "format": "-oxn87gj2gn900",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Transaction ID",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-oxn87gj2gn900"
                        },
                        {
                            "uniqueName": "Create",
                            "aggregation": "count",
                            "active": false,
                            "format": "-oxn87gj2gn900",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify",
                            "aggregation": "count",
                            "active": false,
                            "format": "-oxn87gj2gn900",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Sale Type",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-oxn87gj2gn900"
                        },
                        {
                            "uniqueName": "Master Item ID",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-oxn87gj2gn900"
                        },
                        {
                            "uniqueName": "Name of Item",
                            "aggregation": "count",
                            "active": false,
                            "format": "-oxn87gj2gn900",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Status",
                            "aggregation": "count",
                            "active": false,
                            "format": "-oxn87gj2gn900",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Prepare Station",
                            "aggregation": "count",
                            "active": false,
                            "format": "-oxn87gj2gn900",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Agent",
                            "aggregation": "count",
                            "active": false,
                            "format": "-oxn87gj2gn900",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Waiter",
                            "aggregation": "count",
                            "active": false,
                            "format": "-oxn87gj2gn900",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Membership ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-oxn87gj2gn900",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Member Note",
                            "aggregation": "count",
                            "active": false,
                            "format": "-oxn87gj2gn900",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Tax Type",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-oxn87gj2gn900"
                        },
                        {
                            "uniqueName": "Bill Discount (%)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-oxn87gj2gn900"
                        },
                        {
                            "uniqueName": "Unit Price After Item Disc",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-oxn87gj2gn900"
                        },
                        {
                            "uniqueName": "Unit Selling Price",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-oxn87gj2gn900"
                        },
                        {
                            "uniqueName": "Item Gross Sales",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-oxn87gj2gn900"
                        },
                        {
                            "uniqueName": "Price Name",
                            "aggregation": "count",
                            "active": false,
                            "format": "-oxn87gj2gn900",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Payment Type",
                            "aggregation": "count",
                            "active": false,
                            "format": "-oxn87gj2gn900",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Order No",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-oxn87gj2gn900"
                        },
                        {
                            "uniqueName": "Count Order",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-oxn87gj2gn900"
                        },
                        {
                            "uniqueName": "Table No",
                            "aggregation": "count",
                            "active": false,
                            "format": "-oxn87gj2gn900",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Total Net Price",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-oxn87gj2gn900"
                        },
                        {
                            "uniqueName": "Item (Bill Discount)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-oxn87gj2gn900"
                        },
                        {
                            "uniqueName": "Name of Tax Before",
                            "aggregation": "count",
                            "active": false,
                            "format": "-oxn87gj2gn900",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Tax Before(Taxable Amt)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-oxn87gj2gn900"
                        },
                        {
                            "uniqueName": "Tax Before(%)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-oxn87gj2gn900"
                        },
                        {
                            "uniqueName": "Tax Before",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-oxn87gj2gn900"
                        },
                        {
                            "uniqueName": "Tax Before (Bill Discount)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-oxn87gj2gn900"
                        },
                        {
                            "uniqueName": "Tax Before (After Bill Discount)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-oxn87gj2gn900"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("netTaxBeforeDiscount", "Net Tax Before Discount", false),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-oxn87gj2gn900"
                        },
                        {
                            "uniqueName": "Bill Discount",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-oxn87gj2gn900"
                        },
                        {
                            "uniqueName": "Sub Total",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-oxn87gj2gn900"
                        },
                        {
                            "uniqueName": "Gross",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-oxn87gj2gn900"
                        },
                        {
                            "uniqueName": "Name of Tax 1",
                            "aggregation": "count",
                            "active": false,
                            "format": "-oxn87gj2gn900",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax1", "Tax 1", false),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-oxn87gj2gn900"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax1", "Tax 1 (%)", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-oxn87gj2gn900"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax1", "Tax 1", false) + "(Taxable Amt*)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-oxn87gj2gn900"
                        },
                        {
                            "uniqueName": "Name of Tax 2",
                            "aggregation": "count",
                            "active": false,
                            "format": "-oxn87gj2gn900",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2", false),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-oxn87gj2gn900"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2 (%)", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-oxn87gj2gn900"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2", false) + "(Taxable Amt*)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-oxn87gj2gn900"
                        },
                        {
                            "uniqueName": "Bill Discount (Note)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-oxn87gj2gn900",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Complimentary by",
                            "aggregation": "count",
                            "active": false,
                            "format": "-oxn87gj2gn900",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Shift",
                            "aggregation": "count",
                            "active": false,
                            "format": "-oxn87gj2gn900",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Original Order No",
                            "aggregation": "count",
                            "active": false,
                            "format": "-oxn87gj2gn900",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Reopen Bill",
                            "aggregation": "count",
                            "active": false,
                            "format": "-oxn87gj2gn900",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "No. of Reopen Bill",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-oxn87gj2gn900"
                        },
                        {
                            "uniqueName": "Unit Original Price",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-oxn87gj2gn900"
                        },
                        {
                            "uniqueName": "Comment",
                            "aggregation": "count",
                            "active": false,
                            "format": "-oxn87gj2gn900",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Unit Discount",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-oxn87gj2gn900"
                        },
                        {
                            "uniqueName": "Unit Change",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-oxn87gj2gn900"
                        },
                        {
                            "uniqueName": "Total Unit Discount",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-oxn87gj2gn900"
                        },
                        {
                            "uniqueName": "Total Original Price",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-oxn87gj2gn900"
                        },
                        {
                            "uniqueName": "Unit Discount(%)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-oxn87gj2gn900"
                        },
                        {
                            "uniqueName": "Unit Discount Note",
                            "aggregation": "count",
                            "active": false,
                            "format": "-oxn87gj2gn900",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "No. of Copy Bill Print",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-oxn87gj2gn900"
                        },
                        {
                            "uniqueName": "Category",
                            "aggregation": "count",
                            "active": false,
                            "format": "-oxn87gj2gn900",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Category Sub",
                            "aggregation": "count",
                            "active": false,
                            "format": "-oxn87gj2gn900",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Promotion",
                            "aggregation": "count",
                            "active": false,
                            "format": "-oxn87gj2gn900",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Paid Device ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-oxn87gj2gn900",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Order Device ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-oxn87gj2gn900",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Cancel Device ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-oxn87gj2gn900",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Cancel by",
                            "aggregation": "count",
                            "active": false,
                            "format": "-oxn87gj2gn900",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Payment Note",
                            "aggregation": "count",
                            "active": false,
                            "format": "-oxn87gj2gn900",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Total Discount",
                            "formula": "sum(\"Total Unit Discount\")+sum(\"Item (Bill Discount)\")",
                            "caption": "Total Discount",
                            "active": false,
                            "format": "-oxn87gj2gn900"
                        },
                        {
                            "uniqueName": "Create(Day of Week)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-oxn87gj2gn900",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Create Date(Days)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-oxn87gj2gn900"
                        },
                        {
                            "uniqueName": "Create Date(Month)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-oxn87gj2gn900",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Create Date(Year)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-oxn87gj2gn900"
                        },
                        {
                            "uniqueName": "Create Date(Week)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-oxn87gj2gn900"
                        },
                        {
                            "uniqueName": "Create(Hour of Day)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-oxn87gj2gn900"
                        },
                        {
                            "uniqueName": "Create (Block of 15 minutes)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-oxn87gj2gn900"
                        },
                        {
                            "uniqueName": "Create Date(DD-MM-YYYY)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-oxn87gj2gn900",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Create Date(YYYY-MM-DD)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-oxn87gj2gn900",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify(Day of Week)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-oxn87gj2gn900",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify Date(Days)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-oxn87gj2gn900"
                        },
                        {
                            "uniqueName": "Modify Date(Month)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-oxn87gj2gn900",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify Date(Year)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-oxn87gj2gn900"
                        },
                        {
                            "uniqueName": "Modify Date(Week)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-oxn87gj2gn900"
                        },
                        {
                            "uniqueName": "Modify(Hour of Day)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-oxn87gj2gn900"
                        },
                        {
                            "uniqueName": "Modify (Block of 15 minutes)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-oxn87gj2gn900"
                        },
                        {
                            "uniqueName": "Modify Date(DD-MM-YYYY)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-oxn87gj2gn900",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify Date(YYYY-MM-DD)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-oxn87gj2gn900",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Quarter",
                            "aggregation": "count",
                            "active": false,
                            "format": "-oxn87gj2gn900",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "MealTime",
                            "aggregation": "count",
                            "active": false,
                            "format": "-oxn87gj2gn900",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Parent",
                            "aggregation": "count",
                            "active": false,
                            "format": "-oxn87gj2gn900",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Period",
                            "aggregation": "count",
                            "active": false,
                            "format": "-oxn87gj2gn900",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Bill",
                            "formula": "distinctcount(\"Order No\")",
                            "caption": "Bill",
                            "active": false,
                            "format": "-oxn87gj2gn900"
                        },
                        {
                            "uniqueName": "Gross Sales",
                            "formula": "sum(\"Gross\")",
                            "caption": "Gross Sales",
                            "active": false,
                            "format": "-oxn87gj2gn900"
                        },
                        {
                            "uniqueName": "Net Sales",
                            "formula": "sum(\"Item Sales\")",
                            "caption": "Net Sales",
                            "active": false,
                            "format": "-oxn87gj2gn900"
                        },
                        {
                            "uniqueName": "Total Discount - 2",
                            "formula": "sum(\"Total Unit Discount\")+sum(\"Item (Bill Discount)\")",
                            "caption": "Total Discount - 2",
                            "active": false,
                            "format": "-oxn87gj2gn900"
                        },
                        {
                            "uniqueName": "Unit Discount - 2",
                            "formula": "sum(\"Total Unit Discount\")",
                            "caption": "Sum of Unit Discount",
                            "active": false,
                            "format": "-oxn87gj2gn900"
                        },
                        {
                            "uniqueName": "Sum of Taxes",
                            "formula": "sum(\""+ Filter.changeToNameSettings("tax1", "Tax 1", false) +"\") + sum(\""+ Filter.changeToNameSettings("tax2", "Tax 2", false) +"\") + sum(\""+ Filter.changeToNameSettings("netTaxBeforeDiscount", "Net Tax Before Discount", false) +"\")",
                            "caption": "Sum of Taxes",
                            "active": false,
                            "format": "-oxn87gj2gn900"
                        },
                        {
                            "uniqueName": "No of Items Purchased",
                            "formula": "sum(\"Quantity\")",
                            "caption": "No of Items Purchased",
                            "active": false,
                            "format": "-oxn87gj2gn900"
                        },
                        {
                            "uniqueName": "Avg Items Purchased per Visit",
                            "formula": "sum(\"Quantity\") / \"Bill\"",
                            "caption": "Avg Items Purchased per Visit",
                            "active": false,
                            "format": "-oxn87gj2gn900"
                        },
                        {
                            "uniqueName": "Discount",
                            "formula": "sum(\"Bill Discount\")",
                            "caption": "Amount Discounted",
                            "active": false,
                            "format": "-oxn87gj2gn900"
                        },
                        {
                            "uniqueName": "Total Sales",
                            "formula": "sum(\"Item Sales\")",
                            "caption": "Total Sales",
                            "active": false,
                            "format": "-oxn87gj2gn900"
                        },
                        {
                            "uniqueName": "Avg Spent per Purchase",
                            "formula": "\"Total Sales\" / \"Bill\"",
                            "caption": "Avg Spent per Visit",
                            "active": false,
                            "format": "-oxn87gj2gn900"
                        }
                    ],
                    "sorting": {
                        "column": {
                            "type": "desc",
                            "tuple": [],
                            "measure": {
                                "uniqueName": "Sales Percentage (%)",
                                "aggregation": "none"
                            }
                        }
                    },
                    "flatOrder": [
                        "Name of Item"
                    ]
                },
                "options": {
                    "grid": {
                        "type": "classic"
                    },
                    "chart": {
                        "type": "bar",
                        "activeMeasure": {
                            "uniqueName": ""
                        }
                    },
                    "showEmptyData": false,
                    "viewType": "grid"
                },
                "formats": [
                    {
                        "name": "",
                        "decimalPlaces": 2
                    },
                    {
                        "name": "-oxn87gj2gn900",
                        "decimalPlaces": 2
                    },
                    {
                        "name": "-8slv0rxunp800",
                        "decimalPlaces": -1
                    },
                    getFormats(),
                ]
            }
        },
        {
            "name": "Cancellation (Cashier)",
            "configuation": {
                "slice": {
                    "reportFilters": [
                        {
                            "uniqueName": "Controller Name",
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Status",
                            "filter": {
                                "members": [
                                    "status.[cancelled]"
                                ]
                            }
                        }
                    ],
                    "rows": [
                        {
                            "uniqueName": "Cancel by",
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Order No"
                        },
                        {
                            "uniqueName": "Name of Item"
                        }
                    ],
                    "columns": [
                        {
                            "uniqueName": "[Measures]"
                        }
                    ],
                    "measures": [
                        {
                            "uniqueName": "Bill",
                            "formula": "distinctcount(\"Order No\")",
                            "caption": "Bill",
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Quantity",
                            "aggregation": "sum",
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Item Sales",
                            "formula": "sum(\"Item Sales\")",
                            "caption": "Sum of Item Sales",
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Controller",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Controller Name",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Transaction ID",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Create",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Sale Type",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Master Item ID",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Name of Item",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Status",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Prepare Station",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Agent",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Waiter",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Membership ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Member Note",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Tax Type",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Bill Discount (%)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Unit Price After Item Disc",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Unit Selling Price",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Item Gross Sales",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Price Name",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Payment Type",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Order No",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Count Order",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Table No",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Total Net Price",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Item (Bill Discount)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Name of Tax Before",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Tax Before(Taxable Amt)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Tax Before(%)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Tax Before",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Tax Before (Bill Discount)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Tax Before (After Bill Discount)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Bill Discount",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Sub Total",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Gross",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Name of Tax 1",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax1", "Tax 1 (%)", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax1", "Tax 1", false) + "(Taxable Amt*)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Name of Tax 2",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2", false),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2 (%)", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2", false) + "(Taxable Amt*)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Bill Discount (Note)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Complimentary by",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Shift",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Original Order No",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Reopen Bill",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "No. of Reopen Bill",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Unit Original Price",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Comment",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Unit Discount",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Unit Change",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Total Unit Discount",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Total Original Price",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Unit Discount(%)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Unit Discount Note",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "No. of Copy Bill Print",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Category",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Category Sub",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Promotion",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Paid Device ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Order Device ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Cancel Device ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Cancel by",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Payment Note",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Total Discount",
                            "formula": "sum(\"Total Unit Discount\")+sum(\"Item (Bill Discount)\")",
                            "caption": "Total Discount",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Create(Day of Week)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Create Date(Days)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Create Date(Month)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Create Date(Year)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Create Date(Week)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Create(Hour of Day)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Create (Block of 15 minutes)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Create Date(DD-MM-YYYY)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Create Date(YYYY-MM-DD)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify(Day of Week)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify Date(Days)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Modify Date(Month)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify Date(Year)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Modify Date(Week)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Modify(Hour of Day)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Modify (Block of 15 minutes)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Modify Date(DD-MM-YYYY)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify Date(YYYY-MM-DD)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Quarter",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "MealTime",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Parent",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Period",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Total Discount - 2",
                            "formula": "sum(\"Total Unit Discount\")+sum(\"Item (Bill Discount)\")",
                            "caption": "Total Discount - 2",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Unit Discount - 2",
                            "formula": "sum(\"Total Unit Discount\")",
                            "caption": "Sum of Unit Discount",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Gross Sales",
                            "formula": "sum(\"Gross\")",
                            "caption": "Gross Sales",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Net Sales",
                            "formula": "sum(\"Item Sales\")",
                            "caption": "Net Sales",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "No of Items Purchased",
                            "formula": "sum(\"Quantity\")",
                            "caption": "No of Items Purchased",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Avg Items Purchased per Visit",
                            "formula": "sum(\"Quantity\") / \"Bill\"",
                            "caption": "Avg Items Purchased per Visit",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Discount",
                            "formula": "sum(\"Bill Discount\")",
                            "caption": "Amount Discounted",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Total Sales",
                            "formula": "sum(\"Item Sales\")",
                            "caption": "Total Sales",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Avg Spent per Purchase",
                            "formula": "\"Total Sales\" / \"Bill\"",
                            "caption": "Avg Spent per Visit",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Sum of Taxes",
                            "formula": "sum(\"Tax 1\") + sum(\"Tax 2\") + sum(\"Net Tax Before\")",
                            "caption": "Sum of Taxes",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Sales Percentage (%)",
                            "formula": "percent(\"Item Sales\")",
                            "caption": "Sales Percentage (%)",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        }
                    ],
                    "sorting": {
                        "row": {
                            "type": "desc",
                            "tuple": [
                                "cancel by.[admin (09 feb 2020 12:37)]"
                            ],
                            "measure": {
                                "uniqueName": "Bill",
                                "aggregation": "none"
                            }
                        }
                    },
                    "expands": {
                        "rows": [
                            {
                                "tuple": [
                                    "cancel by.[admin (09 feb 2020 10:26)]",
                                    "order no.[361402]"
                                ]
                            }
                        ]
                    }
                },
                "options": {
                    "grid": {
                        "type": "classic"
                    },
                    "chart": {
                        "activeMeasure": {
                            "uniqueName": ""
                        }
                    },
                    "showEmptyData": false,
                    "viewType": "grid"
                },
                "formats": [
                    {
                        "name": "",
                        "decimalPlaces": -1
                    },
                    {
                        "name": "-itlyt73h11w00",
                        "decimalPlaces": 2
                    },
                    getFormats(),
                ]
            }
        },
        {
            "name": "Top Products by Revenue",
            "configuation": {
                "slice": {
                    "reportFilters": [
                        {
                            "uniqueName": "Controller Name"
                        },
                        {
                            "uniqueName": "Status"
                        }
                    ],
                    "rows": [
                        {
                            "uniqueName": "Name of Item",
                            "filter": {
                                "measure": {
                                    "uniqueName": "Item Sales",
                                    "aggregation": "sum"
                                },
                                "query": {
                                    "top": 10
                                }
                            }
                        }
                    ],
                    "columns": [
                        {
                            "uniqueName": "[Measures]"
                        }
                    ],
                    "measures": [
                        {
                            "uniqueName": "Item Sales",
                            "aggregation": "sum",
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Controller",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Controller Name",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Transaction ID",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Create",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Sale Type",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Quantity",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-16bphsyfpw6k00"
                        },
                        {
                            "uniqueName": "Master Item ID",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Name of Item",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Status",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Prepare Station",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Agent",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Waiter",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Membership ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Member Note",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Tax Type",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Bill Discount (%)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Unit Price After Item Disc",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Unit Selling Price",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Item Gross Sales",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Price Name",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Payment Type",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Order No",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Count Order",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Table No",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Total Net Price",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Item (Bill Discount)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Name of Tax Before",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Tax Before(Taxable Amt)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Tax Before(%)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Tax Before",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Tax Before (Bill Discount)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Tax Before (After Bill Discount)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Bill Discount",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Sub Total",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Gross",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Name of Tax 1",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax1", "Tax 1 (%)", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax1", "Tax 1", false) + "(Taxable Amt*)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Name of Tax 2",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2", false),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2 (%)", true),
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": Filter.changeToNameSettings("tax2", "Tax 2", false) + "(Taxable Amt*)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Bill Discount (Note)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Complimentary by",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Shift",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Original Order No",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Reopen Bill",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "No. of Reopen Bill",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Unit Original Price",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Comment",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Unit Discount",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Unit Change",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Total Unit Discount",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Total Original Price",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Unit Discount(%)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Unit Discount Note",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "No. of Copy Bill Print",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Category",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Category Sub",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Promotion",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Paid Device ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Order Device ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Cancel Device ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Cancel by",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Payment Note",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Total Discount",
                            "formula": "sum(\"Total Unit Discount\")+sum(\"Item (Bill Discount)\")",
                            "caption": "Total Discount",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Create(Day of Week)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Create Date(Days)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Create Date(Month)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Create Date(Year)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Create Date(Week)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Create(Hour of Day)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Create (Block of 15 minutes)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Create Date(YYYY-MM-DD)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify(Day of Week)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify Date(Days)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Modify Date(Month)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify Date(Year)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Modify Date(Week)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Modify(Hour of Day)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Modify (Block of 15 minutes)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-brtiysj6dg63r"
                        },
                        {
                            "uniqueName": "Modify Date(DD-MM-YYYY)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify Date(YYYY-MM-DD)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Quarter",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "MealTime",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Parent",
                            "aggregation": "count",
                            "active": false,
                            "format": "-brtiysj6dg63r",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Total Discount - 2",
                            "formula": "sum(\"Total Unit Discount\")+sum(\"Item (Bill Discount)\")",
                            "caption": "Total Discount - 2",
                            "active": false
                        },
                        {
                            "uniqueName": "Unit Discount - 2",
                            "formula": "sum(\"Total Unit Discount\")",
                            "caption": "Sum of Unit Discount",
                            "active": false
                        },
                        {
                            "uniqueName": "Sales Percentage (%)",
                            "formula": "percent(\"Item Sales\")",
                            "caption": "Sales Percentage (%)",
                            "active": false
                        }
                    ],
                    "sorting": {
                        "column": {
                            "type": "desc",
                            "tuple": [],
                            "measure": {
                                "uniqueName": "Item Sales",
                                "aggregation": "sum"
                            }
                        }
                    }
                },
                "options": {
                    "viewType": "charts",
                    "grid": {
                        "type": "classic"
                    },
                    "chart": {
                        "type": "bar_h"
                    }
                },
                "formats": [
                    {
                        "name": "",
                        "decimalPlaces": 2
                    },
                    getFormats(),
                ]
            }
        },
        {
            "name": "Cancellation (by Bill)",
            "configuation": {
                "slice": {
                    "reportFilters": [
                        {
                            "uniqueName": "Status",
                            "filter": {
                                "members": [
                                    "status.[cancelled]"
                                ]
                            },
                            "sort": "unsorted"
                        }
                    ],
                    "rows": [
                        {
                            "uniqueName": "Order No"
                        },
                        {
                            "uniqueName": "Cancel by",
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Name of Item",
                            "sort": "unsorted"
                        }
                    ],
                    "columns": [
                        {
                            "uniqueName": "[Measures]"
                        }
                    ],
                    "measures": [
                        {
                            "uniqueName": "No of Items Purchased",
                            "formula": "sum(\"Quantity\")",
                            "caption": "No of Items Purchased",
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Net Sales",
                            "formula": "sum(\"Item Sales\")",
                            "caption": "Net Sales",
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Controller",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Controller Name",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Transaction ID",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Create",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Sale Type",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Quantity",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Master Item ID",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Name of Item",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Status",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Prepare Station",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Agent",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Waiter",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Membership ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Member Note",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Tax Type",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Bill Discount (%)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Unit Price After Item Disc",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Unit Selling Price",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Item Gross Sales",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Item Sales",
                            "formula": "sum(\"Item Sales\")",
                            "caption": "Sum of Item Sales",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Price Name",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Payment Type",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Order No",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Count Order",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Table No",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Total Net Price",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Item (Bill Discount)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Name of Service Charge",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Tax Before(Taxable Amt)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Service Charge (%)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Service Charge",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Service Charge (Bill Discount)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Service Charge (After Bill Discount)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Net Service Charge",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Bill Discount",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Sub Total",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Gross",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Name of SST",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "SST",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "SST (%)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "SST(Taxable Amt*)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Name of Tax 2",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Tax 2",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Tax 2 (%)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Tax 2(Taxable Amt*)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Bill Discount (Note)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Complimentary by",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Shift",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Original Order No",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Reopen Bill",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "No. of Reopen Bill",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Unit Original Price",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Comment",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Unit Discount",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Unit Change",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Total Unit Discount",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Total Original Price",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Unit Discount(%)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Unit Discount Note",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "No. of Copy Bill Print",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Category",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Category Sub",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Promotion",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Paid Device ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Order Device ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Cancel Device ID",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Cancel by",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Payment Note",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Total Discount",
                            "formula": "sum(\"Total Unit Discount\")+sum(\"Item (Bill Discount)\")",
                            "caption": "Total Discount",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Create(Day of Week)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Create Date(Days)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Create Date(Month)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Create Date(Year)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Create Date(Week)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Create(Hour of Day)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Create (Block of 15 minutes)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Create Date(DD-MM-YYYY)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Create Date(YYYY-MM-DD)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify(Day of Week)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify Date(Days)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Modify Date(Month)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify Date(Year)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Modify Date(Week)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Modify(Hour of Day)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Modify (Block of 15 minutes)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Modify Date(DD-MM-YYYY)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify Date(YYYY-MM-DD)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Quarter",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "MealTime",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Parent",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Period",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Member Item Note",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Cancel Note",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Special Note",
                            "aggregation": "count",
                            "active": false,
                            "format": "-itlyt73h11w00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Total Discount - 2",
                            "formula": "sum(\"Total Unit Discount\")+sum(\"Item (Bill Discount)\")",
                            "caption": "Total Discount - 2",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Unit Discount - 2",
                            "formula": "sum(\"Total Unit Discount\")",
                            "caption": "Sum of Unit Discount",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Gross Sales",
                            "formula": "sum(\"Gross\")",
                            "caption": "Gross Sales",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Avg Items Purchased per Visit",
                            "formula": "sum(\"Quantity\") / \"Bill\"",
                            "caption": "Avg Items Purchased per Visit",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Discount",
                            "formula": "sum(\"Bill Discount\")",
                            "caption": "Amount Discounted",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Total Sales",
                            "formula": "sum(\"Item Sales\")",
                            "caption": "Total Sales",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Avg Spent per Purchase",
                            "formula": "\"Total Sales\" / \"Bill Discount\"",
                            "caption": "Avg Spent per Visit",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Sum of Taxes",
                            "formula": "sum(\""+ Filter.changeToNameSettings("netTaxBeforeDiscount", "Net Tax Before Discount", false) +"\") + sum(\""+Filter.changeToNameSettings("tax1", "Tax 1", false)+"\") + sum(\""+Filter.changeToNameSettings("tax2", "Tax 2", false)+"\")",
                            "caption": "Sum of Taxes",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        },
                        {
                            "uniqueName": "Sales Percentage (%)",
                            "formula": "percent(\"Item Sales\")",
                            "caption": "Sales Percentage (%)",
                            "active": false,
                            "format": "-itlyt73h11w00"
                        }
                    ],
                    "expands": {
                        "rows": [
                            {
                                "tuple": [
                                    "order no.[11113]"
                                ]
                            },
                            {
                                "tuple": [
                                    "order no.[11117]"
                                ]
                            },
                            {
                                "tuple": [
                                    "order no.[77012]"
                                ]
                            },
                            {
                                "tuple": [
                                    "order no.[277062]"
                                ]
                            },
                            {
                                "tuple": [
                                    "order no.[277063]"
                                ]
                            },
                            {
                                "tuple": [
                                    "order no.[277064]"
                                ]
                            },
                            {
                                "tuple": [
                                    "order no.[277101]"
                                ]
                            }
                        ]
                    },
                    "flatOrder": [
                        "Order No",
                        "Cancel by",
                        "Name of Item"
                    ]
                },
                "options": {
                    "grid": {
                        "type": "classic",
                        "showTotals": "off"
                    },
                    "chart": {
                        "type": "bar",
                        "activeMeasure": {
                            "uniqueName": ""
                        }
                    },
                    "showEmptyData": false,
                    "viewType": "grid"
                },
                "formats": [
                    {
                        "name": "",
                        "thousandsSeparator": ",",
                        "decimalSeparator": ".",
                        "decimalPlaces": 2
                    },
                    {
                        "name": "-itlyt73h11w00",
                        "decimalPlaces": 2
                    }
                ]
            }
        }
    ],
    sales_consumption: [
        {
            "name": "BarSociety",
            "configuation": {
                "slice": {
                    "rows": [
                        {
                            "uniqueName": "Name of Item",
                            "sort": "asc"
                        },
                        {
                            "uniqueName": "Name of Stock",
                            "sort": "asc"
                        },
                        {
                            "uniqueName": "Unit Name",
                            "sort": "asc"
                        }
                    ],
                    "columns": [
                        {
                            "uniqueName": "[Measures]"
                        }
                    ],
                    "measures": [
                        {
                            "uniqueName": "Total Unit Value",
                            "aggregation": "sum"
                        }
                    ],
                    "expands": {
                        "rows": [
                            {
                                "tuple": [
                                    "name of item.[1 for 1 capucana cachaca]"
                                ]
                            },
                            {
                                "tuple": [
                                    "name of item.[1 for 1 capucana cachaca]",
                                    "name of stock.[capucana]"
                                ]
                            }
                        ]
                    }
                },
                "options": {
                    "grid": {
                        "type": "flat"
                    },
                    "chart": {
                        "type": "bar",
                        "activeMeasure": {
                            "uniqueName": ""
                        },
                        "showEmptyData": false,
                        "viewType": "grid"
                    }
                },
            }
        },
        {
            "name": "Stock Consumption",
            "configuation": {
                "slice": {
                    "rows": [
                        {
                            "uniqueName": "Name of Stock"
                        }
                    ],
                    "columns": [
                        {
                            "uniqueName": "[Measures]"
                        },
                        {
                            "uniqueName": "Sale Type"
                        }
                    ],
                    "measures": [
                        {
                            "uniqueName": "Total Display Value",
                            "aggregation": "sum"
                        }
                    ]
                },
                "options": {
                    "grid": {
                        "type": "classic"
                    },
                    "viewType": "grid"
                }
            }
        },
        {
            "name": "Sales Consumption Summary Plus",
            "configuation": {
                "slice": {
                    "reportFilters": [
                        {
                            "uniqueName": "Controller"
                        }
                    ],
                    "rows": [
                        {
                            "uniqueName": "Name of Item"
                        }
                    ],
                    "columns": [
                        {
                            "uniqueName": "[Measures]"
                        }
                    ],
                    "measures": [
                        {
                            "uniqueName": "Quantity",
                            "aggregation": "sum",
                            "format": "-124se1fonb2t00"
                        },
                        {
                            "uniqueName": "Item Sales",
                            "aggregation": "sum"
                        },
                        {
                            "uniqueName": "Total Cost Price",
                            "aggregation": "sum"
                        },
                        {
                            "uniqueName": "Gross Profit",
                            "formula": "sum(\"Item Sales\") - sum(\"Total Cost Price\")",
                            "caption": "Gross Profit"
                        },
                        {
                            "uniqueName": "Margin",
                            "formula": "\"Gross Profit\" / sum(\"Item Sales\")",
                            "caption": "Margin",
                            "format": "-k857qyykdh400"
                        },
                        {
                            "uniqueName": "Transaction ID",
                            "aggregation": "count",
                            "active": false
                        }
                    ]
                },
                "options": {
                    "grid": {
                        "type": "classic"
                    },
                    "chart": {
                        "activeMeasure": {
                            "uniqueName": ""
                        }
                    },
                    "showEmptyData": false,
                    "viewType": "grid"
                },
                "formats": [
                    {
                        "name": "",
                        "decimalPlaces": 2
                    },
                    {
                        "name": "-124se1fonb2t00",
                        "decimalPlaces": -1
                    },
                    {
                        "name": "-k857qyykdh400",
                        "isPercent": true
                    },
                    getFormats(),
                ]
            }
        }
    ],
    clock_in_out: [
        {
            "name": "Clock In/Out (By User)",
            "configuation": {
                "slice": {
                    "reportFilters": [
                        {
                            "uniqueName": "Action",
                            "filter": {
                                "exclude": [
                                    "action.[in]",
                                    "action.[out]"
                                ]
                            },
                            "sort": "unsorted"
                        }
                    ],
                    "rows": [
                        {
                            "uniqueName": "User",
                            "sort": "asc"
                        },
                        {
                            "uniqueName": "Time(YYYY-MM-DD)",
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "IN",
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "OUT",
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Valid",
                            "sort": "unsorted"
                        }
                    ],
                    "columns": [
                        {
                            "uniqueName": "[Measures]"
                        }
                    ],
                    "measures": [
                        {
                            "uniqueName": "Total",
                            "aggregation": "sum",
                            "format": "-4gcyc2gmnk500"
                        },
                        {
                            "uniqueName": "Device",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10cxvyb05wgx00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Device Name",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10cxvyb05wgx00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Action",
                            "aggregation": "distinctcount",
                            "active": false,
                            "format": "-10cxvyb05wgx00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Time",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10cxvyb05wgx00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Time (Miliseconds)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10cxvyb05wgx00"
                        },
                        {
                            "uniqueName": "User",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10cxvyb05wgx00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Time(Day of Week)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10cxvyb05wgx00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Time(Days)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10cxvyb05wgx00"
                        },
                        {
                            "uniqueName": "Time(Month)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10cxvyb05wgx00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Time(Year)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10cxvyb05wgx00"
                        },
                        {
                            "uniqueName": "Time(Week)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10cxvyb05wgx00"
                        },
                        {
                            "uniqueName": "Time(Hour of Day)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10cxvyb05wgx00"
                        },
                        {
                            "uniqueName": "Time(HH:mm)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10cxvyb05wgx00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Time (Block of 15 minutes)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10cxvyb05wgx00"
                        },
                        {
                            "uniqueName": "Time(DD-MM-YYYY)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10cxvyb05wgx00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Time(YYYY-MM-DD)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10cxvyb05wgx00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Period",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10cxvyb05wgx00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Valid",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10cxvyb05wgx00"
                        },
                        {
                            "uniqueName": "IN",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10cxvyb05wgx00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "OUT",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10cxvyb05wgx00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "GROUP",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10cxvyb05wgx00"
                        }
                    ],
                    "flatOrder": [
                        "User",
                        "Action",
                        "Time(YYYY-MM-DD)",
                        "IN",
                        "OUT",
                        "Total",
                        "Valid"
                    ]
                },
                "options": {
                    "grid": {
                        "type": "flat",
                        "showTotals": "off"
                    },
                    "chart": {
                        "type": "bar",
                        "activeMeasure": {
                            "uniqueName": ""
                        }
                    },
                    "showEmptyData": false,
                    "viewType": "grid"
                },
                "formats": [
                    {
                        "name": "-4gcyc2gmnk500",
                        "decimalPlaces": -1
                    },
                    {
                        "name": "-10cxvyb05wgx00",
                        "decimalPlaces": -1
                    }
                ],
                "conditions": [
                    {
                        "formula": "#value = 1",
                        "measure": "Valid",
                        "format": {
                            "backgroundColor": "#8BC34A",
                            "color": "#FFFFFF",
                            "fontFamily": "Arial",
                            "fontSize": "12px"
                        }
                    },
                    {
                        "formula": "#value = 0",
                        "measure": "Valid",
                        "format": {
                            "backgroundColor": "#F44336",
                            "color": "#FFFFFF",
                            "fontFamily": "Arial",
                            "fontSize": "12px"
                        }
                    }
                ]
            }
        },
        {
            "name": "Clock In/Out (By Date)",
            "configuation": {
                "slice": {
                    "rows": [
                        {
                            "uniqueName": "User",
                            "sort": "asc"
                        },
                        {
                            "uniqueName": "Time(YYYY-MM-DD)",
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "IN",
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "OUT",
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Total",
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Valid",
                            "sort": "unsorted"
                        }
                    ],
                    "columns": [
                        {
                            "uniqueName": "Action",
                            "filter": {
                                "exclude": [
                                    "action.[in]",
                                    "action.[out]"
                                ]
                            },
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "[Measures]"
                        }
                    ],
                    "measures": [
                        {
                            "uniqueName": "Action",
                            "aggregation": "distinctcount",
                            "format": "-10cxvyb05wgx00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Device",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10cxvyb05wgx00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Device Name",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10cxvyb05wgx00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Time",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10cxvyb05wgx00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Time (Miliseconds)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10cxvyb05wgx00"
                        },
                        {
                            "uniqueName": "User",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10cxvyb05wgx00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Total",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10cxvyb05wgx00"
                        },
                        {
                            "uniqueName": "Time(Day of Week)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10cxvyb05wgx00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Time(Days)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10cxvyb05wgx00"
                        },
                        {
                            "uniqueName": "Time(Month)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10cxvyb05wgx00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Time(Year)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10cxvyb05wgx00"
                        },
                        {
                            "uniqueName": "Time(Week)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10cxvyb05wgx00"
                        },
                        {
                            "uniqueName": "Time(Hour of Day)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10cxvyb05wgx00"
                        },
                        {
                            "uniqueName": "Time(HH:mm)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10cxvyb05wgx00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Time (Block of 15 minutes)",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10cxvyb05wgx00"
                        },
                        {
                            "uniqueName": "Time(DD-MM-YYYY)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10cxvyb05wgx00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Time(YYYY-MM-DD)",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10cxvyb05wgx00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Period",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10cxvyb05wgx00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Valid",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10cxvyb05wgx00"
                        },
                        {
                            "uniqueName": "IN",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10cxvyb05wgx00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "OUT",
                            "aggregation": "count",
                            "active": false,
                            "format": "-10cxvyb05wgx00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "GROUP",
                            "aggregation": "sum",
                            "active": false,
                            "format": "-10cxvyb05wgx00"
                        }
                    ],
                    "flatOrder": [
                        "Time(YYYY-MM-DD)",
                        "Action",
                        "User",
                        "IN",
                        "OUT",
                        "Total",
                        "Valid"
                    ]
                },
                "options": {
                    "grid": {
                        "type": "flat",
                        "showTotals": "off",
                        "showGrandTotals": "off"
                    },
                    "chart": {
                        "type": "bar",
                        "activeMeasure": {
                            "uniqueName": ""
                        }
                    },
                    "showEmptyData": false,
                    "viewType": "grid"
                },
                "formats": [
                    {
                        "name": "-10cxvyb05wgx00",
                        "decimalPlaces": -1
                    }
                ],
                "conditions": [
                    {
                        "formula": "#value = 1",
                        "measure": "Valid",
                        "format": {
                            "backgroundColor": "#8BC34A",
                            "color": "#FFFFFF",
                            "fontFamily": "Arial",
                            "fontSize": "12px"
                        }
                    },
                    {
                        "formula": "#value = 0",
                        "measure": "Valid",
                        "format": {
                            "backgroundColor": "#F44336",
                            "color": "#FFFFFF",
                            "fontFamily": "Arial",
                            "fontSize": "12px"
                        }
                    }
                ]
            }
        }
    ],
    inventory: [
        {
            "name": "Inventory Report (Daily)",
            "configuation": {
                "slice": {
                    "reportFilters": [
                        {
                            "uniqueName": "Controller",
                            "sort": "unsorted",
                            "expands":true
                        },
                        {
                            "uniqueName": "Category",
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Supplier",
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Delete",
                            "sort": "unsorted"
                        }
                    ],
                    "rows": [
                        {
                            "uniqueName": "Item Name"
                        },
                        {
                            "uniqueName": "GROUP",
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Type",
                            "filter": { 
                                "exclude": [
                                    "Type.[Open Balance]",
                                    "Type.[Close Balance]",
                                    "Type.[Discrepancy]",
                                ]
                            },
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Type ID",
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Usage Date(YYYY-MM-DD HH:mm:ss)",
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "User",
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Comment",
                            "sort": "unsorted"
                        }
                    ],
                    "columns": [
                        {
                            "uniqueName": "[Measures]"
                        }
                    ],
                    "measures": [
                        {
                            "uniqueName": "Open",
                            "formula": "if( \"Status ID\"==-20000, sum(\"Total Unit Value\") , 0)",
                            "individual": true,
                            "caption": "Open",
                            "format": "-rtytuvopn4400"
                        },
                        {
                            "uniqueName": "IN",
                            "formula": "if( \"Status ID\"==100, sum(\"Total Unit Value\") , 0)",
                            "individual": true,
                            "caption": "IN",
                            "format": "-rtytuvopn4400"
                        },
                        {
                            "uniqueName": "OUT",
                            "formula": "if( (\"Status ID\") == 200, - sum(\"Total Unit Value\") , )",
                            "individual": true,
                            "caption": "OUT",
                            "format": "-rtytuvopn4400"
                        },
                        {
                            "uniqueName": "Stock Discrepancy",
                            "formula": "if( \"Status ID\"==1 OR \"Status ID\"==2 , sum(\"Total Unit Value\") , 0)",
                            "individual": true,
                            "caption": "Stock Discrepancy",
                            "format": "-rtytuvopn4400"
                        },
                        {
                            "uniqueName": "Close",
                            "formula": "if( \"Status ID\"==20000, sum(\"Total Unit Value\") , 0)",
                            "individual": true,
                            "caption": "Close",
                            "format": "-rtytuvopn4400"
                        },
                        {
                            "uniqueName": "Controller",
                            "aggregation": "count",
                            "grandTotalCaption": "Controller",
                            "active": false,
                            "format": "-rtytuvopn4400",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Status",
                            "aggregation": "count",
                            "grandTotalCaption": "Status",
                            "active": false,
                            "format": "-rtytuvopn4400",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Type",
                            "aggregation": "count",
                            "grandTotalCaption": "Type",
                            "active": false,
                            "format": "-rtytuvopn4400",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Total Unit Value",
                            "aggregation": "sum",
                            "grandTotalCaption": "Total Unit Value",
                            "active": false,
                            "format": "-rtytuvopn4400"
                        },
                        {
                            "uniqueName": "Reference NO.",
                            "aggregation": "count",
                            "grandTotalCaption": "Reference NO.",
                            "active": false,
                            "format": "-rtytuvopn4400",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Comment",
                            "aggregation": "count",
                            "grandTotalCaption": "Comment",
                            "active": false,
                            "format": "-rtytuvopn4400",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Item ID",
                            "aggregation": "sum",
                            "grandTotalCaption": "Item ID",
                            "active": false,
                            "format": "-rtytuvopn4400"
                        },
                        {
                            "uniqueName": "Modify",
                            "aggregation": "count",
                            "grandTotalCaption": "Modify",
                            "active": false,
                            "format": "-rtytuvopn4400",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Stock Actual",
                            "aggregation": "count",
                            "grandTotalCaption": "Stock Actual",
                            "active": false,
                            "format": "-rtytuvopn4400",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Device",
                            "aggregation": "count",
                            "grandTotalCaption": "Device",
                            "active": false,
                            "format": "-rtytuvopn4400",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Inventory Parent Name",
                            "aggregation": "count",
                            "grandTotalCaption": "Inventory Parent Name",
                            "active": false,
                            "format": "-rtytuvopn4400",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Order",
                            "aggregation": "count",
                            "grandTotalCaption": "Order",
                            "active": false,
                            "format": "-rtytuvopn4400",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "User",
                            "aggregation": "count",
                            "grandTotalCaption": "User",
                            "active": false,
                            "format": "-rtytuvopn4400",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Delete",
                            "aggregation": "sum",
                            "grandTotalCaption": "Delete",
                            "active": false,
                            "format": "-rtytuvopn4400"
                        },
                        {
                            "uniqueName": "Item Parent ID",
                            "aggregation": "count",
                            "grandTotalCaption": "Item Parent ID",
                            "active": false,
                            "format": "-rtytuvopn4400",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Total Prices",
                            "aggregation": "sum",
                            "grandTotalCaption": "Total Prices",
                            "active": false,
                            "format": "-rtytuvopn4400"
                        },
                        {
                            "uniqueName": "Stock Take Last Time",
                            "aggregation": "count",
                            "grandTotalCaption": "Stock Take Last Time",
                            "active": false,
                            "format": "-rtytuvopn4400",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Prices",
                            "aggregation": "sum",
                            "grandTotalCaption": "Prices",
                            "active": false,
                            "format": "-rtytuvopn4400"
                        },
                        {
                            "uniqueName": "Stock Take Last User",
                            "aggregation": "count",
                            "grandTotalCaption": "Stock Take Last User",
                            "active": false,
                            "format": "-rtytuvopn4400",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Total Cost Price",
                            "aggregation": "sum",
                            "grandTotalCaption": "Total Cost Price",
                            "active": false,
                            "format": "-rtytuvopn4400"
                        },
                        {
                            "uniqueName": "Inventory ID",
                            "aggregation": "sum",
                            "grandTotalCaption": "Inventory ID",
                            "active": false,
                            "format": "-rtytuvopn4400"
                        },
                        {
                            "uniqueName": "Type ID",
                            "aggregation": "sum",
                            "grandTotalCaption": "Type ID",
                            "active": false,
                            "format": "-rtytuvopn4400"
                        },
                        {
                            "uniqueName": "Status ID",
                            "aggregation": "sum",
                            "grandTotalCaption": "Status ID",
                            "active": false,
                            "format": "-rtytuvopn4400"
                        },
                        {
                            "uniqueName": "Unit Name",
                            "aggregation": "count",
                            "grandTotalCaption": "Unit Name",
                            "active": false,
                            "format": "-rtytuvopn4400",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Item Name",
                            "aggregation": "count",
                            "grandTotalCaption": "Item Name",
                            "active": false,
                            "format": "-rtytuvopn4400",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Display Name",
                            "aggregation": "count",
                            "grandTotalCaption": "Display Name",
                            "active": false,
                            "format": "-rtytuvopn4400",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Total Display Value",
                            "aggregation": "sum",
                            "grandTotalCaption": "Total Display Value",
                            "active": false,
                            "format": "-rtytuvopn4400"
                        },
                        {
                            "uniqueName": "Category",
                            "aggregation": "count",
                            "grandTotalCaption": "Category",
                            "active": false,
                            "format": "-rtytuvopn4400",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Supplier",
                            "aggregation": "count",
                            "grandTotalCaption": "Supplier",
                            "active": false,
                            "format": "-rtytuvopn4400",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Usage (Day of Week)",
                            "aggregation": "count",
                            "grandTotalCaption": "Usage (Day of Week)",
                            "active": false,
                            "format": "-rtytuvopn4400",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Usage Date(Days)",
                            "aggregation": "sum",
                            "grandTotalCaption": "Usage Date(Days)",
                            "active": false,
                            "format": "-rtytuvopn4400"
                        },
                        {
                            "uniqueName": "Usage Date(Month)",
                            "aggregation": "count",
                            "grandTotalCaption": "Usage Date(Month)",
                            "active": false,
                            "format": "-rtytuvopn4400",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Usage Date(Year)",
                            "aggregation": "sum",
                            "grandTotalCaption": "Usage Date(Year)",
                            "active": false,
                            "format": "-rtytuvopn4400"
                        },
                        {
                            "uniqueName": "Usage Date(Week)",
                            "aggregation": "sum",
                            "grandTotalCaption": "Usage Date(Week)",
                            "active": false,
                            "format": "-rtytuvopn4400"
                        },
                        {
                            "uniqueName": "Usage(Hour of Day)",
                            "aggregation": "sum",
                            "grandTotalCaption": "Usage(Hour of Day)",
                            "active": false,
                            "format": "-rtytuvopn4400"
                        },
                        {
                            "uniqueName": "Usage (Block of 15 minutes)",
                            "aggregation": "sum",
                            "grandTotalCaption": "Usage (Block of 15 minutes)",
                            "active": false,
                            "format": "-rtytuvopn4400"
                        },
                        {
                            "uniqueName": "Usage Date(DD-MM-YYYY)",
                            "aggregation": "count",
                            "grandTotalCaption": "Usage Date(DD-MM-YYYY)",
                            "active": false,
                            "format": "-rtytuvopn4400",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Usage Date(YYYY-MM-DD)",
                            "aggregation": "count",
                            "grandTotalCaption": "Usage Date(YYYY-MM-DD)",
                            "active": false,
                            "format": "-rtytuvopn4400",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Usage Date(YYYY-MM-DD HH:mm:ss)",
                            "aggregation": "count",
                            "grandTotalCaption": "Usage Date(YYYY-MM-DD HH:mm:ss)",
                            "active": false,
                            "format": "-rtytuvopn4400",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify Date(YYYY-MM-DD HH:mm:ss)",
                            "aggregation": "count",
                            "grandTotalCaption": "Modify Date(YYYY-MM-DD HH:mm:ss)",
                            "active": false,
                            "format": "-rtytuvopn4400",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Quarter",
                            "aggregation": "count",
                            "grandTotalCaption": "Quarter",
                            "active": false,
                            "format": "-rtytuvopn4400",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "MealTime",
                            "aggregation": "count",
                            "grandTotalCaption": "MealTime",
                            "active": false,
                            "format": "-rtytuvopn4400",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Period",
                            "aggregation": "count",
                            "grandTotalCaption": "Period",
                            "active": false,
                            "format": "-rtytuvopn4400",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "From",
                            "aggregation": "count",
                            "grandTotalCaption": "From",
                            "active": false,
                            "format": "-rtytuvopn4400",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Report Start Date (YYYY-MM-DD HH:mm:ss)",
                            "aggregation": "count",
                            "grandTotalCaption": "Report Start Date (YYYY-MM-DD HH:mm:ss)",
                            "active": false,
                            "format": "-rtytuvopn4400",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Report End Date (YYYY-MM-DD HH:mm:ss)",
                            "aggregation": "count",
                            "grandTotalCaption": "Report End Date (YYYY-MM-DD HH:mm:ss)",
                            "active": false,
                            "format": "-rtytuvopn4400",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "GROUP",
                            "aggregation": "count",
                            "grandTotalCaption": "GROUP",
                            "active": false,
                            "format": "-rtytuvopn4400",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Start Open",
                            "formula": "if( \"Status ID\"==-30000, sum(\"Total Unit Value\") , 0)",
                            "individual": true,
                            "caption": "Start Open",
                            "active": false,
                            "format": "-rtytuvopn4400"
                        },
                        {
                            "uniqueName": "End Close",
                            "formula": "if( \"Status ID\"==30000, sum(\"Total Unit Value\") , 0)",
                            "individual": true,
                            "caption": "End Close",
                            "active": false,
                            "format": "-rtytuvopn4400"
                        },
                        {
                            "uniqueName": "Unit Cost Price",
                            "formula": "sum(\"Total Display Value\")  / sum(\"Total Unit Value\")",
                            "caption": "Unit Cost Price",
                            "active": false,
                            "format": "-rtytuvopn4400"
                        },
                        {
                            "uniqueName": "Type S",
                            "formula": "\"Type ID\" \"Type\"",
                            "individual": true,
                            "caption": "Type S",
                            "active": false,
                            "format": "-rtytuvopn4400"
                        }
                    ],
                    "flatOrder": [
                        "Item Name",
                        "Report Start Date (YYYY-MM-DD HH:mm:ss)",
                        "Modify",
                        "Usage Date(DD-MM-YYYY HH:mm:ss)",
                        "Type",
                        "User",
                        "Status",
                        "Comment",
                        "Status ID",
                        "Type ID",
                        "Total Unit Value",
                        "Open",
                        "IN",
                        "OUT",
                        "Stock Discrepancy",
                        "Close"
                    ]
                },
                "options": {
                    "grid": {
                        "type": "classic",
                        "showTotals": "off",
                        "showGrandTotals": "rows"
                    },
                    "chart": {
                        "type": "bar",
                        "activeMeasure": {
                            "uniqueName": ""
                        }
                    },
                    "showEmptyData": false,
                    "viewType": "grid"
                },
                "formats": [
                    {
                        "name": "",
                        "thousandsSeparator": "",
                        "decimalPlaces": 0,
                        "nullValue": ""
                    },
                    {
                        "name": "-rtytuvopn4400",
                        "decimalPlaces": -1
                    }
                ]
            }
        },
        {
            "name": "Inventory Report (Period)",
            "configuation": {
                "slice": {
                    "reportFilters": [
                        {
                            "uniqueName": "Delete",
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Controller",
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Category",
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Supplier",
                            "sort": "unsorted"
                        }
                    ],
                    "rows": [
                        {
                            "uniqueName": "Item Name",
                        },
                        {
                            "uniqueName": "GROUP",
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Type",
                            "sort": "unsorted",
                            "filter": { 
                                "exclude": [
                                    "Type.[Open]",
                                    "Type.[Close]",
                                    "Type.[Discrepancy]",
                                ]
                            }
                        },
                        {
                            "uniqueName": "Type ID",
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Usage Date(YYYY-MM-DD HH:mm:ss)",
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "User",
                            "sort": "unsorted"
                        },
                        {
                            "uniqueName": "Comment",
                            "sort": "unsorted"
                        }
                    ],
                    "columns": [
                        {
                            "uniqueName": "[Measures]"
                        }
                    ],
                    "measures": [
                        {
                            "uniqueName": "Start Open",
                            "formula": "if( \"Status ID\"== -30000, sum(\"Total Unit Value\") , 0)",
                            "individual": true,
                            "caption": "Start Open",
                            "format": "-canrvgkjfgf00"
                        },
                        {
                            "uniqueName": "IN",
                            "formula": "if( (\"Status ID\") != -30000 and (\"Status ID\") != 30000 and (\"Status ID\") >= 100 and (\"Status ID\") < 200 , sum(\"Total Unit Value\") , 0)",
                            "individual": true,
                            "caption": "IN",
                            "format": "-canrvgkjfgf00"
                        },
                        {
                            "uniqueName": "OUT",
                            "formula": "if((\"Status ID\") != -30000 and (\"Status ID\") != 30000 and (\"Status ID\") >= 200 and sum(\"Status ID\") < 300, - sum(\"Total Unit Value\") , )",
                            "individual": true,
                            "caption": "OUT",
                            "format": "-canrvgkjfgf00"
                        },
                        {
                            "uniqueName": "Stock Discrepancy",
                            "formula": "if( \"Status ID\"==1 OR \"Status ID\"==2 , sum(\"Total Unit Value\") , 0)",
                            "individual": true,
                            "caption": "Stock Discrepancy",
                            "format": "-canrvgkjfgf00"
                        },
                        {
                            "uniqueName": "End Close",
                            "formula": "if( (\"Status ID\") == 30000, sum(\"Total Unit Value\") , 0)",
                            "individual": true,
                            "caption": "End Close",
                            "format": "-canrvgkjfgf00"
                        },
                        {
                            "uniqueName": "Controller",
                            "aggregation": "count",
                            "grandTotalCaption": "Controller",
                            "active": false,
                            "format": "-canrvgkjfgf00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Status",
                            "aggregation": "count",
                            "grandTotalCaption": "Status",
                            "active": false,
                            "format": "-canrvgkjfgf00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Type",
                            "aggregation": "count",
                            "grandTotalCaption": "Type",
                            "active": false,
                            "format": "-canrvgkjfgf00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Total Unit Value",
                            "aggregation": "sum",
                            "grandTotalCaption": "Total Unit Value",
                            "active": false,
                            "format": "-canrvgkjfgf00"
                        },
                        {
                            "uniqueName": "Reference NO.",
                            "aggregation": "count",
                            "grandTotalCaption": "Reference NO.",
                            "active": false,
                            "format": "-canrvgkjfgf00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Comment",
                            "aggregation": "count",
                            "grandTotalCaption": "Comment",
                            "active": false,
                            "format": "-canrvgkjfgf00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Item ID",
                            "aggregation": "sum",
                            "grandTotalCaption": "Item ID",
                            "active": false,
                            "format": "-canrvgkjfgf00"
                        },
                        {
                            "uniqueName": "Modify",
                            "aggregation": "count",
                            "grandTotalCaption": "Modify",
                            "active": false,
                            "format": "-canrvgkjfgf00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Stock Actual",
                            "aggregation": "count",
                            "grandTotalCaption": "Stock Actual",
                            "active": false,
                            "format": "-canrvgkjfgf00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Device",
                            "aggregation": "count",
                            "grandTotalCaption": "Device",
                            "active": false,
                            "format": "-canrvgkjfgf00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Inventory Parent Name",
                            "aggregation": "count",
                            "grandTotalCaption": "Inventory Parent Name",
                            "active": false,
                            "format": "-canrvgkjfgf00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Order",
                            "aggregation": "count",
                            "grandTotalCaption": "Order",
                            "active": false,
                            "format": "-canrvgkjfgf00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "User",
                            "aggregation": "count",
                            "grandTotalCaption": "User",
                            "active": false,
                            "format": "-canrvgkjfgf00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Delete",
                            "aggregation": "sum",
                            "grandTotalCaption": "Delete",
                            "active": false,
                            "format": "-canrvgkjfgf00"
                        },
                        {
                            "uniqueName": "Item Parent ID",
                            "aggregation": "count",
                            "grandTotalCaption": "Item Parent ID",
                            "active": false,
                            "format": "-canrvgkjfgf00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Total Prices",
                            "aggregation": "sum",
                            "grandTotalCaption": "Total Prices",
                            "active": false,
                            "format": "-canrvgkjfgf00"
                        },
                        {
                            "uniqueName": "Stock Take Last Time",
                            "aggregation": "count",
                            "grandTotalCaption": "Stock Take Last Time",
                            "active": false,
                            "format": "-canrvgkjfgf00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Prices",
                            "aggregation": "sum",
                            "grandTotalCaption": "Prices",
                            "active": false,
                            "format": "-canrvgkjfgf00"
                        },
                        {
                            "uniqueName": "Stock Take Last User",
                            "aggregation": "count",
                            "grandTotalCaption": "Stock Take Last User",
                            "active": false,
                            "format": "-canrvgkjfgf00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Total Cost Price",
                            "aggregation": "sum",
                            "grandTotalCaption": "Total Cost Price",
                            "active": false,
                            "format": "-canrvgkjfgf00"
                        },
                        {
                            "uniqueName": "Inventory ID",
                            "aggregation": "sum",
                            "grandTotalCaption": "Inventory ID",
                            "active": false,
                            "format": "-canrvgkjfgf00"
                        },
                        {
                            "uniqueName": "Type ID",
                            "aggregation": "sum",
                            "grandTotalCaption": "Type ID",
                            "active": false,
                            "format": "-canrvgkjfgf00"
                        },
                        {
                            "uniqueName": "Status ID",
                            "aggregation": "sum",
                            "grandTotalCaption": "Status ID",
                            "active": false,
                            "format": "-canrvgkjfgf00"
                        },
                        {
                            "uniqueName": "Unit Name",
                            "aggregation": "count",
                            "grandTotalCaption": "Unit Name",
                            "active": false,
                            "format": "-canrvgkjfgf00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Item Name",
                            "aggregation": "count",
                            "grandTotalCaption": "Item Name",
                            "active": false,
                            "format": "-canrvgkjfgf00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Display Name",
                            "aggregation": "count",
                            "grandTotalCaption": "Display Name",
                            "active": false,
                            "format": "-canrvgkjfgf00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Total Display Value",
                            "aggregation": "sum",
                            "grandTotalCaption": "Total Display Value",
                            "active": false,
                            "format": "-canrvgkjfgf00"
                        },
                        {
                            "uniqueName": "Category",
                            "aggregation": "count",
                            "grandTotalCaption": "Category",
                            "active": false,
                            "format": "-canrvgkjfgf00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Supplier",
                            "aggregation": "count",
                            "grandTotalCaption": "Supplier",
                            "active": false,
                            "format": "-canrvgkjfgf00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Usage (Day of Week)",
                            "aggregation": "count",
                            "grandTotalCaption": "Usage (Day of Week)",
                            "active": false,
                            "format": "-canrvgkjfgf00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Usage Date(Days)",
                            "aggregation": "sum",
                            "grandTotalCaption": "Usage Date(Days)",
                            "active": false,
                            "format": "-canrvgkjfgf00"
                        },
                        {
                            "uniqueName": "Usage Date(Month)",
                            "aggregation": "count",
                            "grandTotalCaption": "Usage Date(Month)",
                            "active": false,
                            "format": "-canrvgkjfgf00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Usage Date(Year)",
                            "aggregation": "sum",
                            "grandTotalCaption": "Usage Date(Year)",
                            "active": false,
                            "format": "-canrvgkjfgf00"
                        },
                        {
                            "uniqueName": "Usage Date(Week)",
                            "aggregation": "sum",
                            "grandTotalCaption": "Usage Date(Week)",
                            "active": false,
                            "format": "-canrvgkjfgf00"
                        },
                        {
                            "uniqueName": "Usage(Hour of Day)",
                            "aggregation": "sum",
                            "grandTotalCaption": "Usage(Hour of Day)",
                            "active": false,
                            "format": "-canrvgkjfgf00"
                        },
                        {
                            "uniqueName": "Usage (Block of 15 minutes)",
                            "aggregation": "sum",
                            "grandTotalCaption": "Usage (Block of 15 minutes)",
                            "active": false,
                            "format": "-canrvgkjfgf00"
                        },
                        {
                            "uniqueName": "Usage Date(DD-MM-YYYY)",
                            "aggregation": "count",
                            "grandTotalCaption": "Usage Date(DD-MM-YYYY)",
                            "active": false,
                            "format": "-canrvgkjfgf00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Usage Date(YYYY-MM-DD)",
                            "aggregation": "count",
                            "grandTotalCaption": "Usage Date(YYYY-MM-DD)",
                            "active": false,
                            "format": "-canrvgkjfgf00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Usage Date(YYYY-MM-DD HH:mm:ss)",
                            "aggregation": "count",
                            "grandTotalCaption": "Usage Date(YYYY-MM-DD HH:mm:ss)",
                            "active": false,
                            "format": "-canrvgkjfgf00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Modify Date(YYYY-MM-DD HH:mm:ss)",
                            "aggregation": "count",
                            "grandTotalCaption": "Modify Date(YYYY-MM-DD HH:mm:ss)",
                            "active": false,
                            "format": "-canrvgkjfgf00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Quarter",
                            "aggregation": "count",
                            "grandTotalCaption": "Quarter",
                            "active": false,
                            "format": "-canrvgkjfgf00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "MealTime",
                            "aggregation": "count",
                            "grandTotalCaption": "MealTime",
                            "active": false,
                            "format": "-canrvgkjfgf00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Period",
                            "aggregation": "count",
                            "grandTotalCaption": "Period",
                            "active": false,
                            "format": "-canrvgkjfgf00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "From",
                            "aggregation": "count",
                            "grandTotalCaption": "From",
                            "active": false,
                            "format": "-canrvgkjfgf00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Report Start Date (YYYY-MM-DD HH:mm:ss)",
                            "aggregation": "count",
                            "grandTotalCaption": "Report Start Date (YYYY-MM-DD HH:mm:ss)",
                            "active": false,
                            "format": "-canrvgkjfgf00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Report End Date (YYYY-MM-DD HH:mm:ss)",
                            "aggregation": "count",
                            "grandTotalCaption": "Report End Date (YYYY-MM-DD HH:mm:ss)",
                            "active": false,
                            "format": "-canrvgkjfgf00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "GROUP",
                            "aggregation": "count",
                            "grandTotalCaption": "GROUP",
                            "active": false,
                            "format": "-canrvgkjfgf00",
                            "availableAggregations": [
                                "count",
                                "distinctcount"
                            ]
                        },
                        {
                            "uniqueName": "Open",
                            "formula": "if( \"Status ID\"==-20000, sum(\"Total Unit Value\") , 0)",
                            "individual": true,
                            "caption": "Open",
                            "active": false,
                            "format": "-canrvgkjfgf00"
                        },
                        {
                            "uniqueName": "Close",
                            "formula": "if( \"Status ID\"==20000, sum(\"Total Unit Value\") , 0)",
                            "individual": true,
                            "caption": "Close",
                            "active": false,
                            "format": "-canrvgkjfgf00"
                        },
                        {
                            "uniqueName": "Unit Cost Price",
                            "formula": "sum(\"Total Display Value\")  / sum(\"Total Unit Value\")",
                            "caption": "Unit Cost Price",
                            "active": false,
                            "format": "-canrvgkjfgf00"
                        },
                        {
                            "uniqueName": "Type S",
                            "formula": "\"Type ID\" \"Type\"",
                            "individual": true,
                            "caption": "Type S",
                            "active": false,
                            "format": "-canrvgkjfgf00"
                        }
                    ],
                    "flatOrder": [
                        "Item Name",
                        "GROUP",
                        "Type",
                        "Type ID",
                        "Status",
                        "Status ID",
                        "Delete",
                        "Start Open",
                        "OUT",
                        "IN",
                        "Stock Discrepancy",
                        "End Close"
                    ]
                },
                "options": {
                    "grid": {
                        "type": "classic",
                        "showTotals": "columns",
                        "showGrandTotals": "off"
                    },
                    "chart": {
                        "activeMeasure": {
                            "uniqueName": ""
                        }
                    },
                    "showEmptyData": false,
                    "viewType": "grid"
                },
                "formats": [
                    {
                        "name": "",
                        "decimalPlaces": 0,
                        "nullValue": ""
                    },
                    {
                        "name": "-canrvgkjfgf00",
                        "decimalPlaces": -1,
                        "nullValue": "Empty"
                    }
                ],
                "conditions": [
                    {
                        "formula": "isNaN(#value)",
                        "measure": "Start Open",
                        "format": {
                            "backgroundColor": "#F44336",
                            "color": "#FFFFFF",
                            "fontFamily": "Arial",
                            "fontSize": "12px"
                        }
                    }
                ]
            }
        }
    ]
}

export default configs;